export default {
    service_price_modifiers: "Modificadores de Precio",
    service_cost_modifiers: "Modificadores de Costo",
    add_service_modifier: "Agregar Modificador",
    modifier_name: "Nombre del modificador",
    modifier_amount: "Monto",
    modifier_type: "Tipo",
    modifier_addition: "Adicional (+)",
    modifier_deduction: "Deducción (-)",
    no_modifiers_configured: "No hay modificadores configurados para este servicio",
    no_cost_modifiers_configured: "No hay modificadores de costo configurados para este servicio",
    applied_modifiers: "Modificadores",
    applied_modifiers_desc: "Activa o desactiva modificadores para ajustar el precio",
    modifiers_count: "modificadores",
    manage_price_modifiers: "Administrar Modificadores",
    manage_cost_modifiers: "Administrar Modificadores de Costo",
    delete_modifier_confirm: "¿Eliminar este modificador?",
    send_assignment_email: "Enviar asignaciones por email",
    send_email_to_business: "Enviar email a cliente",
    assigned_paxs_summary: "Tienes {{count}} pasajeros asignados para {{date}}",
    preview_message: "Vista previa del mensaje",
    active_reservations_in_date: "Reservas activas en {{date}}",
    menu_permissions: "Permisos de Menú",
    create_action_permissions: "Permisos de Creación",
    create_permissions: "Permisos de Creación",
    allowed_views: "Vistas Permitidas",
    allowed_create_actions: "Acciones de Creación Permitidas",
    allowed_businesses: "Clientes/Proveedores Permitidos",
    no_businesses_allowed: "Sin clientes/proveedores permitidos",
    full_access_desc: "Acceso total a todas las secciones, acciones y clientes/proveedores sin restricciones.",
    reservation_business_access: "Clientes para Reservas",
    reservation_business_access_desc: "Elija si este usuario puede crear reservas para cualquier cliente/proveedor o solo para cliente/proveedores seleccionadas específicas.",
    reservation_edit_access: "Edición de Reservas",
    edit_prices_and_costs_manually: "Editar Precios y Costos Manualmente",
    edit_prices_and_costs_manually_desc: "Permite modificar y restablecer los precios y costos de las reservas de forma manual.",
    no_manual_price_cost_access: "Sin edición manual de precios y costos",
    only_created_reservations: "Solo Creadas por el Usuario",
    edition_group_reservations: "Por Grupo de Edición",
    edition_group_reservations_desc: "El usuario puede editar reservas creadas por miembros del mismo grupo",
    edition_group: "Grupo de Edición",
    edition_groups: "Grupos de Edición",
    edition_group_desc: "Los usuarios que pertenezcan al mismo grupo podrán editar las reservas de los demás miembros.",
    create_edition_group: "Crear Grupo",
    edition_group_placeholder: "Nombre del grupo (ej. Ventas, Recepción)...",
    existing_edition_groups: "Grupos existentes",
    no_edition_group_selected: "Ningún grupo asignado. El usuario solo podrá editar sus propias reservas.",
    users_in_group: "Miembros del grupo",
    no_other_users_in_group: "No hay otros usuarios en este grupo todavía.",
    no_edition_groups_created: "No hay grupos creados todavía. Escribe un nombre para crear el primero.",
    current_edition_group: "Grupo actual asignado",
    clear_edition_group: "Quitar grupo",
    selected_businesses: "Solo Clientes/Proveedores Seleccionadas",
    select_allowed_businesses: "Seleccionar Cliente/Proveedores Permitidas",
    no_businesses_selected: "No hay cliente/proveedores seleccionadas. El usuario no podrá crear reservas para ninguna cliente/proveedor hasta que se agreguen cliente/proveedores.",
    unauthorized_business: "No está autorizado para crear reservas para esta cliente/proveedor",
    filter_both: "Todos",
    filter_departures: "Salidas",
    filter_arrivals: "Llegadas",
    permissions: "Permisos",
    search_users: "Buscar usuarios...",
    full_access: "Acceso Total",
    custom_access: "Acceso Personalizado",
    never: "Nunca",
    add_another_field: "Agregar {{key}}",
    duplicate_client_warning: "Advertencia de Cliente Duplicado",
    duplicate_client_name_desc: "Hay otros clientes con el nombre '{{name}}'. Por favor, verifique si este cliente es correcto.",
    duplicated_name: "Este nombre ya está registrado.",
    create_another: "Crear otro",
    derived_from_reservation: "Derivada de la Reserva",
    parent_reservation_bookings: "Reserva Original",
    original_reservation: "Reserva original",
    child_reservations: "Reservas derivadas",
    reservation_type: "Tipo de reserva",
    main_reservations_only: "Solo principales (sin padre)",
    child_reservations_only: "Solo derivadas (con padre)",
    contact_details: "Datos de Contacto",
    account_overview: "Vista General",
    banking_info: "Información Bancaria",
    quick_actions: "Accesos Rápidos",
    tax_information: "Información Fiscal",
    business_category: "Categoría de Cliente/Proveedor",
    account_status: "Estado de Cuenta",
    cbu_alias: "CBU / Alias",
    no_bookings_in_parent: "Sin servicios",
    select_client_for_child_reservation: "Seleccionar Cliente para Reserva Derivada",
    select_client_to_assign_to_new_reservation: "Selecciona el cliente a asignar a la nueva reserva derivada.",
    simulating_prices_for_selected_business: "Simulando precios personalizados para la cliente/proveedor seleccionada",
    select_business_to_view_custom_tariffs: "Selecciona una cliente/proveedor para aplicar sus descuentos de tarifa personalizados",
    budget: "Presupuesto",
    pinned_services: "Servicios Marcados",
    no_pinned_services: "No hay servicios marcados",
    click_to_pin: "Haz clic en cualquier tarjeta de servicio para fijarla en este presupuesto.",
    clear_all: "Limpiar todo",
    copy_summary: "Copiar Resumen",
    summary_copied: "¡Resumen copiado al portapapeles!",
    total: "Total",
    settings_saved_success: "Configuración guardada con éxito",
    enable_public_exchange_rates_title: "Habilitar Conversión de Moneda en la Web Pública",
    enable_public_exchange_rates_desc: "Permite a los clientes de la web pública convertir los precios a otras monedas usando estas tasas de cambio. Si está desactivado, solo se muestran los precios originales.",
    daily_evolution: "Evolución Diaria",
    paxs_evolution: "Evolución de Pasajeros",
    services_evolution: "Evolución de Servicios",
    money_evolution: "Evolución de Ingresos y Costos",
    same_origin_destination_warning: "El origen y el destino no pueden ser iguales.",
    complete_business_data: "Completar Datos de la Cliente/Proveedor",
    legend: "Leyenda",
    booking_pax_count_mismatch: "La pasajeros asignados ({{personsSum}}), no coincide con el tamaño del booking ({{categorySum}})",
    complete_business_data_description: "Por favor complete la información fiscal y de ubicación requerida para esta cliente/proveedor.",
    passenger_current_reservation: "Reserva Actual del Pasajero",
    group_all_bookings: 'Agrupar Bookings',
    loading_reservation: "Cargando reserva actual...",
    accept: 'Aceptar',
    slots: 'Cupos',
    occupied: 'ocupados',
    default_inventory_slots: 'Cupos por Defecto',
    default_inventory_slots_desc: 'Número de cupos que este servicio ocupa por defecto al ser reservado',
    access: 'Accesos',
    buy: 'Compra',
    buy_services: 'Comprar Servicios',
    select_vendor: 'Seleccionar Proveedor',
    select_client_business: 'Seleccionar Cliente/Proveedor Cliente',
    confirm_purchase: 'Confirmar Compra',
    purchase_successful: 'Compra Exitosa',
    error_during_purchase: 'Ocurrió un error durante la compra',
    no_services_available: 'No hay servicios disponibles de este proveedor',
    next: 'Siguiente',
    select_vendor_placeholder: 'Elige un socio para comprarle',
    select_client_placeholder: 'Selecciona tu cliente/proveedor compradora',
    search_services: 'Buscar servicios por nombre, categoría, ciudad...',
    estimated_price: 'Precio estimado',
    no_matching_services: 'Ningún servicio coincide con tu búsqueda.',
    confirm_review_details: 'Por favor, revisa los detalles de tu solicitud de reserva a continuación.',
    no_pricing_available: 'Detalles de precios no resueltos.',
    error: 'Error',
    invalid_dates: 'Por favor ingrese fechas válidas',
    no_additional_attributes: 'No se requieren campos adicionales.',
    no_paxs_selected: 'Ningún pasajero seleccionado',
    no_services_selected: 'Ningún servicio seleccionado',
    passenger: 'Pasajero',
    please_enter_pax_sizes: 'Por favor ingrese un tamaño de grupo para al menos un pasajero',
    please_select_all_fields: 'Por favor seleccione todos los campos',
    reservation_created_successfully: 'Reserva creada con éxito',
    step_confirm_price: 'Confirmar',
    step_from_who_whom: 'De / Para',
    step_paxs: 'Pasajeros',
    step_select_services: 'Servicios',
    step_title: 'Paso {{step}}',
    group_size: 'Tamaño del Grupo',
    enter_start_day: 'Ingrese fecha de inicio',
    account_settings: 'Ajustes de Cuenta',
    account_statement: 'Estado de Cuenta',
    balance_as_client_disclaimer: 'Este balance NO incluye las reservas como proveedor.',
    check_full_balance: 'Para ver el balance completo, consultá la sección de Balance',
    actions: 'Acciones',
    actions_here_cannot_be_undone: 'Los cambios hechos aqui no pueden ser deshechos',
    active: 'Activos',
    active_costs: 'Costos Activos',
    single_date: 'Fecha Unica',
    active_filters: 'Filtros Activos',
    advanced_filters: 'Filtros Avanzados',
    active_prices: 'Precios Activos',
    active_services: 'Servicios Activos',
    active_stock_periods: 'Periodos de Stock Activos',
    active_template: 'Plantilla Activa',
    active_today: 'Activo hoy',
    activities: 'Actividades',
    activities_list: {
        generic_action: 'Acción',
        new_service_cost: 'Nuevo costo',
        new_service_price: 'Nuevo precio',
        reservation_person_added: 'Persona agregada a la reserva',
        reservation_person_removed: 'Persona removida de la reserva',
        service_cost_created: 'Costo de servicio creado',
        service_cost_updated: 'Costo de servicio actualizado',
        service_price_created: 'Precio de servicio creado',
        service_price_updated: 'Precio de servicio actualizado'
    },
    activity: 'Actividad',
    activity_plural: 'Actividades',
    actual_payment: 'Pago Real',
    add: 'Agregar',
    add_attribute: 'Agregar Atributo',
    add_booking: 'Agregar Reserva de Servicio',
    add_bookings: 'Agregar Bookings',
    add_business: 'Agregar Cliente/Proveedor',
    add_child_cost: 'Agregar Costo Menor',
    add_child_item: 'Agregar Item Debajo',
    add_child_price: 'Agregar Precio Menor',
    add_child_service: 'Agregar servicio al paquete',
    add_cost: 'Agregar Costo',
    add_discount: 'Agregar Descuento',
    add_discount_category: 'Agregar Categoría de Descuento',
    add_exchange_rate: 'Agregar Tasa de Cambio',
    add_foreigner_cost: 'Agregar Costo Extranjero',
    add_foreigner_price: 'Agregar Precio Extranjero',
    add_infant_cost: 'Agregar Costo Infantil',
    add_infant_price: 'Agregar Precio Infantil',
    add_money_in_out: 'Ingreso/Egreso',
    add_more_items: 'Agregar más items',
    add_new_attribute: 'Agregar Nuevo Atributo',
    add_new_my_business: 'Agregar Nueva Cliente/Proveedor Propia',
    add_new_payment: 'Agregar Nuevo Pago',
    add_new_provider: 'Agregar Proveedor',
    add_pax: 'Agregar Pax',
    add_pax_to_housing: 'Agregar Pax al Hospedaje',
    add_pax_to_reservation: 'Agregar Pax a la Reserva',
    add_pax_to_service: 'Agregar Pax al Servicio',
    add_pax_to_transfer: 'Agregar Pax al Traslado',
    add_payment: 'Agregar Pago',
    add_person: 'Agregar Persona',
    add_person_to_housing: 'Agregar Persona al Hospedaje',
    add_person_to_reservation: 'Agregar Persona a la Reserva',
    add_person_to_transfer: 'Agregar Persona al Traslado',
    add_persons_to_vehicle_booking: 'Agregar personas a la reserva de vehículo',
    add_price: 'Agregar Precio',
    add_prices: 'Agregar Precios',
    add_property: 'Agregar propiedad',
    add_provider: 'Agregar Proveedor',
    add_provider_cost: 'Agregar Costo de Proveedor',
    add_provider_price: 'Agregar Precio de Proveedor',
    add_providers: 'Agregar Proveedores',
    add_provier: 'Agregar Proveedor',
    add_reservation: 'Agregar Reserva',
    add_reservation_payment: 'Agregar Pago de Reserva',
    add_reservation_status: 'Agregar Estado de Reserva',
    add_reservations: 'Agregar Reservas',
    add_senior_cost: 'Agregar Costo Jubilado',
    add_senior_price: 'Agregar Precio Jubilado',
    add_service: 'Agregar Servicio',
    add_service_directly: 'Agregar Servicio Directamente',
    add_service_first_first: 'Agregar Servicios Primero',
    add_service_to_group: 'Agregar Servicio al Paquete',
    add_service_to_this_order: 'Agregar Servicio Seleccionado a esta Orden',
    add_services: 'Agregar Servicios',
    add_services_to_group: 'Agregar Servicios al Paquete',
    add_staff: 'Agregar Staff',
    add_status: 'Agregar Estado',
    add_stock_period: 'Agregar Periodo de Stock',
    add_tag: 'Agregar Etiqueta',
    add_template: 'Agregar Plantilla',
    add_time_slot: 'Agregar Horario',
    add_to_reservation: 'Agregar a la reserva',
    add_transaction: 'Agregar Transacción',
    add_user: 'Agregar Usuario',
    add_vehicle: 'Agregar Vehículo',
    additional_details: 'Detalles Adicionales',
    additional_notes: 'Notas Adicionales',
    address: 'Calle y Número',
    address_and_phone: 'Dirección y Telefono',
    admin: 'Admin',

    adults: 'Adultos',
    affect_reservations: 'Afectar Reservas',
    after_tomorrow: 'Pasado Mañana',
    age: 'Edad',
    agency: 'Agencia',
    agenda: 'Agenda',
    agenda_orders: 'Agenda de Ordenes',
    agenda_description: 'Gestioná los vencimientos de pago de reservas pendientes y próximas obligaciones',
    agenda_overdue_alert: 'pagos de reservas vencidos que requieren atención inmediata',
    agenda_view_calendar: 'Calendario',
    agenda_view_list: 'Lista',
    agenda_view_timeline: 'Línea de Tiempo',
    agenda_no_dues: 'No se encontraron vencimientos de reservas pendientes',
    agenda_total_owed: 'Total Adeudado',
    agenda_dues_count: 'Vencimientos Pendientes',
    agenda_day_dues_title: 'Vencimientos de Pago para el {{date}}',
    agenda_overdue_badge: 'Vencido',
    agenda_days_overdue: '{{count}}d vencido',
    agenda_due_in_days: 'Vence en {{count}}d',
    agenda_due_today: 'Vence hoy',
    agenda_view_reservation: 'Ver Reserva',
    agenda_copy_link: 'Copiar Enlace',
    agenda_all_dues: 'Todos los Vencimientos',
    agenda_overdue_only: 'Solo Vencidos',
    agenda_upcoming_only: 'Solo Próximos',
    agenda_category_unpaid_reservations: 'Reservas impagas con fecha de vencimiento',
    agenda_category_tickets: 'Tickets pendientes con fecha límite',
    agenda_filter_all: 'Todos',
    agenda_filter_reservations: 'Reservas',
    agenda_filter_tickets: 'Tickets',
    agenda_sort_date: 'Fecha',
    agenda_sort_category: 'Categoría',
    agenda_sort_assignee: 'Responsable',
    agenda_group_overdue: 'Vencidos',
    agenda_group_today: 'Vencen Hoy',
    agenda_group_upcoming: 'Próximos',
    agenda_group_no_date: 'Sin Fecha Límite',
    agenda_no_items: 'No se encontraron elementos en la agenda',
    agenda_reservation_label: 'Reserva',
    agenda_ticket_label: 'Ticket',
    agenda_day_items_title: 'Agenda para el {{date}}',
    agenda_show_completed: 'Mostrar completados',
    agenda_due_payment: 'Pago de reserva',
    agenda_view_single_list: 'Lista única',
    agenda_view_by_category: 'Por categoría',
    agenda_all_categories: 'Todas las categorías',
    assignments: 'Asignaciones',
    my_assignments: 'Mis Asignaciones',
    as_provider: 'Como Proveedor',
    as_coordinator: 'Como Coordinador',
    origin_address: 'Dirección de Origen',
    destination_address: 'Dirección de Destino',
    flight_number: 'Número de Vuelo',
    flight_departure_time: 'Hora Salida Vuelo',
    flight_arrival_time: 'Hora Llegada Vuelo',
    flight_departure_location: 'Origen del Vuelo',
    flight_arrival_location: 'Destino del Vuelo',
    custom_attributes: 'Detalles del Servicio',
    pickup: 'Punto de Encuentro / Hotel',
    reservation_assignments: 'Asignaciones de Reservas',
    service_order_assignments: 'Asignaciones de Órdenes de Servicio',
    no_reservation_assignments: 'Sin asignaciones de reservas',
    no_service_order_assignments: 'Sin asignaciones de órdenes de servicio',
    no_assignments_yet_desc: 'Cuando otras agencias reserven servicios de tus cliente/proveedores, aparecerán aquí.',
    no_results_for_search: 'Intente ajustar su consulta de búsqueda',
    shared_booking: 'Reserva compartida',
    shared: 'Compartido',
    no_provider: 'Sin proveedores',
    assigned_by: 'Asignado Por',
    'ai-chat': 'Asistente IA',
    'ai-chat-placeholder': 'Escribe tu mensaje...',
    ai_chat: 'Chat IA',
    ai_chat_placeholder: 'Escribe tu mensaje',
    ai_chat_thinking: 'pensando...',
    air: 'Aéreo',
    all_businesses: 'Todas las Cliente/Proveedores',
    all_categories: 'Todas las categorías',
    all_dates: 'Con y Sin Fecha',
    all_days: 'Todos los días',
    all_items: 'Todos los Items',
    all_my_business: 'Todas Empresas',
    all_paxs: 'Todos los pasajeros',
    all_persons: 'Todas las Personas',
    all_plural: 'Todos',
    all_providers: 'Todos los Proveedores',
    all_rights_reserved: 'Todos los derechos reservados',
    all_service_bookings: 'Todas las Reservas de Servicio',
    all_services: 'Todos los Servicios',
    all_types: 'Todos los tipos',
    alls: 'Todos',
    almost_there: 'Casi listo',
    also_update_linked_service: 'También actualizar servicio espejo',
    book_linked_service: 'Reservar también servicio espejo: {{name}}',
    book_linked_service_question: '¿Reservar también este servicio espejo?',
    normally_booked_together: 'Normalmente se reservan juntos',
    amenities: 'Comodidades',
    amount: 'Monto',
    amount_paid_from: 'Pagado por',
    amount_paid_to: 'Pagado a',
    amount_to_pay: 'Monto a Pagar',
    amounts_match: 'Los montos coinciden',
    apartment: 'Apartamento',
    api_logs: {
        business_created: 'Nuevo negocio',
        business_deleted: 'Eliminar negocio',
        business_updated: 'Actualizar negocio',
        inventory_item_created: 'Nuevo ítem de inventario',
        inventory_item_deleted: 'Eliminar ítem de inventario',
        inventory_item_updated: 'Actualizar ítem de inventario',
        new_user_created: 'Nuevo usuario',
        person_created: 'Nueva persona',
        person_deleted: 'Eliminar persona',
        person_updated: 'Actualizar persona',
        provider_created: 'Nuevo proveedor',
        provider_deleted: 'Eliminar proveedor',
        provider_updated: 'Actualizar proveedor',
        reservation_created: 'Nueva reserva',
        reservation_deleted: 'Eliminar reserva',
        reservation_person_added: 'Agregar persona a la reserva',
        reservation_person_removed: 'Remover persona de la reserva',
        reservation_updated: 'Actualizar reserva',
        service_booking_created: 'Nuevo booking de servicio',
        service_booking_deleted: 'Eliminar booking de servicio',
        service_booking_updated: 'Actualizar booking de servicio',
        service_cost_created: 'Nuevo costo de servicio',
        service_cost_deleted: 'Eliminar costo de servicio',
        service_cost_updated: 'Actualizar costo de servicio',
        service_created: 'Nuevo servicio',
        service_deleted: 'Eliminar servicio',
        service_group_created: 'Nuevo grupo de servicios',
        service_group_deleted: 'Eliminar grupo de servicios',
        service_group_discount_updated: 'Actualizar paquete de servicios',
        service_group_updated: 'Actualizar grupo de servicios',
        service_order_created: 'Nueva orden de servicio',
        service_order_deleted: 'Eliminar orden de servicio',
        service_order_updated: 'Actualizar orden de servicio',
        service_price_created: 'Nuevo precio de servicio',
        service_price_deleted: 'Eliminar precio de servicio',
        service_price_updated: 'Actualizar precio de servicio',
        service_updated: 'Actualizar servicio',
        tenant_business_created: 'Nuevo Tenant Business',
        tenant_business_deleted: 'Eliminar Tenant Business',
        tenant_business_updated: 'Actualizar Tenant Business',
        user_deleted: 'Eliminar usuario',
        user_updated: 'Actualizar usuario'
    },
    apply: 'Aplicar',
    apply_changes: 'Aplicar Cambios',
    apply_exchange: 'Aplicar Cambio',
    archived: 'Archivada',
    are_you_sure_delete_transaction: '¿Estás seguro de eliminar la transacción?',
    arrival: 'Arribo',
    arrive: 'Arribo',
    assign: 'Asignar',
    assign_bookings: 'Asignar Ordenes de Servicio',
    assign_inventory: 'Asignar Inventario',
    assign_service: 'Asignar Servicio',
    assign_services: 'Asignar Servicios',
    assign_to_order: 'Asignar a Orden',
    unassign_to_order: 'Desvincular de Orden',
    assigned_inventory: 'Inventario Asignado',
    assigned_services: 'Servicios con Asignar',
    assigned_to_me: 'Asignados a mí',
    assigned_vehicles: 'Vehículos Asignados',
    assignee: 'Asignado',
    assistant: 'Ayudante',
    assistant_plural: 'Ayudantes',
    assistants: 'Ayudantes',
    attachments: 'Adjuntos',
    attachments_urls: 'URLs de Adjuntos',
    download_attachment: 'Descargar adjunto',
    view_attachment: 'Ver adjunto',
    failed_to_download_attachment: 'Error al descargar el archivo adjunto',
    attribute_key: 'Clave',
    attribute_name: 'Nombre del Atributo',
    attribute_value: 'Valor',
    attributes: 'Atributos',
    availability: 'Disponibilidad',
    available: 'Disponible',
    available_inventory: 'Inventario Disponible',
    available_places: 'lugares disponibles',
    no_places_available: 'sin lugares disponibles',
    available_service_orders: 'Ordenes de Servicio Disponibles',
    available_variables: 'Variables disponibles',
    background_color: 'Color de Fondo',
    background_image_url: 'URL Imagen Fondo',
    balance: 'Balance',
    bank_transfer: 'Transferencia Bancaria',
    banking_data: 'Datos Bancarios',
    bank_name: 'Banco / Entidad Financiera',
    bank_account_holder: 'Titular de la Cuenta',
    bank_account_number: 'Nro. de Cuenta',
    bank_account_type: 'Tipo de Cuenta',
    bank_account_type_checking: 'Cuenta Corriente',
    bank_account_type_savings: 'Caja de Ahorro',
    bank_cbu_iban: 'CBU / CVU / IBAN / CLABE',
    bank_alias: 'Alias CBU/CVU',
    bank_tax_id: 'CUIT / CUIL / CPF / Tax ID',
    bank_swift_code: 'Código SWIFT / BIC',
    bank_notes: 'Notas o Instrucciones Bancarias',
    base_price_zero: 'El precio base es cero',
    basic_info: 'Información Básica',
    basic_information: 'Información Básica',
    bath: 'Baño',
    bath_private: 'Baño Privado',
    bath_shared: 'Baño Compartido',
    baths: 'Baños',
    baths_number: 'Nro. de Baños',
    baths_type: 'Tipo de Baños',
    bedroom: 'Dormitorio',
    bedrooms: 'Dormitorios',
    bedrooms_number: 'Dormitorios',
    beds: 'Camas',
    beds_number: 'Camas',
    beds_type: 'Tipo de Camas',
    bike: 'Bicicleta',
    bike_rental: 'Alquiler de Bicicleta',
    bike_rental_plural: 'Alquileres de Bicicleta',
    block: 'Bloquear',
    boat: 'Barco',
    boat_rental: 'Alquiler de Barco',
    boat_rental_plural: 'Alquileres de Barco',
    both: 'Ambos',
    book_service: 'Reservar Servicio',
    booked_services: 'Servicios Asignados',
    booking_attributes: 'Atributos de la Reserva',
    booking_attributes_subtitle: 'Datos ingresados manualmente',
    booking_attrs: 'Atributos de Reserva',
    booking_created: 'Reserva Creada',
    booking_date: 'Fecha de Reserva',
    booking_details: 'Detalles de la Reserva',
    booking_limits: 'Límites de Venta',
    booking_successfully_created: 'Reserva creada exitosamente',
    group_size_exceeds_capacity: 'El tamaño del grupo supera la capacidad',
    capacity_warning_text: 'El servicio seleccionado tiene un límite de capacidad de {{capacity}} pasajeros por reserva. Dado que el tamaño total del grupo es {{total}}, se dividirá en {{count}} reservas individuales de un máximo de {{capacity}} pasajeros cada una. ¿Desea continuar?',
    all_bookings_successfully_created: '¡Todas las reservas se han creado exitosamente!',
    booking: 'Booking',
    bookings: 'Bookings',
    bookings_and_reservations: 'Bookings',
    bookings_calendar: 'Agenda de Servicios',
    bookings_client_provider: 'Bookings (Cliente/Proveedor)',
    bookings_inventory_allocation: 'Asignación de Inventario',
    bookings_limits_available: 'Límites de Reservas Disponibles',
    bookings_per_reservation: 'Bookings - Reservas',
    bookings_per_service: 'Bookings - Servicio',
    bookings_search: 'Búsqueda de Bookings',
    bookings_selected: 'Bookings Seleccionados',
    bookings_timeline: 'Timeline de Bookings',
    bookings_without_assign: 'Servicios sin Asignar',
    bought: 'Compras',
    bought_by_this_client: 'Comprado por el cliente',
    branding: 'Marca',
    brands: 'Marcas',
    breakfast_type: 'Tipo de Desayuno',
    bulk_edit: 'Edición Masiva',
    bulk_edit_businesses: 'Edición Masiva de Cliente/Proveedores',
    bulk_edit_services: 'Edición Masiva de Servicios',
    bulk_email_tariff_warning: 'Estás a punto de enviar una actualización de tarifas a {{count}} cliente/proveedores. ¿Deseas continuar?',
    bulk_price: 'Cambiar Precios (Factor)',
    business: 'Cliente/Proveedor',
    no_tenant_business_error: 'No hay ninguna empresa configurada para realizar transacciones. Por favor crea o configura una empresa en tu cuenta.',
    business_attributes: 'Atributos de la Cliente/Proveedor',
    business_balance: 'Balance de Cliente/Proveedor',
    business_center: 'Centro de Negocios',
    business_name: 'Nombre del Cliente/Proveedor',
    business_tags: 'Categorías de Cliente/Proveedor',
    business_tariffs: 'Tarifario de la Cliente/Proveedor',
    business_type: 'Tipo de cliente/proveedor',
    business_types: {
        activities: 'Actividades y Experiencias',
        agency: 'Agencia de Viajes',
        hotel: 'Hotel',
        lodging: 'Hospedaje',
        other: 'Otro',
        restaurant: 'Restaurante',
        tour_operator: 'Operador Turístico',
        transportation: 'Transporte'
    },
    businesses: 'Clientes/Proveedores',
    businesses_catalog: 'Catalogo de Cliente/Proveedores',
    businesses_description: 'Gestiona tus cliente/proveedores',
    by: 'por',
    cabin: 'Cabaña',
    cabins: 'Cabañas',
    calendar: 'Calendario',
    calendar_inventory_items: 'Calendario de Inventario',
    campaign: 'Campaña',
    campaign_send_error: 'Ocurrió un error al enviar la campaña. Por favor intente nuevamente.',
    campaign_sent_description: 'Su campaña ha sido encolada y los correos se enviarán a los destinatarios seleccionados.',
    campaign_sent_successfully: 'Campaña enviada con éxito',
    campaigns: 'Campañas',
    cancel: 'Cancelar',
    cancelled: 'Cancelada',
    cant_edit_booking: 'No se puede editar la reserva',
    cant_edit_booking_has_inventory_locks: 'La reserva tiene locks de inventario, no se puede editar, debe primero eliminar los locks de inventario',
    capacity: 'Capacidad',
    capacity_and_ranking: 'Capacidad y Orden',
    capacity_max: 'Capacidad Máxima',
    capacity_min: 'Capacidad Mínima',
    car: 'Auto',
    car_rental: 'Alquiler de Auto',
    car_rental_plural: 'Alquileres de Auto',
    car_rentals: 'Alquiler de Vehículos',
    carrier: 'Transporte',
    cash: 'Efectivo',
    catalog: 'Catálogo',
    category: 'Categoría',
    category_name: 'Nombre de la Categoría',
    change_linked_service: 'Cambiar Servicio Espejo',
    change_password: 'Cambiar Contraseña',
    change_password_description: 'Actualiza la contraseña de tu cuenta',
    check_availability: 'Verificar Disponibilidad',
    check_in: 'Check-In',
    check_in_hour: 'Hora de Check-in',
    check_in_out: 'Check-In / Check-Out',
    check_out: 'Check-Out',
    check_out_hour: 'Hora de Check-out',
    check_times: 'Horarios de Check-In y Check-Out',
    checkbox: 'Check',
    checking: 'Verificando',
    checking_availability: 'Verificando Disponibilidad',

    child_services: 'Paquete de servicios',
    child_services_description: 'Sub-servicios que componen este paquete',
    children: 'Menores',
    choose_duration: 'Elegir duración y paxs',
    cities: 'Ciudades',
    city: 'Ciudad',
    city_description: 'Ciudad donde se ofrece el servicio',
    clear: 'Limpiar',
    clear_dates: 'Borrar fechas',
    clear_filters: 'Limpiar Filtros',
    filter_by_passenger: 'Filtrar por pasajero',
    clear_selection: 'Limpiar selección',
    click_to_edit_cost: 'Haz clic para editar el costo',
    click_to_edit_price: 'Haz clic para editar el precio',
    client: 'Cliente',
    assign_client: 'Asignar Cliente',
    client_balance: 'Balance de Cliente',
    client_bookings: 'Reservas de Servicio de',
    client_category_discount: 'Descuento de Categoría de Cliente',
    client_cost: 'Costo del Cliente',
    client_cost_discount: 'Desc. de Costo de Cliente',
    client_cost_paid: 'Costo Pagado del Cliente',
    client_discount: 'Descuento de Cliente',
    client_history: 'Historial',
    client_income_received: 'Ingresos Recibidos del Cliente',
    client_observations: 'Observaciones para el Cliente',
    client_reservations: 'Reservas como Cliente',
    client_settlement: 'Liquidación',
    client_type: 'Tipo de Cliente',
    client_unpaid_sells: 'Ventas por cobrar del Cliente',
    clients: 'Clientes',
    clients_balance: 'Balance de Clientes',
    close: 'Cerrar',
    copied: 'Copiado',
    admin_link: 'Enlace de Administración',
    public_link: 'Enlace Público (Para Clientes)',
    collapse: 'Colapsar',
    collapse_all: 'Colapsar todos',
    color: 'Color',
    comma_separated: 'Separado por comas',
    commercial_settings: 'Configuración Comercial',
    commercial_settings_desc: 'Gestiona la moneda predeterminada, categorías de descuento y datos bancarios para transacciones.',
    company_information: 'Información de la Cliente/Proveedor',
    company_name: 'Nombre de la cliente/proveedor',
    company_name_or_name: 'Nombre de la cliente/proveedor o tuyo',
    composition_mismatch_warning: 'La composición de paxs no coincide con el grupo original.',
    complete_before_continue: 'Completar antes de continuar',
    complete_data: 'Datos Completos',
    completed: 'Completada',
    concert: 'Concierto',
    concert_plural: 'Conciertos',
    confirm: 'Confirmar',
    confirm_create_order: '¿Confirmar creación de orden de servicio?',
    confirm_delete: '¿Estás seguro de que quieres eliminar este elemento?',
    confirm_delete_service_order: '¿Estás seguro de que deseas eliminar esta orden de servicio?',
    confirm_delete_business: '¿Estás seguro de que quieres eliminar este negocio?',
    delete_business_warning: 'Eliminar permanentemente este negocio y todas sus configuraciones.',
    confirm_password: 'Confirmar Contraseña',
    confirmed: 'Confirmada',
    consumed: 'Consumido',
    contact: 'Contacto',
    contact_information: 'Información de Contacto',
    contact_me: 'Quiero más información',
    continue: 'Continuar',
    cooking: 'Cocina',
    cooking_class: 'Clase de Cocina',
    cooking_class_plural: 'Clases de Cocina',
    cooking_plural: 'Cocinas',
    coordinator: 'Coordinador',
    coordinator_plural: 'Coordinadores',
    coordinators: 'Coordinadores',
    cost: 'Costo',
    cost_amount: 'Monto de Costo',
    cost_breakdown: 'Detalle de Costos',
    cost_by: 'Costo Por:',
    cost_by_description: 'Como se calculará el costo final',
    cost_by_hour: 'costo por Hora',
    cost_discount_default: 'Descuento de Costo',
    cost_saved_successfully: 'Costo guardado exitosamente',
    cost_summary: 'Resumen de Costos',
    costs: 'Costos',
    countries: {
        AE: 'Emiratos Árabes Unidos',
        AR: 'Argentina',
        AT: 'Austria',
        AU: 'Australia',
        BE: 'Bélgica',
        BG: 'Bulgaria',
        BO: 'Bolivia',
        BR: 'Brasil',
        BY: 'Bielorrusia',
        CA: 'Canadá',
        CH: 'Suiza',
        CL: 'Chile',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CY: 'Chipre',
        CZ: 'República Checa',
        DE: 'Alemania',
        DK: 'Dinamarca',
        DO: 'República Dominicana',
        DZ: 'Argelia',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egipto',
        ES: 'España',
        ET: 'Etiopía',
        FI: 'Finlandia',
        FR: 'Francia',
        GB: 'Reino Unido',
        GH: 'Ghana',
        GR: 'Grecia',
        GT: 'Guatemala',
        HN: 'Honduras',
        HR: 'Croacia',
        HU: 'Hungría',
        ID: 'Indonesia',
        IE: 'Irlanda',
        IL: 'Israel',
        IN: 'India',
        IS: 'Islandia',
        IT: 'Italia',
        JP: 'Japón',
        KE: 'Kenia',
        KR: 'Corea del Sur',
        LT: 'Lituania',
        LV: 'Letonia',
        LY: 'Libia',
        MA: 'Marruecos',
        MT: 'Malta',
        MX: 'México',
        MY: 'Malasia',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Países Bajos',
        NO: 'Noruega',
        NZ: 'Nueva Zelanda',
        PA: 'Panamá',
        PE: 'Perú',
        PH: 'Filipinas',
        PL: 'Polonia',
        PR: 'Puerto Rico',
        PT: 'Portugal',
        PY: 'Paraguay',
        RO: 'Rumania',
        RS: 'Serbia',
        RU: 'Rusia',
        SA: 'Arabia Saudita',
        SE: 'Suecia',
        SG: 'Singapur',
        SI: 'Eslovenia',
        SK: 'Eslovaquia',
        SV: 'El Salvador',
        TH: 'Tailandia',
        TN: 'Túnez',
        TR: 'Turquía',
        TZ: 'Tanzania',
        UA: 'Ucrania',
        UK: 'Reino Unido',
        US: 'Estados Unidos',
        UY: 'Uruguay',
        VE: 'Venezuela',
        VN: 'Vietnam',
        ZA: 'Sudáfrica'
    },
    country: 'País',
    country_code: 'Código de País',
    cover_image: 'Imagen de Portada',
    create: 'Crear',
    create_account: 'Crear Cuenta',
    create_action_menu: 'Nuevo',
    create_another_campaign: 'Crear otra campaña',
    create_business: 'Crear cliente/proveedor',
    create_inventory_item: 'Crear Item de Inventario',
    create_item_under_this_one: 'Crear Item Debajo',
    create_multiple: 'Crear Múltiples',
    create_new_business: 'Crear nuevo Cliente/Proveedor',
    create_new_order: 'Crear nueva orden',
    create_new_pax: 'Crear nuevo pax',
    create_select_new_pax: 'Crear o seleccionar Pax',
    create_select_new_business: 'Crear o seleccionar Cliente/Proveedor',
    select_category: 'Seleccionar categoría',
    search_permissions: 'Buscar permisos...',
    all_permissions_enabled: 'Todos los permisos habilitados',
    no_permissions_enabled: 'Sin permisos habilitados',
    manage_permissions: 'Gestionar permisos',
    edit_user: 'Editar Usuario',
    confirm_delete_user: '¿Estás seguro de que deseas eliminar este usuario?',
    user_updated_successfully: 'Usuario actualizado con éxito',
    user_deleted_successfully: 'Usuario eliminado con éxito',
    email_required: 'El correo electrónico es requerido',
    tenant: 'Tenant',
    you: 'Tú',
    total_users: 'Total de Usuarios',
    no_users_found: 'No se encontraron usuarios',
    no_users_found_desc: 'Intenta ajustar tu búsqueda o crea un nuevo usuario.',
    permission_overview: 'Resumen de Permisos',
    all_businesses_desc: 'Acceso a todas las empresas en el sistema',
    selected_businesses_desc: 'Acceso restringido solo a las empresas especificadas',
    all_reservations_desc: 'El usuario puede editar todas las reservas',
    only_created_reservations_desc: 'El usuario solo puede editar reservas creadas por él mismo',
    unknown_error: 'Ocurrió un error desconocido',
    never_logged_in: 'Nunca inició sesión',
    all_menu_permissions: 'Todos los Permisos de Menú',
    all_create_permissions: 'Todos los Permisos de Creación',
    back_to_users: 'Volver a Usuarios',
    new_password: 'Nueva Contraseña',
    leave_blank_password_help: 'Ingresa una nueva contraseña para restablecerla, o déjala en blanco para mantener la actual.',
    save_changes: 'Guardar Cambios',
    user_not_found: 'Usuario no encontrado',
    user_details: 'Detalles del Usuario',
    account_details: 'Detalles de la Cuenta',
    business_and_scope_access: 'Alcance y Acceso a Empresas',
    create_new_payment: 'Crear Nuevo Pago',
    existing_pax_matches: 'Pasajeros existentes',
    no_matching_pax_found: 'No se encontraron pasajeros coincidentes',
    select_existing_pax: 'Seleccionar',
    create_new_person: 'Crear nueva persona',
    create_new_reservations: 'Crear nueva reserva',
    create_new_service: 'Crear nuevo servicio',
    create_new_service_order: 'Crear nueva orden de servicio',
    create_new_vehicle: 'Crear nuevo vehículo',
    create_order: 'Crear Orden',
    create_pax: 'Crear Pax',
    create_payment: 'Crear Pago',
    create_reservation: 'Crear reserva',
    create_service: 'Crear servicio',
    create_service_bookings: 'Crear Ordenes',
    create_service_order: 'Crear Orden de Servicio',
    create_staff: 'Crear Staff',
    create_subscription: 'Crear Suscripción',
    create_template: 'Crear Template',
    create_ticket: 'Crear Ticket',
    create_user: 'Agregar Usuario',
    create_vehicle: 'Crear vehículo',
    created: 'Creado',
    created_at: 'Creado el',
    created_by: 'Creado por',
    created_by_me: 'Creados por mí',
    creating_booking: 'Creando Reserva',
    creator: 'Creador',
    credit_card: 'Tarjeta crédito',
    debit_card: 'Tarjeta débito',
    debit_credit_card: 'Tarjeta',
    cruise: 'Crucero',
    currencies: {
        ARS: 'Peso Argentino',
        BRL: 'Real Brasileño',
        CLP: 'Peso Chileno',
        COP: 'Peso Colombiano',
        EUR: 'Euro',
        GBP: 'Libra Esterlina',
        MXN: 'Peso Mexicano',
        PEN: 'Sol Perú',
        USD: 'Dólar Estados Unidos',
        UYU: 'Peso Uruguayo',
        VEF: 'Bolívar Venezolano'
    },
    currency: 'Moneda',
    currency_exchange: 'Cambio de Moneda',
    'current-password-incorrect': 'La contraseña actual es incorrecta',
    'current-password-required': 'Se requiere la contraseña actual',
    current_password: 'Contraseña Actual',
    current_providers: 'Proveedores Actuales',
    custom_properties: 'Propiedades personalizadas',
    cycle: 'Ciclo',
    cycle_monthly: 'Mensual',
    cycle_yearly: 'Anual',
    daily: 'Diario',
    daily_cost: 'Costo Diario',
    daily_limit: 'Limite de Reservas por día',
    dance_class: 'Clase de Baile',
    dance_class_plural: 'Clases de Baile',
    danger_zone: 'Zona de Peligro',
    dashboard: 'Panel de Control',
    data: 'Datos',
    date: 'Fecha',
    date_and_time_for_service: 'Fecha y hora del servicio',
    date_of: 'Fecha de',
    date_optional_time: 'Fecha (hora opcional)',
    date_range: 'Rango de Fechas',
    dated: 'Con Fecha',
    dates: 'Fechas',
    day: 'Día',
    day_of_month: 'Día {{day}}',
    days: 'Días',
    days_arr: [
        'Todos los dias',
        'Lunes',
        'Martes',
        'Miercoles',
        'Jueves',
        'Viernes',
        'Sabado',
        'Domingo',
        'Fin de Semana',
        'Lunes a Viernes'
    ],
    days_in: 'días en',
    days_of_week: {
        friday: 'Viernes',
        monday: 'Lunes',
        saturday: 'Sábado',
        sunday: 'Domingo',
        thursday: 'Jueves',
        tuesday: 'Martes',
        wednesday: 'Miércoles'
    },
    days_of_week_short: {
        fri: 'Vie',
        mon: 'Lun',
        sat: 'Sáb',
        sun: 'Dom',
        thu: 'Jue',
        tue: 'Mar',
        wed: 'Mié'
    },
    days_range: {
        next_month: 'Próximo mes',
        next_week: 'Próxima semana',
        next_year: 'Próximo año',
        ten_days: '10 días',
        this_month: 'Este mes',
        this_week: 'Esta semana',
        today: 'Hoy',
        tomorrow: 'Mañana',
        yesterday: 'Ayer'
    },
    default_currency: 'Moneda Default',
    default_discounts: 'Descuentos por Defecto',
    default_discounts_description: 'Pueden ser modificados en el servicio',
    default_language: 'Idioma por Defecto',
    default_limit: 'Límite por Defecto',
    default_limit_description: 'Máximo de Pax por día',
    default_limit_helper: 'Capacidad base aplicada a todos los días del calendario a menos que se defina un valor específico individual.',
    default_value: 'Valor por Defecto',
    custom: 'Personalizado',
    custom_limit: 'Límite personalizado',
    restore_default: 'Restablecer valor por defecto',
    limit_update_success: 'Límite actualizado exitosamente',
    limit_update_error: 'Error al actualizar el límite',
    limits_are_based_on_price_by: 'Los límites diarios consumen capacidad según la configuración de escala.',
    booked: 'Reservados',
    available_short: 'disp.',
    booked_short: 'ocup.',
    limit_short: 'lím.',
    sold_out: 'Agotado',
    default_tariff_template: 'Template por defecto de tarifas',
    delete: 'Eliminar',
    delete_selected: 'Eliminar Seleccionados',
    delete_booking: 'Eliminar Reserva de Servicio',
    delete_booking_confirmation: '¿Estás seguro de que deseas eliminar esta reserva?',
    delete_dates: 'Eliminar Fechas',
    delete_reservation: 'Eliminar Reserva',
    delete_service: 'Eliminar Servicio',
    delete_service_group: 'Eliminar Paquete',
    delete_tag: 'Eliminar Etiqueta',
    delete_transaction: 'Esta acción no se puede deshacer',
    delete_user: 'Eliminar Usuario',
    departure: 'Salida',
    departure_time: 'Hora de Salida',
    description: 'Descripción',
    destination: 'Destino',
    destination_city: 'Ciudad de Destino',
    destination_zone: 'Zona de Destino',
    details: 'Detalles',
    direction: 'Dirección',
    discard: 'Cancelar',
    discount: 'Descuento',
    discount_categories: 'Categorías de Descuento',
    discount_categories_description: 'Valores por defecto, cada servicio modificará estos valores',
    discount_category: 'Categoría de Descuento',
    discount_category_desc: 'Asigna la categoría comercial aplicable a esta cliente/proveedor para el cálculo de tarifas y descuentos.',
    discount_distributed_error: 'Error al distribuir el descuento',
    discount_distributed_success: 'Descuento distribuido exitosamente',
    discounts: 'Descuentos',
    discounts_settings_desc: 'Define las categorías y reglas de descuento para tus servicios.',
    discover_experiences: 'Descubre Experiencias',
    display_name: 'Nombre para mostrar',
    distribute: 'Distribuir',
    distribute_passengers: 'Distribuir Pasajeros',
    do_you_want_to_apply_this_cost_to_linked_service: '¿Quieres aplicar este costo al servicio espejo?',
    do_you_want_to_apply_this_price_to_linked_service: '¿Quieres aplicar este precio al servicio espejo?',
    documentation: 'Documentación',
    done: 'Listo',
    done_create_another_campaign: 'Listo! Crear otra campaña.',
    dont_apply_client_discount: 'No aplicar descuento de cliente',
    double_bed: 'Cama Doble',
    double_beds: 'Camas Dobles',
    driver: 'Chofer',
    driver_information: 'Información del Conductor',
    driver_license: 'Carnet de Conducir',
    driver_plural: 'Choferes',
    drivers: 'Choferes',
    drivers_license: 'Carnet de Conducir',
    dropoff: 'Entrega',
    dropoff_location: 'Punto de Devolución',
    due_date: 'Fecha de Vencimiento',
    due_date_short: 'Vencimiento',
    due_day: 'Día de vencimiento',
    duplicate: 'Duplicar',
    update_service_data: 'Actualizar Servicio',
    duration: 'Duración',
    duration_and_paxs: 'Duración y Pasajeros',
    duration_distance: 'Duración y Distancia',
    edit: 'Editar',
    edit_attributes: 'Editar Atributos',
    edit_business: 'Editar Cliente/Proveedor',
    edit_business_tag: 'Editar Etiqueta de Cliente/Proveedor',
    edit_cost: 'Editar Costo',
    edit_inventory: 'Editar Inventario',
    edit_payment: 'Editar Pago',
    edit_price: 'Editar Precio',
    edit_prices: 'Editar Precios',
    edit_properties: 'Editar Propiedades',
    edit_reservation: 'Editar Reserva',
    edit_selected: 'Editar Seleccionados',
    edit_service: 'Editar Servicio',
    edit_service_booking: 'Editar Reserva de Servicio',
    edit_service_group: 'Editar Paquete de Servicios',
    edit_service_tag: 'Editar Etiqueta de Servicio',
    edit_subscription: 'Editar Suscripción',
    edit_tag: 'Editar Etiqueta',
    edit_tariffs: 'Editar Tarifario',
    edit_template: 'Editar Plantilla',
    edit_ticket: 'Editar Ticket',
    edit_vehicle: 'Editar Vehículo',
    editing: 'Editando',
    editor: 'Editor',
    effective_date: 'Fecha de Validez',
    email: 'Correo',
    'email-and-password-required': 'El correo electrónico y la contraseña son requeridos',
    'email-required': 'El correo electrónico es requerido',
    email_campaigns: 'Campañas de Correo',
    email_history: 'Historial de Correos',
    email_send_error: 'Error al enviar el mail',
    email_sent: 'Mail enviado exitosamente',
    email_subject: 'Asunto del mail',
    email_subject_placeholder: 'Asunto de la conversación',
    email_template: 'Template de correo',
    email_templates: 'Plantillas de Correo',
    emails: 'Emails',
    emails_sent_successfully: 'Correos enviados exitosamente',
    enable_manual_price: 'Habilitar precio manual',
    end: 'Fin',
    end_date: 'Fecha de Fin',
    end_hour: 'Hora de Fin',
    end_time: 'Hora de fin',
    ends: 'Finaliza',
    ends_between: 'Finaliza Entre',
    ends_today: 'Ultimo Día',
    enter_attribute_key: 'Ingrese la clave del atributo',
    enter_attribute_value: 'Ingrese el valor del atributo',
    enter_city: 'Ingrese ciudad',
    enter_default_limit: 'Ingrese límite por defecto',
    enter_group_size: 'Ingresar Tamaño del Grupo',
    enter_additional_emails: 'Ingresar correos adicionales',
    enter_different_foreigner_cost: 'Ingrese el costo para extranjeros',
    enter_different_foreigner_price: 'Precio Diferente para Extranjeros',
    enter_different_provider_cost: 'Ingrese el costo para proveedores',
    enter_different_provider_price: 'Ingresar Precio Diferente para Proveedores',
    enter_emails: 'Ingresa correos',
    enter_emails_manually: 'Ingresa correos manualmente',
    enter_observations: 'Ingrese las observaciones',
    enter_payment: 'Registrar Pago',
    enter_search_criteria: 'Seleccione una fecha y número de huéspedes para ver los servicios disponibles',
    enter_status_name: 'Ingrese el nombre del estado',
    equal: 'Igual',
    erase: 'Borrar',
    error_creating_payment: 'Error al crear el pago',
    error_creating_service: 'Error al crear servicio',
    error_creating_reservation: 'Error al crear la reserva',
    error_creating_service_order: 'Error al crear la orden de servicio',
    error_deleting_payment: 'Error al eliminar el pago',
    error_loading_vehicle: 'Error al cargar detalles del vehículo',
    error_loading_vehicles: 'Error al cargar vehículos',
    error_sharing_reservation: 'Error al compartir la reserva',
    error_unsharing_reservation: 'Error al eliminar el acceso a la reserva',
    errors: {
        'duplicate-request': 'Solicitud duplicada, por favor espere.',
        'child-booking-pax-change-not-allowed': 'No se permite cambiar el número de pasajeros para los servicios incluidos',
        error_duplicating_booking: 'Ocurrió un error al duplicar la reserva.',
        error_updating_booking: 'Error al actualizar la reserva. Intente de nuevo más tarde.',
        'person-not-found': 'Persona no encontrada',
        'person-not-found-in-booking': 'Persona no encontrada en la reserva',
        'service-booking-daily-available-limit-exceeded': 'Ya tienes el máximo de pasajeros permitidos para este servicio en esta fecha',
        'service-booking-not-found': 'Reserva de servicio no encontrada',
        'service-not-found': 'Servicio no encontrado'
    },
    exchange: 'Cambiar',
    exchange_bookings_currency: 'Convertir a Unica Moneda',
    exchange_bookings_currency_description: 'De todos los servicios dentro de la reserva',
    exchange_currency: 'Moneda de Cambio',
    exchange_currency_description: 'Moneda en la que se recibió el pago',
    exchange_rate: 'Tasa de Cambio',
    exchange_rate_calculation: 'La tasa de cambio con la que se convierte la moneda recibida a la moneda de la reserva',
    exchange_rate_description: 'El pago se recibió en una moneda diferente a la de la reserva',
    exchange_rates: 'Tasas de Cambio',
    exchange_rates_description: 'Configura las tasas de cambio para tus servicios y reservas',
    exchange_rates_settings_desc: 'Administra las tasas de cambio y configuraciones de multi-moneda.',
    exclusive_client: 'Cliente Exclusivo',
    exclusive_rates: 'Precios Exclusivos',
    execution_status: 'Estatus de Ejecución',
    exit_time: 'Hora de Salida',
    expand_all: 'Expandir todos',
    expected_amount: 'Monto Esperado',
    experience: 'Experiencia',
    experience_plural: 'Experiencias',
    external_reference: 'Referencia Externa',
    extra_observations: 'Observaciones Extra',
    extra_title_info: 'Extra Info',
    facilities: 'Facilidades',
    factor: 'Factor',
    failed: 'Fallido',
    failed_to_fetch_dashboard_data: 'Error al cargar datos del panel',
    failed_to_load_reservation: 'Error al cargar la reserva',
    failed_to_send_emails: 'Error al enviar correos',
    favorite: 'Favorito',
    favorites: 'Favoritos',
    features: 'Características',
    ferry: 'Ferry',
    festival: 'Festival',
    festival_plural: 'Festivales',
    filter: 'Filtrar',
    filter_by: 'Filtrar por',
    filter_by_category: 'Filtrar por categoría',
    filter_by_date: 'Filtrar por fecha',
    filter_by_type: 'Filtrar por tipo',
    filter_inventory: 'Filtrar Inventario',
    filter_rooms: 'Filtrar Habitaciones',
    filter_services: 'Filtrar Servicios',
    filter_tours: 'Filtrar Excursiones',
    filter_transfers: 'Filtrar Traslados',
    filters: 'Filtros',
    final_price: 'Precio Final',
    finalizing_booking: 'Finalizando reserva',
    finances: 'Finanzas',
    financials: 'Finanzas',
    font_family: 'Fuente (Google Fonts)',
    for: 'para',
    for_all_providers: 'Para todos los proveedores',
    for_all_providers_leave_blank: 'Para todos los proveedores, dejar en blanco',
    for_businesses: 'de cliente/proveedores',
    for_services: 'de servicios',
    foreigner: 'Extranjero',
    foreigner_price: 'Precio para Extranjeros',
    from: 'Desde',
    from_currency: 'Moneda de Origen',
    fuel: 'Combustible',
    fulfillment: 'Ejecución y Composición',
    full: 'Total',
    full_duration: 'Reserva Completa',
    full_duration_uses_all_paxs_description: 'Selecciona entre toda la reserva completa o una fecha/paxs específicos.',
    future: 'Futuro',
    general: 'General',
    general_information: 'Informacion General',
    go_to_business: 'Ir a la Cliente/Proveedor',
    group_composition: 'Composición del Grupo',
    group_composition_description: 'La cantidad de adultos, menores y bebés que forman parte del grupo',
    link_passengers: 'Vincular Pasajeros',
    in_this_booking: 'Vinculados al servicio',
    in_the_reservation: 'Disponibles en la reserva',
    define_group_size_first: 'Define el tamaño del grupo en el Paso 1.',
    group_complete: '¡Todos los pasajeros vinculados!',
    missing_passengers_warning: 'Falta vincular {{count}} pasajero(s) para completar el grupo.',
    extra_passengers_warning: 'Hay {{count}} pasajero(s) de más vinculados respecto al tamaño del grupo.',
    link_passenger: 'Buscar y vincular pasajero...',
    group_a: 'Grupo A',
    group_a_name: 'Nombre del Grupo A',
    group_b: 'Grupo B',
    group_b_name: 'Nombre del Grupo B',
    group_names: 'Nombres de los Grupos',
    paxs_selected_unselected_tooltip: '{{selected}} asignados, {{unassigned}} sin asignar',

    guest: 'TC',
    guests: 'TCs',
    guests_label: 'Paxs No Facturados (TC)',
    guests_description: 'Coordinadores, Auxiliares, Invitados, etc',
    guide: 'Guia',
    guide_plural: 'Guias',
    guides: 'Guias',
    gym: 'Gimnasio',
    has_a_linked_service_same_price: 'Tiene un servicio conectado. ¿Quieres guardar el mismo precio en el servicio conectado?',
    has_access_to_provider_price: 'Acceso al Precio de Proveedores',
    has_exchange_rate: 'Tiene Tipo de Cambio',
    has_money: 'Tiene dinero a favor',
    helicopter: 'Helicóptero',
    helicopter_rental: 'Alquiler de Helicóptero',
    helicopter_rental_plural: 'Alquileres de Helicópteros',
    hero_image_url: 'URL Imagen Hero',
    hero_subtitle: 'Subtítulo Hero',
    hero_title: 'Título Hero',
    hide_assigned: 'Ocultar Asignados',
    hide_bookings: 'Ocultar Reservas',
    high: 'Alta',
    history: 'Historial',
    horizontal_axis_items: 'Tipo de Columnas',
    home: 'Home',
    home_type: 'Tipo',
    hostel: 'Hostel',
    hostel_room: 'Hostel Room',
    hotel: 'Hotel',
    hour: 'Hora',
    hourly: 'Por Hora',
    house: 'Casa',
    housing: 'Hospedaje',
    housings: 'Hospedajes',
    how_many: '¿Cuántos?',
    id: 'DNI',
    id_card: 'DNI',
    id_number: 'Documento',
    id_type: 'Tipo de Documento',
    identification: 'Documento',
    im_the_owner: 'Soy dueña/o',
    image_delete_error: 'Error al eliminar la imagen',
    image_deleted: 'Imagen eliminada exitosamente',
    image_upload_error: 'Error al subir la imagen',
    image_uploaded: 'Imagen subida exitosamente',
    images: 'Imagenes',
    in_progress: 'En Curso',
    in_use: 'En Uso',
    include_bookings_without_dates: 'Incluir Servicios sin Fechas',
    included_services: 'Servicios Incluidos',
    includes: 'Incluye',
    income: 'Ingresos',
    outcome: 'Egresos',
    incomes: 'Ingresos',
    incomplete: 'Incompleto',
    incomplete_data: 'Faltan Datos',
    indoor_adventure: 'Aventura Adentro',
    indoor_adventure_plural: 'Aventuras Adentro',

    infants: 'Infantes',
    info: 'Info',
    information: 'Información',
    insurance_expiry: 'Vencimiento del Seguro',
    interactive_view: 'Vista Interactiva',
    internal_use: 'Uso Interno',
    'invalid-credentials': 'Credenciales inválidas',
    inventory: 'Inventario',
    inventory_availability: 'Disponibilidad de Inventario',
    inventory_calendar: 'Calendario',
    inventory_item: 'Item de Inventario',
    inventory_lock: 'Lock de Inventario',
    inventory_locks: 'Locks de Inventario',
    inventory_status: 'Estado de Inventario',
    irreversible_action: 'Acción irreversible',
    issue: 'Problema',
    is_favorite: 'Es Favorito',
    is_refund: 'Reembolso',
    is_refund_description: 'Si el pago es un reembolso, se debe marcar esta opción',
    items: 'Items',
    itinerary: 'Itinerario',
    its_my_business_info: 'Esta cliente/proveedor será registrada como tuya propia.',
    jacuzzi: 'Jacuzzi',
    join_turizi: 'Únete a Turizi',
    kilometers: 'Kilómetros',
    lake: 'Lacustre',
    landing: 'Llegada',
    language: 'Idioma',
    language_class: 'Clase de Idioma',
    language_class_plural: 'Clases de Idioma',
    language_description: 'Selecciona el idioma para tu usuario',
    language_plural: 'Idiomas',
    language_settings_desc: 'Cambia el idioma predeterminado y las opciones regionales.',
    languages: {
        en: 'Inglés',
        es: 'Español',
        pt: 'Portugués'
    },
    last_edited_reservations: 'Últimas Reservas Editadas',
    last_edited_services: 'Últimos Servicios Editados',
    last_login: 'Último Login',
    last_maintenance: 'Último Mantenimiento',
    last_price: 'Último Precio',
    leave: 'Salida',
    leave_blank_to_keep_current_password: 'Dejar en blanco para mantener la contraseña actual',
    leave_empty_for_all_providers: 'Dejar en blanco para todos los proveedores',
    license_plate: 'Patente',
    limit: 'Límite',
    limits: 'Límites',
    link_business: 'Vincular Cliente/Proveedor',
    link_existing_payment: 'Vincular Pago Existente',
    link_payment: 'Vincular Pago',
    linked_service: 'Servicio Espejo',
    linked_service_description: 'Cambio de precios, descuentos y booking en reservas se sincronizarán con el servicio',
    linked_to_reservation: 'Vinculado a la reserva',
    liquidate_reservation: 'Liquidar Reserva',
    list: 'Lista',
    load_more: 'Cargar más',
    loading: 'Cargando...',
    loading_price: 'Calculando...',
    location: 'Ubicación',
    location_and_branding: 'Localización y Marca',
    locations: 'Ubicaciones',
    lodging: 'Alojamiento',
    lodging_type: 'Tipo de alojamiento',
    login: 'Iniciar Sesión',
    login_failed: 'Error al iniciar sesión. Por favor, inténtelo de nuevo.',
    login_description: 'Inicia sesión para continuar',
    login_popup_hint: "¡Inicia sesión para clientes y proveedores, consulta tus precios especiales y tu saldo aquí!",
    logistics: 'Logística',
    logo_url: 'URL del Logo',
    logout: 'Cerrar Sesión',
    logs: 'Logs',
    low: 'Baja',
    maintenance: 'En Mantenimiento',
    make_me_owner_of_this_business: 'Soy legalmente responsable de esta cliente/proveedor',
    make_model: 'Marca y Modelo',
    manage_reservation_finances: 'Gestionar finanzas de la reserva',
    manage_reservation_payments: 'Gestionar pagos de la reserva',
    managed_businesses: 'Cliente/Proveedores Gestionadas',
    managed_by_owner: 'Gestionada por su propietaria',
    managed_by_owner_description: 'Esta cliente/proveedor es gestionada por su propietaria. Read-Only.',
    manager: 'Gestor',
    management: 'Gestión',
    manifest: 'Manifesto',
    manual_emails: 'Correos Manuales',
    manual_entry: 'Manual',
    manual_price_reason_placeholder: 'Descuento especial, correcion de precio, etc...',
    mark_all_as_read: 'Marcar todo como leído',
    mark_as_read: 'Marcar como leído',
    market: 'Mercado',
    max_bookings: 'Máximo de Reservas',
    max_capacity: 'Capacidad Max',
    max_pax: 'Máximo de Pax',
    max_pax_per_booking: 'Maximo de pasajeros por reserva',
    max_pax_per_day: 'Máximo de Paxs por Día',
    max_paxs: 'Máximo de Paxs',
    max_per_day: 'Máx./Día',
    meal_plan: 'Regimen',
    meditation: 'Meditación',
    meditation_class: 'Clase de Meditación',
    meditation_class_plural: 'Clases de Meditación',
    meditation_plural: 'Meditaciones',
    medium: 'Media',
    member: 'Miembro',
    members: 'Miembros',
    menu: 'Menú',
    method: 'Método',
    metrics: 'Metricas',
    metrics_dashboard: 'Tablero de Métricas',
    total_money_in: 'Total de Ventas',
    selected_period: 'Período seleccionado',
    all_payments: 'Todos los pagos',
    total_money_out: 'Total de Costos',
    total_paid_in: 'Total Cobrado',
    total_paid_out: 'Total Pagado a Proveedores',
    sold_services: 'Servicios Vendidos',
    services_sold_by_bookings: 'Servicios por Reservas',
    services_sold_by_paxs: 'Servicios por Pasajeros',
    services_sold_by_money_in: 'Servicios por Ingresos',
    services_sold_by_money_out: 'Servicios por Costos',
    services_sold_by_margin: 'Servicios por Margen',
    margin: 'Margen',
    by_amount_bookings: 'Por Cantidad de Reservas',
    by_amount_money: 'Por Cantidad de Dinero',
    total_bookings_manual_prices: 'Bookings con Precios Manuales',
    client_as_pax: 'Cliente como Pasajero',
    client_as_pax_pct_desc: 'de reservas con cliente persona',
    percentage_manual_price_higher: 'Precio Manual Mayor al Original',
    percentage_manual_price_lower: 'Precio Manual Menor al Original',
    sales_by_client: 'Ventas por Cliente',
    group_sizes: 'Tamaños de Grupos',
    bookings_count: 'Cantidad de Reservas',
    reservations_count: 'Cantidad de Reservas',
    manual_price_label: 'Precio Manual',
    higher: 'Mayor',
    lower: 'Menor',
    net_balance: 'Saldo Neto',
    group: 'Grupo',
    group_size_1: '1 Pasajero',
    group_size_2: '2 Pasajeros',
    group_size_3_4: '3-4 Pasajeros',
    group_size_5_8: '5-8 Pasajeros',
    group_size_9_plus: '9+ Pasajeros',
    last_30_days: 'Últimos 30 Días',
    this_month: 'Este Mes',
    this_year: 'Este Año',
    all_time: 'Todo el Tiempo',
    manual_prices_breakdown: 'Desglose de Precios Manuales',
    pax_issues_spotter: 'Detector de Problemas de Pax',
    missing_lastname: 'Falta Nombre o Apellido',
    single_name_warning: 'Nombre único (no se detectó apellido)',
    no_lastname_found: 'No se encontraron pasajeros sin apellido.',
    total_lastname_issues: 'Pasajeros con nombre único',
    view_pax: 'Ver Pax',
    view_business: 'Ver Cliente/Proveedor',
    sailing: 'Navegación',
    adventure: 'Aventura',
    kayak: 'Kayak',
    rafting: 'Rafting',
    diving: 'Buceo',
    ferry_company: 'Ferries',
    clean_duplicates: 'Limpiar Duplicados',
    duplicate_paxs: 'Pasajeros Duplicados',
    total_duplicate_groups: 'Grupos Duplicados Encontrados',
    clean_all_duplicates: 'Limpiar Todos los Duplicados',
    no_duplicates_found: 'No se encontraron pasajeros duplicados.',
    auto_clean: 'Auto Limpiar',
    keep: 'Mantener',
    confirm_clean_all_duplicates: '¿Está seguro de que desea limpiar todos los duplicados? Esto mantendrá el registro más antiguo para cada nombre duplicado y eliminará el resto.',
    confirm_clean_group_duplicates: '¿Está seguro de que desea limpiar automáticamente los duplicados para este pasajero?',
    mileage: 'Kilometraje',
    min_max_pax: 'Min-Max Pax',
    min_max_pax_per_booking: 'Minimo y Maximo de Paxs por reserva',
    min_pax: 'Mínimo de Pax',
    no_min: 'Sin mínimo',
    no_max: 'Sin máximo',
    min_pax_per_booking: 'Minimo de pasajeros por reserva',
    min_paxs: 'Mínimo de Paxs',
    minutes: 'Minutos',
    money_business_owes: 'Deuda del Vendedor',
    money_in: 'Dinero Entrante',
    payment_from_client: "Pago de Cliente",
    payment_to_provider: "Pago a Proveedor",
    money_in_adult: 'Precio Adult.',
    money_in_child: 'Precio Menor',
    money_in_infant: 'Precio Infant.',
    money_in_senior: 'Precio Jubil.',
    money_in_total: 'Precio Total',
    money_movement: 'Movimiento de Dinero',
    money_movements: 'Movimientos de Dinero',
    money_out: 'Dinero Saliente',
    money_out_adult: 'Costo Adult.',
    money_out_child: 'Costo Menor',
    money_out_infant: 'Costo Infant.',
    money_out_senior: 'Costo Jubil.',
    money_out_total: 'Costo Total',
    money_owed_to_business: 'Adeudado al Vendedor',
    money_they_owe_us: 'Nos Deben',
    money_transaction_reasons: {
        correction: 'Ajuste',
        future_payment: 'Pago A Cuenta',
        other: 'Otro',
        payment: 'Pago',
        refund: 'Reembolso'
    },
    money_transactions: 'Transacciones',
    money_we_owe_them: 'Debemos',
    money_will_be_collected: 'El dinero será recaudado',
    money_will_be_refunded: 'El dinero será reembolsado',
    month: 'Mes',
    months: {
        april: 'Abril',
        august: 'Agosto',
        december: 'Diciembre',
        february: 'Febrero',
        january: 'Enero',
        july: 'Julio',
        june: 'Junio',
        march: 'Marzo',
        may: 'Mayo',
        november: 'Noviembre',
        october: 'Octubre',
        september: 'Septiembre'
    },
    months_short: {
        apr: 'Abr',
        aug: 'Ago',
        dec: 'Dic',
        feb: 'Feb',
        jan: 'Ene',
        jul: 'Jul',
        jun: 'Jun',
        mar: 'Mar',
        may: 'May',
        nov: 'Nov',
        oct: 'Oct',
        sep: 'Sep'
    },
    more: 'más',
    more_paxs: 'personas más',
    motel: 'Motel',
    movements: 'Movimientos',
    multiply_last_price_by_this_factor: 'Multiplicar el último precio por este factor',
    music: 'Música',
    music_class: 'Clase de Música',
    music_class_plural: 'Clases de Música',
    music_festival: 'Festival de Música',
    music_festival_plural: 'Festivales de Música',
    music_plural: 'Músicas',
    my_business_split_info_1: 'Separar las operaciones bajo distintas cliente/proveedores ayuda a mantener el balance y la contabilidad más organizadas.',
    my_business_split_info_2: 'Sin embargo, TODOS los servicios seguirán mostrándose unificados bajo la misma URL de su tienda online.',
    my_businesses: 'Mis Empresas',
    my_businesses_dashboard: {
        active_services: 'Servicios Activos',
        active_staff: '{{count}} personal activo',
        advisor_issues_count: 'El asesor encontró {{count}} problemas',
        ask_assistant: 'Consultar Asistente',
        business_profile: 'Perfil Comercial',
        business_website: 'Sitio Web',
        chart_pax: 'Pasajeros (PAX)',
        chart_reservations: 'Reservas',
        chart_service_bookings: 'Órdenes de Servicio',
        chart_transactions: 'Transacciones',
        copied: '¡Copiado!',
        copy_url: 'Copiar Sitio',
        days_ago: 'Hace {{count}}d',
        error: 'Error',
        get_started: 'Comenzar',
        healthy: 'Activo',
        hours_ago: 'Hace {{count}}h',
        last_activity: 'Última Actividad',
        minutes_ago: 'Hace {{count}}m',
        no_activity: 'Sin actividad reciente',
        no_businesses_found: 'No se encontraron cliente/proveedores',
        no_businesses_found_desc: 'Crea tu primera cliente/proveedor en la sección de administración para ver métricas, itinerarios y finanzas en tiempo real.',
        no_website: 'Sin sitio web configurado',
        operational_activity: 'Actividad Operativa (Últimos 7 días)',
        pending_payments: 'Pagos Pendientes',
        phone_missing: 'Teléfono faltante',
        select_business: 'Seleccionar Cliente/Proveedor',
        staff_members: 'Personal Activo',
        todays_bookings: 'Reservas de Hoy',
        warning: 'Advertencia',
        weekly_reservations: 'Reservas de la Semana'
    },
    my_companies: 'Mis Cliente/Proveedores',
    name: 'Nombre',
    name_list_placeholder: 'Ingresa un nombre por línea...',
    nationality: 'Nacionalidad',
    net_amount: 'Monto Neto',
    net_price: 'Precio Neto',
    'new-password-required': 'Se requiere la nueva contraseña',
    new_account: 'Nueva Cuenta',
    new_business: 'Nuevo Cliente/Proveedor',
    new_campaign: 'Nueva Campaña',
    new_chat: 'Nuevo Chat',
    new_cost: 'Nuevo Costo',
    new_housing: 'Nuevo Hospedaje',
    new_inventory_item: 'Nuevo Item de Inventario',
    new_money_transaction: 'Nueva Transacción',
    new_order: 'Nueva Orden',
    new_pax: 'Nuevo Pax',
    new_person: 'Nueva Persona',
    new_price: 'Nuevo Precio',
    new_register_money_transaction: 'Nueva Transacción',
    new_reservation: 'Nueva Reserva',
    new_reservation_payment: 'Nuevo Pago de Reserva',
    new_sell_price: 'Nuevo Precio de Venta',
    new_service: 'Nuevo Servicio',
    new_service_group: 'Nuevo Paquete de Servicios',
    new_service_order: 'Nueva Orden de Servicio',
    new_staff: 'Nuevo Staff',
    new_stock_period: 'Nuevo Periodo de Stock',
    new_tab: 'Nueva Pestaña',
    new_ticket: 'Nuevo Ticket',
    new_vehicle: 'Nuevo Vehículo',
    newsletter: {
        disclaimer: 'Al registrarte, aceptas recibir actualizaciones sobre Turizi',
        getStarted: 'Comenzar',
        gotIt: 'Entendido',
        joinTitle: 'Quiero mantenerme informado',
        maybeLater: 'Tal vez más tarde',
        subscribeError: 'Error al suscribirse. Por favor, inténtalo de nuevo.',
        subscribeSuccess: '¡Suscripción exitosa!',
        subtitle: 'Te contactaremos en menos de 24 horas',
        successMessage: 'Te mantendremos informado con nuestras últimas novedades.',
        title: 'Newsletter',
        welcome: '¡Bienvenido a Turizi!'
    },
    next_10_days: 'Próximos 10 días',
    next_14_days: 'Próximos 14 días',
    next_7_days: 'Próximos 7 días',
    next_maintenance: 'Próximo Mantenimiento',
    next_month: 'Próximo mes',
    night: 'Noche',
    night_and_pax_pricing: 'Noche y Persona',
    nights: 'Noches',
    nights_pricing: 'Noche',
    no: 'No',
    'no-password-set': 'No se ha establecido una contraseña para esta cuenta. Por favor usa el enlace de acceso.',
    no_availability: 'Sin Disponibilidad',
    no_bookings_found: 'No se encontraron bookings',
    no_categories_found: 'No se encontraron categorías',
    no_change: 'Sin cambio',
    no_changes_to_apply: 'No hay cambios para aplicar',
    no_contact: 'Sin contacto',
    no_cost: 'Sin Costo',
    no_data: 'Sin datos',
    no_date: 'Sin fecha',
    no_hour: 'Sin hora',
    no_discount: 'Sin Descuento',
    no_due_date: 'Sin fecha límite',
    no_email_configured: 'Sin correo configurado',
    no_emails_available: 'No hay correos disponibles para este cliente',
    no_exchange_rate_found: 'No se encontró tasa de cambio en la base de datos.',
    no_inventory_selected: 'Sin inventario seleccionado',
    no_limit: 'Sin límite',
    no_linked_service: 'Sin Servicio Espejo',
    no_names: 'Sin nombres',
    no_columns_selected: 'Sin columnas seleccionadas',
    select_columns_instruction: 'Elija un tipo de columna y seleccione uno o más ítems arriba para visualizar las reservas en la matriz.',
    no_locks_for_this_day: 'No hay locks para este día',
    no_notifications: 'Sin notificaciones',
    no_only_this_service: 'No, solo este servicio',
    no_operational_services: 'No hay servicios operativos asignados',
    no_payments_found: 'No se encontraron pagos',
    no_payments_found_for_this_client: 'No se encontraron pagos para este cliente',
    no_pending_tickets: 'No hay tickets pendientes',
    no_price: 'Sin Precio',
    no_price_resolved: 'Precio no resuelto',
    no_provider_selected: 'Proveedor no asignado',
    no_providers: 'Sin proveedores',
    no_providers_assigned: 'Sin proveedor asignado',
    no_reservations: 'Sin reservas',
    no_reservation_associated_with_booking: 'No hay reserva asociada con la reserva',
    no_results: 'No se encontraron resultados',
    no_service_orders: 'Sin Órdenes de Servicio',
    no_services: 'Sin servicios',
    no_services_scheduled: 'Sin servicios programados',
    no_statuses_defined: 'No hay estados de reserva definidos',
    no_template_selected: 'Ninguna plantilla seleccionada',
    no_unpaid_reservations_found: 'No se encontraron reservas no pagadas',
    merge_business: 'Combinar Negocio',
    merge_with_another_business: 'Combinar con otro negocio',
    merge_business_description: 'Transfiere todas las reservas, pagos, servicios y transacciones del negocio seleccionado a este y luego elimina permanentemente el negocio seleccionado.',
    select_business_to_merge: 'Seleccionar negocio a combinar',
    select_source_business_to_delete: 'Seleccionar cliente/proveedor a combinar y ELIMINAR',
    business_to_be_deleted: 'Cliente/Proveedor que será ELIMINADA y destruida',
    business_to_be_kept: 'Cliente/Proveedor destinataria (Se conserva)',
    merge_and_delete_warning: 'ADVERTENCIA CRÍTICA: Se transferirán todos los datos a la cliente/proveedor destinataria. ¡La cliente/proveedor seleccionada SERÁ ELIMINADA PERMANENTEMENTE!',
    merge_and_delete_action: 'Combinar y Eliminar Cliente/Proveedor',
    confirm_merge_business: '¿Estás seguro de que deseas combinar este negocio? Esta acción no se puede deshacer.',
    business_merged_successfully: 'Negocio combinado exitosamente',
    error_merging_business: 'Error al combinar el negocio',
    cannot_merge_business_into_itself: 'No se puede combinar un negocio consigo mismo',
    no_upcoming_reservations: 'No hay reservas próximas',
    no_upcoming_service_orders: 'No hay órdenes de servicio próximas',
    no_users_shared_with: 'No hay usuarios con acceso compartido',
    no_vehicle_selected: 'Sin vehículo asignado',
    no_vehicle_type: 'Sin tipo de vehículo',
    no_vehicles_assigned: 'Sin vehículos asignados',
    no_vehicles_found: 'No se encontraron vehículos',
    no_vehicles_scheduled_today: 'No hay vehículos programados para hoy',
    none: 'Ninguno',
    not_assigned: 'Sin Asignar',
    not_available: 'No disponible',
    not_specified: 'No especificado',
    notes: 'Notas',
    notification_settings: 'Configuración de Notificaciones',
    notifications_settings: 'Configuración de Notificaciones',
    notifications_settings_desc: 'Configurar preferencias de notificación y receptores',
    emails_settings: 'Configuración de Emails',
    emails_settings_desc: 'Configura los emails de la organización y las direcciones remitentes autorizadas.',
    primary_email_label: 'Email Principal de la Organización',
    primary_email_desc: 'Dirección de contacto predeterminada de la organización.',
    sender_emails_settings: 'Emails Remitentes',
    sender_emails_settings_desc: 'Configura los emails autorizados para enviar resúmenes de cuenta, tarifas y reservas.',
    sender_emails_label: 'Emails de Envío Autorizados',
    sender_emails_help_text: 'Escribe una dirección de correo y presiona Enter para agregarla a tu lista de remitentes autorizados. Puedes guardar tantas direcciones como necesites.',
    authorized_emails_count: 'Direcciones Remitentes Autorizadas ({{count}})',
    primary: 'Principal',
    sender_email_placeholder: 'ejemplo@empresa.com',
    select_sender_email: 'Enviar desde email',
    payment_request_receivers_label: 'Receptores de Solicitud de Pago',
    payment_request_receivers_desc: 'Seleccione qué usuarios deben recibir notificaciones cuando se solicite un pago a sus cliente/proveedores.',
    pending_payment_request: 'Esta es una solicitud de pago pendiente.',
    payment_reminder: "Recordatorio de Pago",
    mark_as_paid: 'Marcar como Pagado',
    cancel_request: 'Cancelar Solicitud',
    notifications: {
        reservation_deleted: {
            content: '{{deleter_name}} ha eliminado la reserva #{{reservation_id}}.',
            title: 'Reserva Eliminada'
        },
        reservation_payment_overdue: {
            content: 'La reserva #{{reservation_id}} se encuentra impaga. Monto: ${{amount}}{{currency}}. Venció el {{due_date}}',
            title: 'Reserva - Pago Vencido'
        },
        payment_overdue: {
            content: 'El pago #{{payment_id}} está vencido. Monto: ${{amount}}{{currency}}. Venció el {{due_date}}',
            title: 'Pago Vencido'
        },
        payment_request: {
            content: '{{from_business_name}} ha solicitado un pago de {{amount}} {{currency}}.',
            title: 'Solicitud de Pago Recibida'
        },
        ticket_assigned: {
            content: '{{ticket_title}}',
            title: 'Nuevo Ticket Asignado'
        },
        ticket_updated: {
            content: '{{updater_name}} ha actualizado el ticket: {{ticket_title}}',
            title: 'Ticket Actualizado'
        },
        ticket_commented: {
            content: 'Nuevo comentario de {{commenter_name}} en el ticket: {{ticket_title}}',
            title: 'Nuevo Comentario en el Ticket'
        },
        ticket_overdue: {
            content: 'El ticket "{{ticket_title}}" está vencido',
            title: 'Ticket Vencido'
        },
        booking_pax_count_mismatch: {
            content: 'La reserva #{{reservation_id}} tiene una Diferencia entre la cantidad de pasajeros y la lista de asignados.',
            title: 'Diferencia de Pasajeros'
        },
        flight_status_changed: {
            content: 'El estado del vuelo {{flight_number}} ha cambiado a "{{new_status}}".',
            title: 'Estado de Vuelo Actualizado'
        }
    },
    tracking_active: 'Seguimiento Activo',
    tracked_flight_id: 'ID de Vuelo Registrado',
    tracked_flights: 'Vuelos Rastreados',
    today_flights: 'Vuelos de Hoy',
    future_flights: 'Vuelos Próximos',
    today_and_upcoming_flights: 'Vuelos de Hoy y Próximos',
    past_flights: 'Vuelos Pasados',
    OUT: 'OUT',
    IN: 'IN',
    tracked_flights_description: 'Monitoreo automático en tiempo real del estado de los vuelos',
    search_tracked_flights_placeholder: 'Buscar por nro de vuelo, código de origen/destino o estado...',
    no_tracked_flights_found: 'No se encontraron vuelos rastreados',
    no_tracked_flights_help: 'Los vuelos asignados a reservas de servicios aparecerán automáticamente aquí para su seguimiento.',
    associated_reservations: 'Reservas asociadas',
    mark_section_as_read: 'Marcar sección como leída',
    unread_count_label: '{{count}} sin leer',
    notifications_categories: {
        payments: 'Pagos',
        reservations: 'Reservas',
        tickets: 'Tickets y Soporte',
        flights: 'Vuelos y Logística',
        system: 'Sistema y General'
    },
    notifications_title: 'Notificaciones',
    number: 'Número',
    number_of_days: 'Nro. Días',
    number_short: 'N°',
    occupancy: 'Ocupación',
    odometer: 'Kilometraje',
    of: 'de',
    onboarding_description: 'Ingresa tus datos para comenzar.',
    onboarding_title: 'Crear tu Grupo de Trabajo',
    one_url_per_line: 'Una URL por línea',
    ongoing: 'En Curso',
    online_publishing: 'Publicación Online',
    online_store: 'Tienda Online',
    online_store_description: 'Configura la tienda online de tu cliente/proveedor',
    online_store_settings_desc: 'Configura la integración y apariencia de tu tienda online.',
    only_pendings: 'Solo Pendientes',
    open: 'Abierto',
    operated_by: 'Operado por',
    operation: {
        error: 'Error',
        info: 'Información',
        save_business: {
            error: 'Error al guardar cliente/proveedor',
            success: 'Cliente/Proveedor guardada exitosamente'
        },
        save_person: {
            error: 'Error al guardar persona',
            success: 'Persona guardada exitosamente'
        },
        save_reservation: {
            error: 'Error al actualizar reserva',
            success: 'Reserva actualizada exitosamente'
        },
        save_service: {
            error: 'Error al guardar servicio',
            success: 'Servicio guardado exitosamente'
        },
        save_settings: {
            error: 'Error al guardar configuración',
            success: 'Configuración guardada exitosamente'
        },
        save_saved_report: {
            error: 'Error al guardar el filtro',
            success: 'Filtro guardado exitosamente'
        },
        save_shared_report: {
            error: 'Error al compartir reporte',
            success: 'Reporte compartido exitosamente'
        },
        delete_shared_report: {
            error: 'Error al eliminar reporte compartido',
            success: 'Reporte compartido eliminado exitosamente'
        },
        delete_saved_report: {
            error: 'Error al eliminar el filtro',
            success: 'Filtro eliminado exitosamente'
        },
        save_template: {
            error: 'Error al guardar plantilla',
            success: 'Plantilla guardada exitosamente'
        },
        add_subscription: {
            error: 'Error al agregar suscripción',
            success: 'Suscripción agregada exitosamente'
        },
        delete_subscription: {
            error: 'Error al eliminar suscripción',
            success: 'Suscripción eliminada exitosamente'
        },
        add_recurring_expense: {
            error: 'Error al agregar gasto recurrente',
            success: 'Gasto recurrente agregado exitosamente'
        },
        delete_recurring_expense: {
            error: 'Error al eliminar gasto recurrente',
            success: 'Gasto recurrente eliminado exitosamente'
        },
        cancel_recurring_expense: {
            error: 'Error al cancelar gasto recurrente',
            success: 'Gasto recurrente cancelado exitosamente'
        },
        save_recurring_expense: {
            error: 'Error al guardar gasto recurrente',
            success: 'Gasto recurrente guardado exitosamente'
        },
        save_vehicle: {
            error: 'Error al guardar vehículo',
            success: 'Vehículo guardado exitosamente'
        },
        success: 'Operación exitosa',
        warning: 'Advertencia'
    },
    operational_services: 'Servicios Operativos',
    operations: 'Operaciones',
    operations_and_capacity: 'Operaciones y Capacidad',
    operator: 'Operador',
    operators: 'Operadores',
    opertor: 'Operador',
    optional: 'Opcional',
    options: 'Opciones',
    options_text: 'Opciones con Texto',
    or: 'O',
    order: 'Orden',
    orders: 'Ordenes',
    orders_calendar: 'Calendario de Ordenes',
    orders_create: 'Ordenes - Crear',
    orders_management: 'Gestión de Ordenes',
    orders_show: 'Ordenes - Mostrar',
    origin: 'Origen',
    origin_city: 'Ciudad de Origen',
    origin_zone: 'Zona de Origen',
    original_cost: 'Costo Original',
    original_price: 'Precio Original',
    original_total_price: 'Total Original',
    other: 'Otra',
    other_plural: "Otros",
    other_class: 'Clase Especial',
    other_class_plural: 'Clases Especiales',
    outdoor_adventure: 'Aventura Al Aire Libre',
    outdoor_adventure_plural: 'Aventuras Al Aire Libre',
    over_paid: 'Sobrepago',
    overdue: 'Vencido',
    overview: 'Resumen',
    owes: 'Debe',
    client_surplus_money: 'A favor',
    owes_money: 'Debe dinero',
    owner: 'Propietario',
    you_are_the_owner: 'Eres el propietario de este negocio.',
    packages: 'Paquetes',
    pages: {
        home: {
            allRightsReserved: 'Todos los derechos reservados.',
            benefitsTitle: 'Transforma tus operaciones con resultados medibles',
            contact: 'Contacto',
            contactSubtitle: 'Estamos aquí para ayudarte a planificar tu viaje perfecto',
            contactUs: 'Contáctanos',
            ctaSubtitle: 'Comienza hoy y descubre cómo Turizi puede revolucionar tus operaciones hoteleras.',
            ctaTitle: '¿Listo para transformar tu negocio?',
            discoverExperiences: 'Descubre Experiencias Increíbles',
            emailUs: 'Envíanos un Email',
            exploreServices: 'Explorar Servicios',
            features: {
                accounting: {
                    description: 'Gestión financiera completa con facturación automatizada, seguimiento de gastos e informes.',
                    title: 'Contabilidad y Finanzas'
                },
                multiProperty: {
                    description: 'Administra propiedades ilimitadas desde un solo panel con controles unificados de inventario y precios.',
                    title: 'Gestión Multi-Propiedad'
                },
                revenueAnalytics: {
                    description: 'Gestion de precios dinámicos, información de ocupación y control de gastos.',
                    title: 'Ingresos/Egresos'
                },
                roomManagement: {
                    description: 'Inventario completo de habitaciones, horarios de limpieza y seguimiento de ocupación.',
                    title: 'Habitaciones'
                },
                smartBooking: {
                    description: 'Optimiza las reservas tus servicios y propiedades con programación y disponibilidad en tiempo real.',
                    title: 'Reservas'
                },
                vehicleManagement: {
                    description: 'Administra tu flota con seguimiento, programas de mantenimiento y optimización de rutas.',
                    title: 'Buses y Vehículos'
                }
            },
            forBusinesses: 'Para Cliente/Proveedores',
            from: 'Desde',
            getInTouch: 'Ponte en Contacto',
            getStarted: 'Comienza Ahora',
            heroHighlight: 'Servicios Turísticos',
            heroTitle: 'Plataforma de',
            landing: {
                automation: {
                    aiPowered: {
                        description: 'Asistente inteligente de IA para ayudar a gestionar tus operaciones',
                        title: 'Asistencia con IA'
                    },
                    analytics: {
                        description: 'Información en tiempo real sobre el rendimiento de tu negocio',
                        title: 'Análisis Inteligente'
                    },
                    instantProcessing: {
                        description: 'Automatiza tareas repetitivas y ahorra horas de trabajo manual',
                        title: 'Procesamiento Instantáneo'
                    },
                    timeTracking: {
                        description: 'Tu asistente digital trabaja las 24 horas del día',
                        title: 'Disponibilidad 24/7'
                    }
                },
                comparison: {
                    sectionBadge: 'Transformación Digital',
                    sectionSubtitle: 'Deja de perder tiempo en procesos manuales. Turizi digitaliza y automatiza todo tu negocio de viajes.',
                    sectionTitle: 'De Operaciones Manuales a Automatizadas',
                    traditional: {
                        item1: 'Flujos de trabajo en papel o planillas',
                        item2: 'Entrada manual de datos y cálculos',
                        item3: 'Colaboración y visibilidad limitadas',
                        item4: 'Propenso a errores humanos',
                        item5: 'Tareas repetitivas que consumen tiempo',
                        item6: 'Sin actualizaciones en tiempo real ni automatización',
                        title: 'Operaciones Manuales'
                    },
                    turizi: {
                        item1: '100% operaciones digitales en la nube',
                        item2: 'Cálculos y flujos de trabajo automatizados',
                        item3: 'Colaboración y actualizaciones en tiempo real',
                        item4: 'Procesos automatizados sin errores',
                        item5: 'Tareas automatizadas ahorran horas diarias',
                        item6: 'Automatización y digitalización completa',
                        title: 'Plataforma Digital Automatizada'
                    }
                },
                cta: {
                    button: 'Comenzar Ahora',
                    description: 'Únete a la revolución digital y automatiza tus operaciones hoy.',
                    scheduleDemo: 'Programar Demo',
                    startTrial: 'Comenzar Prueba Gratis',
                    title: '¿Listo para Transformar tu Agencia de Viajes?'
                },
                digitalFeatures: {
                    ai: {
                        badge: 'Potenciado por IA',
                        description: 'Haz preguntas, obtén respuestas instantáneas y gestiona tus operaciones usando lenguaje natural. Nuestra IA comprende tu negocio y proporciona respuestas precisas y contextuales.',
                        feature1: 'Consultas en lenguaje natural',
                        feature2: 'Recuperación instantánea de datos',
                        feature3: 'Disponibilidad 24/7',
                        title: 'Asistente Inteligente a tu Servicio'
                    },
                    badge: 'Herramientas Digitales',
                    calendar: {
                        badge: 'Programación Inteligente',
                        description: 'Visualiza todas tus reservas, tours y actividades en un calendario unificado. Evita conflictos y optimiza automáticamente la asignación de recursos.',
                        feature1: 'Vista unificada de todos los servicios',
                        feature2: 'Detección automática de conflictos',
                        feature3: 'Optimización de recursos',
                        title: 'Gestión Automatizada de Calendario'
                    },
                    finance: {
                        badge: 'Control Financiero',
                        description: 'Rastrea pagos, balances y métricas financieras en tiempo real. Automatiza facturación y recordatorios de pago para mejorar el flujo de caja.',
                        feature1: 'Seguimiento de balance en tiempo real',
                        feature2: 'Recordatorios de pago automatizados',
                        feature3: 'Soporte multimoneda',
                        title: 'Visibilidad Financiera Completa'
                    },
                    title: 'Digitaliza Cada Aspecto de tu Agencia'
                },
                features: {
                    groupManagement: {
                        description: 'Gestiona digitalmente reservas grupales complejas. Automatiza asignaciones de viajeros, habitaciones y coordinación de servicios en una plataforma.',
                        title: 'Gestión de Grupos Automatizada'
                    },
                    instantQuotes: {
                        description: 'Genera propuestas digitales profesionales instantáneamente con cálculos de precios automatizados y verificación de disponibilidad.',
                        title: 'Cotizaciones Digitales Instantáneas'
                    },
                    multiDestination: {
                        description: 'Automatiza la coordinación de tours complejos con integración inteligente de proveedores y sincronización de disponibilidad en tiempo real.',
                        title: 'Automatización Multi-destino'
                    },
                    payments: {
                        description: 'Digitaliza tus finanzas con facturación automatizada, seguimiento de pagos y soporte multi-moneda.',
                        title: 'Procesamiento de Pagos Automatizado'
                    },
                    sectionBadge: 'Automatización Digital',
                    sectionSubtitle: 'Desde la consulta inicial hasta el pago final, nuestra plataforma automatiza y digitaliza cada aspecto de las operaciones de agencias de viajes.',
                    sectionTitle: 'Automatiza Todo tu Negocio de Viajes',
                    security: {
                        description: 'Cifrado de nivel bancario y cumplimiento GDPR aseguran que tus operaciones digitales sean seguras y protegidas.',
                        title: 'Infraestructura Digital Segura'
                    },
                    smartScheduling: {
                        description: 'Creación automática de itinerarios con detección de conflictos y optimización impulsada por IA para operaciones sin problemas.',
                        title: 'Automatización Inteligente de Programación'
                    }
                },
                footer: {
                    about: 'Acerca de',
                    api: 'API',
                    blog: 'Blog',
                    careers: 'Carreras',
                    community: 'Comunidad',
                    company: 'Cliente/Proveedor',
                    contact: 'Contacto',
                    copyright: '© 2024 Turizi. Todos los derechos reservados.',
                    docs: 'Documentación',
                    features: 'Características',
                    gdpr: 'GDPR',
                    helpCenter: 'Centro de Ayuda',
                    integrations: 'Integraciones',
                    legal: 'Legal',
                    pricing: 'Precios',
                    privacy: 'Privacidad',
                    product: 'Producto',
                    resources: 'Recursos',
                    security: 'Seguridad',
                    terms: 'Términos',
                    webinars: 'Webinars'
                },
                hero: {
                    automation: 'Automatización y Digitalización Completa de Procesos',
                    noCreditCard: 'Sin tarjeta de crédito • Configuración en 15 minutos • Cancela cuando quieras',
                    startTrial: 'Prueba Gratis por 14 Días',
                    subtitle: 'Transforma tus operaciones con la plataforma todo-en-uno diseñada para',
                    subtitle2: 'agencias de viajes y operadores turísticos',
                    title: 'Digitalización y Automatización para Agencias de Viajes',
                    watchDemo: 'Ver Demo'
                },
                nav: {
                    contact: 'Contacto',
                    demo: 'Demo',
                    features: 'Características',
                    pricing: 'Precios',
                    signIn: 'Iniciar Sesión',
                    startFreeTrial: 'Prueba Gratis'
                },
                showcase: {
                    badge: 'Plataforma Completa',
                    title: 'Todo lo que Necesitas en un Solo Lugar'
                },
                stats: {
                    agencies: 'Agencias de Viajes',
                    satisfaction: 'Satisfacción del Cliente',
                    setupTime: 'Tiempo de Configuración Promedio',
                    travelers: 'Viajeros Gestionados'
                },
                workflow: {
                    sectionBadge: 'Transformación Digital',
                    sectionTitle: 'Digitaliza y automatiza todo tu flujo de trabajo',
                    step1: {
                        description: 'Transforma tus servicios, alojamientos y actividades en activos digitales con precios automatizados y disponibilidad en tiempo real.',
                        title: 'Digitaliza tu Inventario'
                    },
                    step2: {
                        description: 'Usa nuestra interfaz digital de arrastrar y soltar para crear itinerarios con precios automatizados, verificación de disponibilidad y detección de conflictos.',
                        title: 'Automatiza la Creación de Itinerarios'
                    },
                    step3: {
                        description: 'Generación automatizada de propuestas con un clic. Documentos digitales incluyen mapas, fotos y desgloses detallados.',
                        title: 'Genera Propuestas Digitales Instantáneamente'
                    },
                    step4: {
                        description: 'Paneles digitales para reservas, pagos y documentos. Recordatorios y notificaciones automatizadas mantienen las operaciones funcionando sin problemas.',
                        title: 'Gestión de Operaciones Automatizada'
                    }
                }
            },
            limitedAvailability: 'Disponibilidad limitada',
            localExpertise: 'Experiencia Local',
            localExpertiseDesc: 'Conocimiento profundo de destinos y joyas ocultas',
            login: 'Iniciar sesión',
            or: 'o',
            ourBusinesses: 'Nuestras Cliente/Proveedores Asociadas',
            ourServices: 'Nuestros Servicios',
            perPerson: 'por persona',
            publishYourService: 'Conocer más',
            qualityService: 'Servicio de Calidad',
            qualityServiceDesc: 'Atención personalizada y experiencias memorables',
            questions: '¿Preguntas? Contáctanos en',
            sendMessage: 'Envíanos un mensaje',
            servicesSubtitle: 'Elige entre nuestros tours y actividades cuidadosamente seleccionados',
            variedOptions: 'Opciones Variadas',
            variedOptionsDesc: 'Amplia gama de tours para cada viajero',
            viewAllServices: 'Ver los {{count}} servicios',
            viewDetails: 'Ver Detalles',
            welcome: 'Bienvenido a {{name}}',
            whyChooseUs: '¿Por qué Elegirnos?',
            whyChooseUsSubtitle: 'Tu socio de confianza para viajes inolvidables'
        }
    },
    paid: 'Pagado',
    paid_amount: 'Abonado',
    remaining_amount: 'Resta',
    surplus: 'A favor',
    painting: 'Pintura',
    painting_class: 'Clase de Pintura',
    painting_class_plural: 'Clases de Pintura',
    painting_plural: 'Pinturas',
    parent_inventory_item: 'Item Superior',
    parking: 'Estacionamiento',
    partial: 'Parcial',
    partially_paid: 'Pago Parcial',
    partially_refunded: 'Parcialmente Reembolsado',
    passenger_data: 'Datos del pasajero',
    passenger_info: 'Información del pasajero',
    passenger_type: 'Tipo de Pasajero',
    passengers_per_day: 'Personas por Día',
    passport: 'Pasaporte',
    password: 'Contraseña',
    'password-required': 'La contraseña es requerida',
    password_changed_successfully: 'Contraseña cambiada con éxito',
    passwords_do_not_match: 'Las contraseñas no coinciden',
    paste_a_list_of_names: 'Pega una lista de nombres',
    pax: 'Pax',
    pax_count: 'Paxs',
    pax_holder: 'Pax Titular',
    pax_assigned_count: '{{assigned}} / {{total}} asignados',
    pax_description: 'Persona o Grupo que viaja y paga por el servicio',
    pax_number_question: 'Nro. de personas',
    pax_pricing: 'Persona',
    pax_seats: 'Paxs / Asientos',
    paxs: 'Paxs',
    paxs_capacity: 'Capacidad de Paxs',
    paxs_capacity_description: 'Dejar vacío para no limitar la capacidad en este item',
    paxs_catalog: 'Catalogo de Paxs',
    paxs_description: 'Gestiona tus paxs',
    payed_amount: 'Pagado',
    payee: 'Para',
    payer: 'De',
    payer_information: 'Información del Cliente',
    payment: 'Pago',
    applied_amount: 'Monto Aplicado',
    applied_amounts: 'Montos Aplicados',
    distribute_evenly: 'Distribuir Equitativamente',
    fill_needed_amounts: 'Completar Saldos Requeridos',
    payment_created_successfully: 'Pago creado exitosamente',
    payment_date: 'Fecha de Pago',
    payment_deleted_successfully: 'Pago eliminado exitosamente',
    payment_done: 'Pago Realizado',
    payment_done_desc: 'El pago se ha realizado correctamente',
    payment_failed: 'Pago Fallido',
    payment_full: 'Pago Total',
    payment_intent: 'Intención de Pago',
    payment_issue_warning: 'Monto inválido o emisor/receptor idénticos',
    payment_method: 'Método de Pago',
    payment_methods: {
        bank_transfer: 'Transferencia Bancaria',
        card: 'Tarjeta',
        debit_card: 'Tarjeta Débito',
        credit_card: 'Tarjeta Crédito',
        cash: 'Efectivo',
        paypal: 'PayPal',
        reconciling: 'Conciliación',
        service_reciprocity: 'Servicio por Reciprocidad',
        stripe: 'Stripe',
        wallet_transfer: 'Billetera Digital',
        other: "Otro"
    },
    by_payment_method: 'Por método de pago',
    no_transactions: 'Sin transacciones',
    no_overdue_payments: 'Sin pagos vencidos',
    payment_partial: 'Pago Parcial',
    payment_pending: 'Pendiente',
    payment_status: 'Estado de Pago',
    reconcile_payments: 'Asistente de Conciliación',
    see_reconciliation_details: 'Ver Detalles de Conciliación',
    reconciliation_triggered_successfully: 'Conciliación completada con éxito',
    reconciliation_failed: 'Error en la conciliación',
    reconciliation_executed_successfully: 'Conciliación ejecutada con éxito',
    match: 'Coincidencia',
    find_matches_title: 'Buscar Coincidencias de Conciliación',
    no_matches_found: 'No se encontraron pagos/reservas no conectadas.',
    reconcile_confirm_title: 'Conciliar Pagos',
    reconcile_confirm_desc: 'Seleccione las coincidencias propuestas que desea ejecutar. Solo se procesan los pagos y reservas que no están vinculados.',
    reconcile_execute_button: 'Ejecutar Conciliación',
    reconcile_match_payment: 'Pago',
    reconcile_match_reservation: 'Reserva',
    reconcile_match_amount: 'Monto a Vincular',
    reconcile_find_error: 'Error al buscar coincidencias de conciliación',
    payment_type: 'Tipo de Pago',
    payment_types: {
        cancellation_fee: 'Tarifa de Cancelación',
        fee: 'Tarifa',
        full: 'Total',
        partial: 'Parcial',
        refund: 'Reembolso'
    },
    payments: 'Pagos',
    payments_income: 'Pagos de Clientes',
    payments_outcome: 'Pagos a Proveedores',
    payments_history: 'Historial de Pagos',
    paypal: 'PayPal',
    pdf_view: 'Vista en PDF',
    pending: 'No Confirmada',
    pending_payments: 'Pagos Pendientes',
    pending_tickets: 'Tickets Pendientes',
    people: 'Personas',
    percentage: 'Porcentaje',
    period: 'Periodo',
    person: 'Persona',
    person_type_pricing: 'Por Persona',
    person_updated_successfully: 'Persona actualizada exitosamente',
    persons: 'Personas',
    phone: 'Teléfono',
    phones: 'Telefonos',
    photography: 'Fotografía',
    photography_class: 'Clase de Fotografía',
    photography_class_plural: 'Clases de Fotografía',
    photography_plural: 'Fotografías',
    pickup_date: 'Fecha de Recogida',
    pickup_location: 'Punto de Entrega',
    plane: 'Avión',
    plane_rental: 'Alquiler de Avión',
    plane_rental_plural: 'Alquileres de Aviónes',
    planned_services: 'Servicios Programados',
    please_select_start_and_end_time: 'Por favor selecciona la fecha y hora de inicio y fin',
    please_select_the_passengers_for_this_booking: 'Seleccione los pasajeros para esta reserva',
    policies: 'Políticas',
    postal_code: 'Código Postal',
    precio_manual: 'Precio manual',
    preview: 'Vista Previa',
    price: 'Precio',
    pvp: 'PVP',
    standard_retail_price: 'Precio Venta Publico',
    price_breakdown: 'Detalle de Precios',
    price_by: 'Precios Por:',
    price_by_description: 'El precio se calculará por día, pax o servicio',
    price_by_hour: 'por Hora',
    price_by_night: 'por Noche',
    price_by_night_and_pax: 'por Noche y Persona',
    price_by_pax: 'por Persona',
    price_by_service: 'por Servicio',
    price_calculated_by: 'Precio Calculado Por:',
    price_cost_error: 'El precio de venta debe ser mayor al precio de costo',
    price_factor: 'Factor de Precio',
    price_period: 'Periodo de Precio',
    price_saved_successfully: 'Precio guardado exitosamente',
    price_summary: 'Resumen de Precios',
    prices: 'Precios',
    pricing: 'Precios',
    pricing_error_desc: 'No se pudieron obtener los precios para uno o más servicios. Por favor verifica las fechas y parámetros.',
    pricing_error_title: 'Error de Tarifas',
    primary_color: 'Color Primario',
    privacy: 'Privacidad',
    private: 'Privado',
    private_categories: 'Categorías Privadas',
    private_fm: 'Privada',
    private_room: 'Habitación Privada',
    private_service: 'Privado',
    private_vehicle: 'Vehículo Privado',
    privates: 'Privados',
    processing: 'Procesando',
    processing_your_request: 'Procesando tu solicitud',
    products: 'Productos',
    profile: 'Perfil',
    profit: 'Ganancia',
    proportional: 'Proporcional',
    provided_by_other: 'Proveído por terceros',
    provider: 'Proveedor',
    provider_only_bookings: 'Reservas de Servicio Proveídas por',
    provider_price: 'Precio de Proveedor',
    provider_services: 'Servicios que Provee',
    provider_specific_cost: 'Este costo se aplicará a un proveedor específico',
    provider_specific_price: 'Este precio se aplicará a un proveedor específico',
    providers: 'Proveedores',
    providing_services: 'Servicios que provee',
    province: 'Provincia',
    public: 'Público',
    public_categories: 'Categorías Públicas',
    public_rank: 'Ranking Publico (web/tarifario)',
    public_services: 'Compartir Tarifario',
    public_tariffs: 'Tarifario Público',
    publish_price: 'Publicar online',
    publish_price_description: 'Habilite esta opción para mostrar este servicio y sus precios en la tienda online o para  usuarios externos.',
    publish_prices: 'Publicar online',
    published: 'Publicado',
    purchase_date: 'Fecha de Compra',
    quantity: 'Unidades',
    quantity_description: 'Cantidad del mismo item',
    rack: 'Rack',
    rank: 'Ranking',
    ready: 'Listo',
    reason: 'Razón',
    received_currency: 'Moneda Recibida',
    recipient: 'Destinatario',
    recipients: 'Destinatarios',
    recipients_list: 'Lista de Destinatarios',
    records: 'Registros',
    refresh: 'Actualizar',
    refund: 'Reembolso',
    refunded: 'Reembolsado',
    regime: 'Régimen',
    regimen: 'Regimen',
    register_money_transaction: 'Registrar Pago',
    regular: 'Regular',
    regular_schedule: 'Regular',
    regulars: 'Regulares',
    reply_to_existing_conversation: 'Responder a una conversación de mail existente',
    remove: 'Eliminar',
    remove_bookings: 'Sacar Bookings',
    remove_from_order: 'Eliminar de Orden',
    remove_from_reservation: 'Sacar de la reserva',
    remove_pax: 'Sacar Pax',
    remove_staff: 'Sacar Staff',
    remove_stock_period: 'Eliminar Periodo de Stock',
    remove_stock_period_confirmation: '¿Estás seguro de querer eliminar este periodo de stock?',
    remove_stock_period_confirmation_message: '¿Estás seguro de querer eliminar este periodo de stock?',
    remove_stock_period_confirmation_title: 'Eliminar Periodo de Stock',
    rental_house: 'Casa de Alquiler',
    required_info: 'Información Requerida',
    required_information: 'Información Requerida',
    required_number_of_service_orders: 'Número de Órdenes Requeridas',
    required_service_orders: 'Órdenes de servicio requeridas',
    requested_amount: 'Monto Solicitado',
    linked_payments: 'Pagos Vinculados',
    unlinked_payments: 'Pagos Sin Vincular',
    reservation: 'Reserva',
    reservation_cancelled: 'Cancelada',
    reservation_cancelled_plural: 'Canceladas',
    reservation_completed: 'Completada',
    reservation_confirmed: 'Confirmada',
    reservation_in_progress: 'En Curso',
    reservation_finished: 'Finalizada',
    reservation_confirmed_plural: 'Confirmadas',
    reservation_date: 'Fecha de Reserva',
    reservation_dates: 'Fechas de Reserva',
    reservation_details: 'Detalles de Reserva',
    reservation_future: 'Proximamente',
    reservation_id: 'ID de Reserva',
    reservation_number: 'Número de Reserva',
    reservation_ongoing: 'En Curso',
    reservation_paxs: 'Paxs de la Reserva',
    reservation_payments: 'Pagos de la Reserva',
    reservation_pending: 'Cotización',
    reservation_pending_plural: 'Cotizaciónes',
    reservation_price: 'Precio de la Reserva',
    reservation_shared_successfully: 'Reserva compartida exitosamente',
    reservation_status: 'Estado de Reserva',
    reservation_statuses: 'Estados de Reserva',
    reservations_by_status: 'Reservas por Estado',
    reservation_unshared_successfully: 'Acceso a la reserva eliminado exitosamente',
    reservation_web_created: 'Web',
    reservations: 'Reservas',
    reservation_summary: 'Reserva',
    quotes: 'Presupuestos',
    quote: 'Presupuesto',
    new_quote: 'Nuevo Presupuesto',
    quote_status: 'Estado del Presupuesto',
    quote_dates: 'Fechas del Presupuesto',
    create_quote: 'Crear Presupuesto',
    error_creating_quote: 'Error al crear el presupuesto',
    accepted: 'Aceptado',
    rejected: 'Rechazado',
    expired: 'Expirado',
    totals: 'Totales',
    observations_placeholder: 'Escriba observaciones aquí...',
    quote_deleted: 'Presupuesto eliminado con éxito',
    error_deleting_quote: 'Error al eliminar el presupuesto',
    confirm_delete_service: '¿Está seguro de que desea eliminar este servicio?',
    service_deleted: 'Servicio eliminado con éxito',
    error_deleting_service: 'Error al eliminar el servicio',
    booking_updated: 'Reserva actualizada con éxito',
    error_updating_booking: 'Error al actualizar la reserva',
    quote_status_updated: 'Estado actualizado con éxito',
    quote_client_updated: 'Cliente actualizado con éxito',
    quote_observations_updated: 'Observaciones actualizadas con éxito',
    quote_details: 'Detalles del Presupuesto',
    no_services_quote: 'Aún no se han añadido servicios a este presupuesto',
    add_first_service: 'Añadir Primer Servicio',
    no_quotes_found: 'No se encontraron presupuestos',
    manual_price: 'Precio Manual',
    please_select_business: 'Por favor seleccione una cliente/proveedor',
    select_business_to_view_assignments: 'Selecciona una cliente/proveedor para ver las asignaciones',
    select_business_placeholder: 'Seleccione una cliente/proveedor...',
    reservations_calendar: 'Calendario de Reservas',
    reservations_description: 'Gestiona tus reservas de servicios',
    reservations_payments: 'Pagos de Reservas',
    reservations_sold: 'Reservas Vendidas',
    reserved_price: 'Precio Reservado',
    reset_price: 'Recalcular precio',
    reset_cost: 'Recalcular costo',
    reset_to_template: 'Restablecer',
    resolve_payment_for_reservation: 'Vincular Pago (Reserva #{{id}})',
    resources_and_services: 'Recursos y Servicios',
    restaurant: 'Restaurante',
    restaurants: 'Restaurantes',
    result: 'Resultado',
    results: 'Resultados',
    retry_campaign: 'Falló. Intentar nuevamente',
    revenue: 'Ingresos',
    river: 'Río',
    road: 'Terrestre',
    role: 'Rol',
    room: 'Habitación',
    room_category: 'Categoría de Habitación',
    room_details: 'Detalles de Habitación',
    room_number: 'Nro. Hab.',
    room_plural: 'Habitaciones',
    room_type: 'Habitación',
    rooms: 'Habitaciones',
    rooms_available: 'Habitaciones disponibles',
    route: 'Recorrido',
    route_points: 'Puntos de Recorrido',
    routing: 'Ruta',
    sales: 'Ventas',
    save: 'Guardar',
    save_as_new_template: 'Guardar como nueva plantilla',
    save_and_close: 'Guardar y Cerrar',
    save_current_preset: 'Guardar Filtros Actuales',
    save_new_cost: 'Guardar Nuevo Costo',
    save_new_name: 'Guardar Nuevo Nombre',
    save_new_price: 'Guardar nuevo precio',
    save_preset_dialog_title: 'Guardar Filtro',
    save_observations: 'Guardar',
    save_providers: 'Guardar Proveedores',
    save_to_linked_service: 'Guardar en el servicio espejo',
    saved_presets: 'Filtros Guardados',
    saved_to_linked_service: 'Guardado en el servicio conectado',
    saved_to_linked_service_cost: 'Guardado en el servicio conectado',
    saved_to_linked_service_price: 'Guardado en el servicio conectado',
    saving: 'Guardando...',
    saving_providers: 'Guardando proveedores...',
    saving_providers_success: 'Proveedores guardados exitosamente',
    schedule: 'Horarios',
    scheduling: 'Programación',
    search: 'Buscar',
    search_all: 'Buscar en todos',
    search_businesses: 'Buscar Cliente/Proveedores',
    search_by: 'Buscar Por',
    search_paxs: 'Buscar pasajeros',
    search_client: 'Buscar Cliente',
    search_clients: 'Buscar Clientes',
    search_existing_person: 'Buscar persona existente',
    search_inventory: 'Buscar inventario',
    search_inventory_items: 'Buscar en Inventario',
    search_rooms: 'Buscar Habitaciones',
    search_tours: 'Buscar Excursiones',
    search_transfers: 'Buscar Traslados',
    seats_available: 'asientos disponibles',
    secondary_color: 'Color Secundario',
    see_all: 'Ver Todos',
    see_vehicles: 'Ver Vehículos',
    select: 'Seleccionar',
    select_all: 'Seleccionar Todo',
    select_all_filtered: 'Seleccionar todos los filtrados',
    select_an_existing_payment_from_client: 'Selecciona un pago existente del cliente: {{name}}',
    select_assignee: 'Seleccionar Asignado',
    select_business: 'Seleccionar Cliente/Proveedor',
    select_business_type: 'Selecciona tipo de cliente/proveedor',
    select_businesses: 'Selecciona las cliente/proveedores',
    select_businesses_to_edit: 'Selecciona cliente/proveedores para editar',
    select_campaign: 'Seleccionar Campaña',
    select_categories: 'Seleccionar Categorías',
    select_city: 'Seleccionar Ciudad',
    select_client: 'Seleccionar Cliente',
    please_select_client: 'Por favor seleccione un cliente',
    click_to_edit: 'Click para editar',
    select_coordinator: 'Seleccionar Coordinador',
    select_cost_by: 'Costo Por:',
    select_country: 'Seleccionar País',
    select_currency: 'Seleccionar Moneda',
    select_currency_for_all_bookings: 'Seleccionar Moneda para precio final',
    select_date: 'Seleccionar Fecha',
    select_date_range: 'Seleccionar Fechas',
    select_date_time_and_guests: 'Selecciona fecha, hora y número de huéspedes',
    select_destination: 'Seleccionar Destino',
    select_destination_city: 'Seleccionar Ciudad de Devolución',
    select_due_date: 'Seleccionar Fecha de Vencimiento',
    select_image: 'Seleccionar Imagen',
    select_inventory: 'Seleccionar Inventario',
    select_inventory_item: 'Seleccionar Inventario',
    select_items: 'Seleccionar items',
    select_items_placeholder: 'Elija los ítems para mostrar como columnas',
    select_linked_service: 'Seleccionar Servicio Espejo',
    select_money_destination: 'Seleccionar Destinatario',
    select_money_origin: 'Seleccionar Remitente',
    select_order: 'Seleccionar Orden',
    select_origin: 'Seleccionar Origen',
    select_pax: 'Seleccionar Pax',
    select_paxs: 'Seleccionar Paxs',
    select_payee: 'Seleccionar Beneficiario',
    select_payer: 'Seleccionar Pagador',
    select_payment: 'Seleccionar pago',
    select_pickup_city: 'Seleccionar Ciudad de Entrega',
    select_price_by: 'Precio por:',
    select_provider: 'Seleccionar Proveedor',
    select_emails: 'Seleccionar direcciones de correo',
    select_recipient: 'Seleccionar Quien Recibe',
    select_recipients: 'Seleccionar Destinatarios',
    select_role: 'Seleccionar Rol',
    select_seller_business: 'Seleccionar Cliente/Proveedor Vendedora',
    select_service: 'Seleccionar Servicio',
    select_service_for_group: 'Seleccionar Servicio para el Paquete',
    select_service_for_reservation: 'Seleccionar Servicio Para Reserva',
    select_service_type: 'Seleccionar Tipo de Servicio',
    select_preset: 'Seleccionar filtro guardado...',
    select_staff: 'Seleccionar Staff',
    select_template: 'Seleccionar Plantilla',
    select_type: 'Seleccionar Tipo',
    select_user: 'Seleccionar Usuario',
    select_vehicle: 'Seleccionar Vehículo',
    select_zone: 'Seleccionar Zona',
    selected: 'Seleccionados',
    selected_inventory: 'Inventario Seleccionado',
    selected_items_total: 'Total de Items Seleccionados',
    selected_paxs: 'Paxs Seleccionados',
    selected_provider: 'Proveedor Seleccionado',
    selected_service: 'Servicio Seleccionado',
    selected_staff: 'Staff Seleccionado',
    self: 'Propia',
    self_attributes: 'Atributos',
    self_attrs: 'Atributos',
    sell_amount: 'Monto de Venta',
    sell_costs: 'Costos de Venta',
    sell_prices: 'Precios de Venta',
    sell_prices_discounts: 'Descuentos Sobre Precios de Venta',
    seller: 'Vendedor',
    seller_and_provider_bookings: 'Reservas de Servicio Vendidas y Proveídas por',
    seller_business: 'Cliente/Proveedor Vendedora',
    seller_business_description: 'Esto es para llevar el control de las ventas de los servicios',
    seller_only_bookings: 'Reservas de Servicio Vendidas por',
    selling_limit: 'Límite de Venta',
    selling_services: 'Servicios que Vende',
    send: 'Enviar',
    send_balance_email: 'Enviar Balance Por Mail',
    send_period_balance_email: 'Enviar Periodo Seleccionado',
    send_all_balance_email: 'Enviar Resumen de Balance',
    send_campaign: 'Enviar campaña',
    send_email: 'Enviar Mail',
    send_tariffs_email: 'Enviar Acceso a Tarifario',
    send_reservations_payment_status_email: 'Enviar Estado de Pago de Reservas',
    reservations_payment_status: 'Estado de Pago de Reservas',
    payment_status_filter: 'Filtrar por Estado de Pago',
    custom_message_optional: 'Mensaje personalizado (opcional)',
    custom_message_placeholder: 'Escribe un mensaje o nota adicional para incluir en el correo...',

    seniors: 'Seniors',
    retired: 'Jubilado',
    retired_plural: 'Jubilados',
    show_retired: 'Mostrar precio Jubilado',
    show_retired_description: 'Usar "Jubilado" en lugar de "Senior" para este servicio',
    sent: 'Enviado',
    sent_to: 'Enviado a',
    service: 'Servicio',
    'service-booking-daily-available-limit-exceeded': 'Ya tienes el máximo de pasajeros permitidos para este servicio en esta fecha',
    service_attributes: 'Atributos del Servicio',
    service_booked_in: 'Reservas del Servicio',
    service_booking_price: 'Precio del servicio',
    service_bookings: 'Bookings de Servicios',
    service_categories: 'Categorías de Servicio',
    service_category: 'Tipo de Servicio',
    service_composition: 'Composición del Servicio',
    service_configuration: 'Configuración',
    service_date: 'Fecha del Servicio',
    service_day: 'Día del Servicio',
    service_default_duration: 'Duración Estándar del Servicio',
    service_definition: 'Definición del Servicio',
    service_details: 'Detalles del Servicio',
    service_discounts: 'Descuentos',
    service_group: 'Paquete de Servicios',
    service_group_discount: 'Descuento del Paquete de Servicios',
    service_group_plural: 'Paquetes de Servicios',
    service_groups: 'Paquetes de Servicios',
    service_groups_plural: 'Paquetes de Servicios',
    service_has_attrs_warning: 'Elimine los atributos de reserva para agregar sub-servicios.',
    service_has_children_warning: 'No admite atributos de reserva por ser paquete.',
    service_key: 'Clave del Servicio',
    service_name: 'Nombre del Servicio',
    service_not_available: 'El servicio no está disponible para las fechas seleccionadas',
    service_not_found: 'Servicio no encontrado',
    service_number: 'Nro. de Servicio',
    service_order: 'Orden de Servicio',
    service_order_attributes: 'Atributos de Orden de Servicio',
    service_order_bookings: 'Reservas de Servicio',
    service_order_bookings_description: 'Reservas de Servicio en esta Orden',
    service_orders: 'Ordenes de Servicio',
    service_orders_settings_desc: 'Configura opciones de órdenes de servicio, campos personalizados y numeración.',
    service_paxs: 'Paxs Servicio',
    service_period_end: 'Fecha de Fin de Servicio',
    service_period_start: 'Fecha de Inicio de Servicio',
    service_provider: 'Proveedor de Servicios',
    service_selected: 'Servicio Seleccionado',
    service_tags: 'Categorías de Servicio',
    service_title: 'Título del Servicio',
    service_type: 'Tipo de Servicio',
    services: 'Servicios',
    services_availability: 'Disponibilidad de Servicios',
    services_in_this_order: 'Servicios en esta Orden',
    services_landing: 'Servicios',
    services_table: 'Tabla de Servicios',
    services_with_calculated_prices: 'Servicios con Nuevos Precios',
    services_without_dates: 'Servicios sin Fecha',
    services_without_vehicles: 'Sin asignación de vehículo',
    set_coordinator: 'Establecer coordinador',
    set_coordinator_all_bookings: 'Establecer coordinador para todas las reservas',
    set_provider: 'Establecer proveedor',
    set_provider_all_bookings: 'Establecer proveedor para todas las reservas',
    set_discount_scheme_for_all_services: 'Establecer Esquema de Descuentos para Todos los Servicios',
    set_group_composition_before_services: 'Configura la composición del grupo para verificar disponibilidad',
    settings: 'Configuración',
    settings_subtitle: 'Configura y personaliza las opciones y preferencias de tu espacio de trabajo.',
    share: 'Compartir',
    share_reservation: 'Compartir Reserva',
    share_service: 'Compartir Servicio',
    share_services: 'Compartir Servicios',
    share_report: 'Compartir Reporte',
    share_link_copied: '¡Enlace copiado al portapapeles!',
    shared_report_title: 'Reporte de Reservas Compartido',
    viewing_shared_report_desc: 'Viendo Reporte de Reservas Compartido (Solo Lectura)',
    shared_reports: 'Reportes Compartidos',
    sharing_one_service: 'Compartiendo 1 servicio',
    sharing_multiple_services: 'Compartiendo {{count}} servicios',
    sharing_services_description: 'Configure los permisos del cliente a continuación',
    mixed_access: 'Acceso mixto',
    partial_access: 'Acceso parcial',
    remove_access: 'Eliminar acceso',
    services_shared_successfully: 'Servicios compartidos exitosamente',
    error_sharing_services: 'Error al compartir servicios',
    services_unshared_successfully: 'Acceso a servicios eliminado exitosamente',
    error_unsharing_services: 'Error al eliminar el acceso a los servicios',
    shared_kitchen: 'Cocina Compartida',
    shared_room: 'Habitación Compartida',
    shared_vehicle: 'Vehículo Compartido',
    shared_with_me: 'Compartido conmigo',
    show: 'Mostrar',
    show_bookings: 'Mostrar Reservas',
    show_more: 'Ver más',
    show_on_main_page: 'Mostrar en pagina principal',
    show_only_services_without_vehicles: 'Mostrar solo servicios sin vehículos',
    show_service_orders: 'Ver Ordenes',
    showing_results: 'Mostrando {{count}} de {{total}} resultados',
    signIn: 'Iniciar sesión',
    signature_provider: 'Operador: Sello, Firma, Aclaración',
    signature_seller: 'Vendedor: Sello, Firma, Aclaración',
    signingIn: 'Iniciando sesión...',
    single_bed: 'Cama Individual',
    single_beds: 'Camas Individuales',
    single_provider: 'Proveedor único',
    sold: 'Ventas',
    sold_by: 'Por',
    sold_by_long: 'Vendido por',
    sold_by_other: 'Vendido por terceros',
    sort_by: 'Ordenar por',
    sort_by_name: 'Ordenar por Nombre',
    sort_by_price: 'Ordenar por Precio',
    spacial_requirements: 'Requerimientos especiales',
    spacial_view: 'Vista Espacial',
    special: 'Especial',
    special_pricing_available_only_for: 'Precios especiales disponibles solo para',
    special_pricing_target: 'Destinatario de Precios Especiales',
    split: 'Dividir',
    split_pax_group: 'Dividir grupo de paxs',
    splitting_original_group: 'Dividiendo Grupo Original',
    staff: 'Staff',
    staff_category_description: 'Seleccionar o ingresar una nueva categoría',
    staff_description: 'Empleado o miembro del equipo que proporciona servicios',
    staff_paxs: 'Staff y Paxs',
    staff_tag: {
        coordinator: 'Coordinador',
        driver: 'Chofer',
        guide: 'Guía',
        sales: 'Ventas'
    },
    stars: 'Estrellas',
    insufficient_capacity: 'Cupo insuficiente',
    start: 'Inicio',
    start_date: 'Fecha de Inicio',
    start_hour: 'Hora de Inicio',
    start_time: 'Hora de inicio',
    starts_between: 'Comienza Entre',
    status: 'Status',
    status_active: 'Activo',
    status_paused: 'Pausado',
    status_canceled: 'Cancelado',
    total_expenses_by_currency: 'Total de Gastos por Moneda',
    subscription_readonly_warning: 'Este gasto recurrente es de solo lectura y no se puede modificar.',
    status_color: 'Color del Estado',
    status_color_already_exists: 'El color del estado ya existe',
    status_color_required: 'El color del estado es requerido',
    status_inactive: 'Inactivo',
    status_name_already_exists: 'El nombre del estado ya existe',
    status_name_required: 'El nombre del estado es requerido',
    status_overdue: 'Vencido',
    status_open: 'Abierto',
    status_pending: 'Pendiente',
    status_in_progress: 'En Progreso',
    status_completed: 'Completado',
    status_closed: 'Cerrado',
    status_paid: 'Pagado',
    status_cancelled: 'Cancelado',
    priority_low: 'Baja',
    priority_medium: 'Media',
    priority_high: 'Alta',
    priority_urgent: 'Urgente',
    payment_request: 'Solicitud de Pago',
    log_direct_payment: 'Registrar Pago Directo',
    payment_type_selector: 'Tipo de Transacción',
    generate_tax_voucher: 'Generar Factura AFIP',
    invoice_generation_failed: 'Error al generar la factura',
    statuses: 'Estados',
    stay: 'Alojamiento',
    stay_plural: 'Alojamientos',
    stock: 'Stock',
    stock_control: 'Control de Inventario',
    stock_control_description: 'Las Órdenes de Servicio y el Inventario se sincronizarán con el servicio',
    store: 'Tienda',
    store_name: 'Nombre de la Tienda',
    store_website_description: 'Donde esta alojada la tienda online',
    stripe: 'Stripe',
    styling_branding: 'Estilo y Marca',
    submit: 'Enviar',
    subscribe: 'Suscribirse',
    subscription: 'Suscripción',
    subscription_business: 'Negocio',
    subscriptions: 'Gastos Fijos',
    expenses: 'Gastos',
    expense: 'Gasto',
    recurring: 'Fijos',
    auto_payment: 'Pago Automático',
    recurring_expenses: 'Gastos Fijos',
    recurring_expense: 'Gasto Fijo',
    delete_recurring_expense: 'Eliminar Gasto Fijo',
    delete_recurring_expense_confirmation: '¿Estás seguro de que deseas eliminar el gasto fijo {{name}}?',
    cancel_recurring_expense: 'Cancelar Gasto Fijo',
    cancel_recurring_expense_confirmation: '¿Estás seguro que querés cancelar el gasto fijo {{name}}?',
    cancel_subscription: 'Cancelar Gasto Fijo',
    create_recurring_expense: 'Crear Gasto Fijo',
    edit_recurring_expense: 'Editar Gasto Fijo',
    recurring_expense_business: 'Negocio',
    recurring_expense_details: 'Detalles de Gasto Fijo',
    recurring_expense_details_description: 'Configure los parámetros de este gasto fijo.',
    billing_and_cost: 'Facturación y Costo',
    attribution_and_schedule: 'Atribución y Programación',
    subtotal: 'Subtotal',
    suite: 'Suite',
    summary: 'Resumen',
    summary_and_send: 'Resumen y Envío',
    swimming_pool: 'Pileta',
    synced_inventory_items: 'Items de Inventario Sincronizados',
    table: 'Tabla',
    tag_category: 'Categoría de la Etiqueta',
    tag_id: 'ID de la Etiqueta',
    tag_name: 'Nombre de la Etiqueta',
    tag_source: 'Fuente de la Etiqueta',
    tag_value: 'Valor de la Etiqueta',
    tags: 'Categorías',
    takeoff: 'Salida',
    target_currency: 'Moneda de Destino',
    target_price: 'Precio Objetivo',
    target_email_message_id: 'Message-ID del email original',
    target_email_message_id_placeholder: 'ej. <CAH=vXh7z6Vp3P9@mail.gmail.com>',
    tariff_exclusivity_notice: 'Estas tarifas especiales están disponibles exclusivamente para este cliente',
    tariff_provider: 'Proveedor de Tarifas',
    tariffs: 'Tarifario',
    tariffs_email: 'Email para tarifario',
    tariffs_from: 'Tarifario de',
    task: 'Ticket',
    task_delete: 'Eliminar Tarea',
    task_delete_confirmation: '¿Estás seguro de eliminar la Tarea?',
    task_delete_confirmation_cancel: 'Cancelar',
    task_delete_confirmation_confirm: 'Eliminar',
    task_delete_confirmation_description: 'Esta acción no se puede deshacer',
    task_delete_error: 'Error al eliminar la Tarea',
    task_deleted: 'Tarea eliminada exitosamente',
    task_edit: 'Editar Tarea',
    task_show: 'Ver Tarea',
    tasks: 'Tickets',
    tax_name: 'Razon Social',
    tax_condition: 'Condición frente al IVA',
    tax_id: 'Identificación Fiscal',
    tax_id_number: 'Identificador Fiscal (CUIT/CUIL/DNI...)',
    receipt_number: 'Factura',
    receipt_number_label: "Ingresar Numero de Factura",
    tax_id_type: 'Tipo de Documento',
    template: 'Plantilla',
    template_content: 'Contenido del template',
    template_name: 'Nombre Template',
    template_name_placeholder: 'Ingresa un nombre para el template',
    templates: 'Plantillas',
    tenant_name: 'Nombre de la Cliente/Proveedor',
    text: 'Texto',
    theme_colors: 'Colores',
    they_paid_us: 'Nos Pagaron',
    this_action_cannot_be_undone: 'Esta acción es permanente',
    this_cost_applies_to_all_providers: 'Este costo se aplicará a todos los proveedores',
    this_discount_will_be_applied_to: 'Este descuento se aplicará a',
    this_is_a_payment: 'Este es un Pago',
    this_is_a_refund: 'Este es un Reembolso',
    this_price_applies_to_all_providers: 'Este precio se aplicará a todos los proveedores',
    this_price_applies_to_selected_provider_only: 'Este precio se aplicará a un proveedor específico',
    this_week_reservation: 'Reservas de esta semana',
    this_weeks_reservations: 'Reservas de esta Semana',
    threshold: 'Limite',
    thread_settings_title: 'Hilo de conversación (Opcional)',
    ticket: 'Ticket',
    ticket_content_placeholder: 'Describa el ticket (puede incluir links)',
    ticket_number: 'Número de Ticket',
    ticket_title_placeholder: 'Ingrese el título del ticket',
    ticketed: 'Facturado',
    tickets: 'Tickets',
    time: 'Hora',
    time_end: 'Fin de Horario',
    time_range: 'Horarios',
    time_start: 'Inicio de Horario',
    timeline: 'Itinerario',
    title: 'Título',
    to: 'A',
    to_businesses: 'A las cliente/proveedores',
    to_currency: 'Moneda de Destino',
    today: 'Hoy',
    today_service_orders: 'Ordenes de servicio de hoy',
    todays_bookings: 'Reservas de Hoy',
    todays_reservations: 'Reservas de hoy',
    todays_vehicle_schedule: 'Agenda de Vehículos de Hoy',
    todays_vehicles: 'Vehículos de Hoy',
    tomorrow_service_orders: 'Ordenes de servicio de mañana',
    total_after_exchange: 'Total después de cambio de moneda',
    total_before_exchange: 'Total antes de cambio de moneda',
    total_cost: 'Total de Costos',
    total_cost_paid: 'Costos Pagados',
    total_costs: 'Costos',
    total_costs_paid: 'Costos Pagados',
    total_income: 'Total Abonado',
    total_income_received: 'Ingresos Recibidos',
    total_my_businesses: 'Total de Cliente/Proveedores',
    total_passengers: 'Total de Pasajeros',
    passengers: "Paxs",
    total_pax: 'Total de Paxs',
    total_paxs: 'Total de Paxs',
    total_price: 'Precio Total',
    total_recipients: 'Total Destinatarios',
    total_refunded: 'Total Reembolsado',
    total_sells: 'Ventas',
    total_sells_paid: 'Ventas Pagadas',
    total_ticketed: 'Total Facturado',
    total_unpaid_sells: 'Ventas por cobrar',
    tour: 'Excursion',
    tour_path: 'Ruta del tour',
    tour_plural: 'Excursiones',
    tour_type: 'Tipo de Tour',
    tours: 'Excursiones',
    tours_available: 'Excursiones disponibles',
    train: 'Tren',
    transaction_amount: 'Monto de la Transacción',
    transaction_amount_exceeds_selected: 'El monto de la transacción excede el total de items seleccionados',
    transaction_amount_less_than_selected: 'El monto de la transacción es menor al total de items seleccionados',
    transaction_from: 'De',
    transaction_id: 'ID de Transacción',
    transaction_to: 'Para',
    transfer: 'Traslado',
    transfer_placeholder: 'VIP, Exclusivo, etc.',
    transfer_plural: 'Traslados',
    transfers: 'Traslados',
    transfers_available: 'Traslados disponibles',
    travel_stop: 'Parada',
    trip: 'Viaje',
    trip_reservations: 'Reservas de Viajes',
    trips: 'Viajes',
    type: 'Tipo',
    unassigned: 'Sin Asignar',
    unassigned_bookings: 'Bookings Sin Fecha Asignada',
    unassigned_services: 'Servicios sin Asignar',
    unavailable: 'No Disponible',
    undated: 'Sin Fecha Asiganada',
    undated_bookings: 'Reservas sin fecha',
    undated_services: 'Servicios sin fecha',
    unlimited: 'Ilimitado',
    unlink_payment: 'Registrar Impago',
    unlink_service_order: 'Desvincular Orden de Servicio',
    unlinked_only: 'Sin Asignar',
    unnamed_client: 'Cliente sin nombre',
    unpaid: 'Impago',
    unpaid_reservations: 'Reservas Impagas',
    unpaid_provider_costs: 'Costos Pendientes al Proveedor',
    no_unpaid_provider_costs_found: 'No se encontraron costos pendientes para este proveedor',
    cost_payment_status: 'Estado de Pago de Costo',
    linked_items: 'Vinculados',
    pending_costs: 'Costos Pendientes',
    paid_costs: 'Costos Pagados',
    client_payment_status: 'Cobro a Cliente',
    provider_cost_status: 'Pago a Proveedor',
    client_payment: 'Cobro a Cliente',
    provider_payment: 'Pago a Proveedor',
    no_client_payments: 'Sin cobros a cliente',
    no_provider_payments: 'Sin pagos a proveedores',
    pay_providers: 'Pagar a Proveedores',
    pay_provider: 'Pagar a Proveedor',
    select_provider_to_pay: 'Selecciona el proveedor a quien registrar el pago',
    no_pending_provider_costs: 'No hay costos de proveedor pendientes de pago',
    unsaved_changes: 'Cambios no guardados',
    unscheduled_services: 'Servicios sin Programar',
    unselect: 'Deseleccionar',
    unselect_all: 'Deseleccionar Todo',
    upcoming_reservations: 'Próximas Reservas',
    update_current_template: 'Actualizar plantilla actual',
    update_cost_manually: 'Actualizar Costo Manualmente',
    update_price_manually: 'Actualizar Precio Manualmente',
    update_progress: 'Progreso de Actualización',
    update_single_attribute: 'Actualizar un Atributo',
    update_start_time: 'Actualizar Hora de Salida',
    updated_at: 'Actualizado el',
    updated_by: 'Actualizado por',
    last_updated: 'Última actualización',
    updating: 'Actualizando',
    upload: 'Subir',
    upload_image: 'Subir Imagen',
    urgent: 'Urgente',
    use_booking_date: 'Fecha del Booking del Servicio',
    use_magic_link: 'Enviar enlace de acceso por correo',
    use_password_login: 'Iniciar sesión con contraseña',
    use_provider_price: 'Usar Precio de Proveedores',
    use_reservation_date: 'Fecha de la Reserva',
    user: 'Usuario',
    user_roles: {
        external: 'Externo',
        internal: 'Interno'
    },
    users: 'Usuarios',
    active_user: 'Usuario Activo',
    email_has_associated_user: 'Este correo electrónico tiene una cuenta de usuario asociada y no se puede modificar ni eliminar.',
    email_associated_with_user_account: 'Este email está asociado con una cuenta para {{name}}',
    this_email_is_used_to_login: 'Este email se usa para iniciar sesión',
    no_emails_configured_for_this_business: 'No hay correos electrónicos configurados para este negocio. Haz clic en el botón + de arriba para agregar uno.',
    users_settings_desc: 'Administra los usuarios, roles y permisos en tu espacio de trabajo.',
    users_with_access: 'Usuarios con Acceso',
    using_manual_rate: 'Usando tasa manual.',
    valid_from: 'Válido desde',
    valid_until: 'Válido hasta',
    validation: {
        emailInvalid: 'Email inválido',
        emailRequired: 'El email es requerido'
    },
    van: 'Van',
    van_rental: 'Alquiler de Van',
    van_rental_plural: 'Alquileres de Vans',
    vehicle_booking: 'Reserva de Vehículo',
    vehicle_cost: 'Costo del Vehículo',
    vehicle_details: 'Detalles del Vehículo',
    vehicle_information: 'Información del Vehículo',
    vehicle_not_found: 'Vehículo no encontrado',
    vehicle_not_selected: 'Vehículo no seleccionado',
    vehicle_type: 'Tipo de Vehículo',
    vehicles: 'Vehículos',
    vendor: 'Proveedor',
    vendors: 'Proveedores',
    view_all: 'Ver Todos',
    view_customer_portal: 'Ver Portal de Clientes',
    view_details: 'Ver Detalles',
    view_order: 'Ver Orden',
    view_payment: 'Ver Pago',
    view_public_tariffs: 'Ver Tarifario Público',
    view_ticket: 'Ver Ticket',
    viewer: 'Lector',
    villa: 'Villa',
    wallet_transfer: 'Billetera Digital',
    we_paid_them: 'Les Pagamos',
    welcome: 'Bienvenido',
    last_checked: 'Última actualización',
    just_now: 'Hace un momento',
    ago: 'atrás',
    what_are_you_looking_for: '¿Qué estás buscando?',
    when: 'Cuando',
    when_question: 'Cuando?',
    where: 'Donde',
    who: 'Quién',
    who_owns_this_inventory_item: 'Seleccionar Cliente/Proveedor',
    who_question: 'Quién?',
    wifi: 'Wifi',
    with_and_without_dates: 'Con y Sin Fechas',
    with_dates: 'Solo Con Fechas',
    with_services: 'Con servicios',
    with_vehicles: 'Con vehículos',
    without_dates: 'Solo Sin Fechas',
    without_service_order: 'Sin Orden de Servicio',
    without_services: 'Sin servicios',
    workspace_name: 'Nombre del Grupo de Trabajo',
    yes: 'Si',
    yes_save_to_linked: 'Sí, guardar en el servicio conectado',
    yoga: 'Yoga',
    yoga_class: 'Clase de Yoga',
    yoga_class_plural: 'Clases de Yoga',
    yoga_plural: 'Yogas',
    your_company: 'Tu cliente/proveedor',
    your_name: 'Tu nombre',
    zero_assigned: '0 asignados',
    price_by_null: '',
    back_to_list: "Volver a la lista",
    service_discounts_desc: 'Solo estos descuentos están guardados y aplicados explícitamente a este servicio.',
    apply_all_defaults: 'Aplicar todos los valores por defecto del Tenant',
    no_discounts_configured: 'Aún no hay descuentos personalizados configurados para este servicio. Se aplicará 0% de descuento por defecto.',
    available_tenant_categories: 'Categorías de Descuento Disponibles',
    available_tenant_categories_desc: 'Estas categorías existen globalmente en la configuración pero NO están activas para este servicio.',
    all_categories_assigned: 'Todas las categorías del tenant están configuradas para este servicio.',
    default_percentages: 'Porcentajes por Defecto',
    name_public_optional: "Nombre Publico (Opcional)",
    name_public_desc: "Este será el nombre que aparezca en los manifiestos. Dejar vacio para usar el default.",
    payment_from: "Realizado por",
    payment_to: "Enviado a",
    paxs_list: "Lista de Pasajeros",
    add_to_booking: "Agregar al booking",
    remove_from_bookings: "Sacar del booking",
    not_linked_in_reservation: "Sin vincular en la Reserva",
    package: "Paquete",
    copy: "Copiar",
    "copied!": "Copiado!",
    add_notes: "Agregar Notas",
    external_code: "Código Externo",
    add_external_code: "Código Externo",
    external_code_placeholder: "Ingresar código externo...",
    product: "Producto",
    add_product: "Agregar Producto",
    create_product: "Crear Producto",
    edit_product: "Editar Producto",
    product_name: "Nombre del Producto",
    linked_services: "Servicios Vinculados",
    book_linked_services_question: "¿Reservar también estos servicios vinculados?",
    no_linked_services: "Sin servicios vinculados",
    add_linked_service: "Agregar Servicio Vinculado",
    cannot_link_service_to_itself: "No se puede vincular un servicio a sí mismo",
    service_linked_successfully: "Servicio vinculado exitosamente",
    service_link_removed: "Servicio vinculado eliminado",
    service_already_linked: "Este servicio ya se encuentra vinculado",
    no_products_yet: "Aún no hay productos",
    products_description: "Los productos te permiten agrupar servicios para visualizarlos y gestionarlos de forma unificada.",
    no_services_linked: "Sin servicios vinculados",
    product_not_found: "Producto no encontrado",
    selected_services_count: "{{count}} servicio(s) seleccionado(s)",
    assigned_to_other_product: "Asignado a otro producto",
    no_product: "Sin Producto",
    group_by_product: "Agrupar por Producto",
    confirm_delete_product: "¿Estás seguro de que deseas eliminar este producto?",
    delete_product: "Eliminar producto",
    unlink_service: "Desvincular servicio",
    names: "Nombres",
    reset_price_desc: "¡Esta acción eliminará cualquier precio manual y hará que el sistema vuelva a calcular el precio basándose en el tarifario!",
    back: "Atras",
    search_payments: "Buscar en pagos...",
    row_display_options: 'Opciones de Visualización',
    attributes_to_show: 'Atributos a mostrar',
    show_pax_phone: 'Mostrar Teléfono',
    show_pax_email: 'Mostrar Email',
    show_provider: 'Proveedor',
    show_coordinator: 'Coordinador',
    please_select_date_range: 'Por favor, seleccione un rango de fechas para cargar reservas.',
    please_select_end_date: 'Por favor, seleccione la fecha de fin.',
    select_active_starts_or_ends: 'Seleccione una fecha activa o rango de fechas para inspeccionar reservas.',
    no_service_bookings_found: 'No se encontraron reservas de servicio con los filtros seleccionados.',
    group_by_category: 'Agrupar por Categoría',
    ungrouped: 'Sin agrupar',
    compress_identical: 'Comprimir idénticos',
    uncompress_identical: 'Descomprimir idénticos',
    identical_services_group: 'Servicios idénticos',
    identical_bookings_count: '{{count}} bookings',
    unit_price: 'c/u',
    expand: 'Expandir',
    hide_package_parents: 'Ocultar Paquetes',
    slim_layout: 'Diseño Compacto',
    estimated_revenue: 'Ingresos Estimados',
    total_bookings: 'Total de Reservas',
    search_placeholder: 'Buscar por pasajero, cliente, ID de reserva, servicio...',
    search_and_filters: 'Búsqueda y Filtros',
    requires_at_least_one_active: 'Requiere al menos una selección de rango de fechas',
    show_service_title: 'Título de Servicio',
    show_service_order: 'Orden de Servicio',
    show_reservation: 'Reserva',
    show_client_name: 'Nombre del Cliente',
    show_paxs: 'Pasajeros',
    show_pax_name: 'Nombres de Pasajeros',
    show_hour: 'Hora',
    show_price: 'Precio',
    ascending: 'Ascendente',
    descending: 'Descendente',
    sort_up: 'Ascendente',
    sort_down: 'Descendente',
    ids: 'IDs',
    group_by_reservation: 'Agrupar por Reserva',
    grouping: 'Agrupamiento',
    show_booking_id: 'ID de Booking',
    show_payment_status: 'Estado de Pago',
    search_by_reservation_dates: 'Buscar por Fechas de Reserva',
    search_by_booking_dates: 'Buscar por Fechas de Booking',
    general_service_info: 'Servicio y General',
    reservation_client: 'Reserva y Cliente',
    finance: 'Finanzas',
    reservations_export: 'Buscador de Reservas',
    title_big_or_small: "Título de Servicio Grande",
    allow_edit: 'Habilitar Edición',
    allow_online_reservations: 'Permitir Reservas Online',
    group_by_paxs: 'Agrupar por Pasajeros',
    no_paxs_specified: 'Sin pasajeros especificados',
    reservation_passengers: 'Reserva / Pasajeros',
    booking_start_date: "Fecha Asignada al Servicio",
    show_cost: "Mostrar Costo",
    hide_service_title: "Ocultar Servicio",
    add_to_all_bookings: "Agregar a Todos los Bookings",
    remove_from_all_bookings: "Quitar de Todos los Bookings",
    booking_dates: 'Fechas de Booking',
    presets_templates: 'Plantillas y Ajustes',
    save_preset: 'Guardar Filtro',
    display_settings: 'Ajustes de Visualizacion',
    visible_columns: 'Columnas Visibles',
    price_updated: 'Precio Actualizado',
    reset_defaults: 'Restablecer Valores Predeterminados',
    print: 'Imprimir',
    columns: "Columnas",
    group_by: "Agrupar",
    booking_code: "Codigo de Reserva",
    reservations_as_client: "Reservas como Cliente",
    bookings_as_provider: "Reservas como Proveedor",
    no_bookings: "Sin servicios registrados",
    register_payment: "Registrar Pago",
    register_payment_from_client: "Pago de Cliente",
    register_payment_to_provider: "Pago a Proveedor",
    create_payment_reminder: "Recordatorio de Pago",
    add_new_business: "Cliente o Proveedor",
    add_new_pax: "Agregar Pasajero",
    add_new_inventory_item: "Agregar Elemento de Inventario",
    new_task: "Nuevo Ticket",
    paid_on: "Fecha de Pago",
    reservations_as_passenger: "Reservas como Pasajero",
    active_during_date: "Activa en la Fecha",
    bookings_matrix: "Matriz de Reservas",
    service_orders_matrix: "Matriz de Órdenes",
    unassigned_pax: "Pasajeros sin asignar",
    unassigned_client: "Clientes sin asignar",
    unassigned_coordinator: "Coordinador sin asignar",
    unassigned_inventory: "Inventario sin asignar",
    owes_to: "debe a",
    settled: "Saldado",
    received: 'Recibido',
    from_them: 'de ellos',
    to_them: 'a ellos',
    no_service_order: "Sin Orden de Servicio",
    service_id: "Servicio",
    service_id_sort: "ID",
    flight: 'Vuelo',
    flight_in: 'Vuelo de Llegada',
    flight_out: 'Vuelo de Salida',
    bus_departure_location: "Bus: Origen",
    bus_departure_time: "Bus: Hora Salida",
    bus_arrival_location: "Bus: Destino",
    bus_arrival_time: "Bus: Hora Llegada",
    bus_brand: "Bus: Cliente/Proveedor",
    bus_number: 'Bus: Numero',
    client_name: "Nombre del Cliente",
    pax_name: "Nombre del Pasajero",
    pax_phone: "Telefono del Pasajero",
    pax_email: "Email del Pasajero",
    booking_id: "Booking ID",
    nothing_consumed_or_paid_yet: "Sin consumos o pagos.",
    purchases: "Compras",
    payed: "Pagado",
    ingress: "Entrada",
    egress: "Salida",
    select_option: "Seleccionar",
    dashboard_subtitle: 'Acceso rápido a operaciones y asignaciones.',
    active_assignments: 'asignaciones activas',
    view_assignments: 'Ver asignaciones',
    quick_actions_subtitle: 'Crea nuevas reservas, pagos, órdenes de servicio, negocios u otros recursos de forma rápida.',
    new_reservation_desc: 'Crear una reserva confirmada',
    new_pending_reservation_desc: 'Crear una reserva en estado pendiente',
    new_payment_desc: 'Registrar un cobro o pago de cliente',
    new_service_order_desc: 'Crear una nueva orden de servicio para organizar pax',
    new_business_desc: 'Registrar un nuevo proveedor, cliente corporativo o agencia',
    new_pax_desc: 'Registrar los datos de un pasajero recurrente',
    new_service_desc: 'Crear una nueva excursión, traslado, o actividad de catálogo',
    new_inventory_item_desc: 'Agregar un vehículo, habitación, o guía asignable',
    new_task_desc: 'Crear una tarea de seguimiento en el tablero de control',
    buy_page_desc: 'Acceder al cotizador y realizar reservas en vivo',
    payment_log: "Registro de Pago",
    magic_link_description: "Ingresa tu correo electrónico y te enviaremos un enlace seguro para iniciar sesión al instante.",
    'magic-link-sent-description': 'Hemos enviado un enlace de acceso a tu correo. Por favor revisa tu bandeja de entrada.',
    send_magic_link: 'Enviar Enlace de Acceso',
    verifying_session: 'Verificando enlace...',
    verifying_session_desc: 'Por favor espera mientras iniciamos sesión.',
    create_account_link: "¿No tienes una cuenta? Regístrate",
    create_account_description: "Ingresa tu correo electrónico para verificar un negocio registrado y crear tu cuenta.",
    back_to_login: "Volver a Iniciar Sesión",
    user_exists_title: "La Cuenta ya Existe",
    user_exists_desc: "Ya existe una cuenta registrada con este correo electrónico. Por favor inicia sesión.",
    no_business_found_title: "Negocio no Encontrado",
    no_business_found_desc: "Este correo electrónico no está registrado con ningún negocio de Turizi. Por favor contacta a tu administrador.",
    try_another_email: "Probar con otro Correo",
    business_found_title: "Negocio Encontrado",
    business_found_desc: "Encontramos un negocio registrado asociado a tu dirección de correo electrónico.",
    are_you_part_of_business: "¿Formas parte de este negocio?",
    yes_create_account: "Sí, crear mi cuenta",
    no_go_back: "No, volver atrás",
    account_created_title: "¡Cuenta Creada!",
    not_found: "No encontrado",
    go_back: "Volver atrás",
    business_not_found: "Negocio no encontrado",
    reservation_not_found: "Reserva no encontrada",
    assigments_overview: "Resumen de Asignaciones",
    assigments_overview_subtitle: "Monitorea los servicios asignados a tu personal.",
    available_3rd_party: "Disponible para Terceros",
    trip_start_day: "Reserva - Día de Inicio",
    trip_end_day: "Reserva - Día de Fin",
    child_bookings: "Servicios del Paquete",
    balance_dates: "Periodo",
    all_history: "Todo el Historial",
    select_dates: "Seleccionar Fechas",
    decrease_font_size: "Disminuir tamaño de letra",
    increase_font_size: "Aumentar tamaño de letra",
    premium_feature_title: "Función Premium",
    paying_customers_only_heading: "Solo Clientes Premium",
    paying_customers_only_description: "Esta función solo está disponible para clientes de pago. Contáctanos en hola@turizi.com para actualizar tu cuenta y desbloquear todas las funciones premium.",
    ops_view: "Vista de Operaciones",
    self_reservation: "Nueva Reserva",
    buy_from_3rd_party: "Nueva Compra",
    tax_settings: "Configuración de Impuestos",
    arg_tax_settings_desc: "Configura la integración AFIP/ARCA para la facturación electrónica en Argentina.",
    afip_arca_settings: "Configuración de ARCA / AFIP (Argentina)",
    afip_arca_settings_desc: "Permite automatizar la creación del certificado y autorizar el Web Service de Factura Electrónica (wsfe).",
    afip_sdk_token: "Token de Acceso de Afip SDK",
    cuit: "CUIT",
    arca_username: "CUIT del Usuario de ARCA (Clave Fiscal)",
    arca_password: "Clave Fiscal de ARCA",
    alias: "Alias del Certificado",
    environment: "Entorno",
    homologation: "Homologación (Pruebas)",
    production: "Producción",
    generate_certificate: "Generar Certificado",
    authorize_web_service: "Autorizar Servicio Web",
    certificate_generated: "Certificado Generado",
    service_authorized: "Servicio Autorizado (wsfe)",
    save_settings: "Guardar Configuración",
    generating_certificate: "Generando certificado...",
    authorizing_service: "Autorizando servicio...",
    certificate_generated_success: "Certificado generado con éxito",
    service_authorized_success: "Servicio web autorizado con éxito",
    error_generating_certificate: "Error al generar el certificado",
    error_authorizing_service: "Error al autorizar el servicio web",
    afip_error_detail: "Detalle del Error de Integración de AFIP",
    afip_error_desc: "El servidor devolvió el siguiente error detallado de validación al comunicarse con la API de Afip SDK:",
    integration_steps_title: "Pasos y Estado de la Integración",
    integration_steps_desc: "Sigue estos pasos para completar tu integración de facturación electrónica con ARCA/AFIP.",
    step_save_credentials: "1. Guardar Credenciales",
    saved: "Guardado",
    pending_config: "Configuración Pendiente",
    step_save_credentials_desc: "Completa el entorno y tus credenciales de ARCA en el formulario de abajo y haz clic en el botón \"Guardar Configuración\" al final.",
    step_generate_certificate: "2. Generar Certificado Digital",
    certificate_active: "Certificado Activo",
    pending_generation: "Generación Pendiente",
    step_generate_certificate_desc: "Genera el certificado SSL y la clave privada requeridos para autenticar las solicitudes ante ARCA.",
    step_authorize_service: "3. Autorizar Servicio Web",
    service_authorized_badge: "Servicio Autorizado (wsfe)",
    pending_authorization: "Autorización Pendiente",
    step_authorize_service_desc: "Autoriza el Web Service de Factura Electrónica (wsfe) utilizando el certificado digital generado.",
    step_create_sales_point: "4. Crear Punto de Venta",
    step_create_sales_point_desc: "Crea un punto de venta directamente en ARCA utilizando tus credenciales.",
    create_sales_point_btn: "Crear Punto de Venta",
    pos_auto_config_info: "Turizi escaneará automáticamente tus puntos de venta existentes en ARCA/AFIP, identificará el próximo número disponible, registrará un punto de venta dedicado (llamado \"Turizi POS\") para esta integración y guardará un registro del resto de tus puntos de venta.",
    auto_configure_sales_point_btn: "Autoconfigurar Punto de Venta",
    other_detected_sales_points: "Otros Puntos de Venta Detectados",
    sales_point_number: "Número del Punto de Venta",
    sales_point_name: "Nombre del Punto de Venta",
    sales_point_system: "Sistema de Facturación",
    sales_point_address: "Domicilio Registrado",
    sales_point_address_placeholder: "Selecciona o escribe el domicilio declarado en ARCA",
    sales_point_address_hint: "Domicilio fiscal o sucursal registrado en el Sistema Registral de ARCA para este CUIT.",
    sales_point_created_success: "¡Punto de venta creado con éxito!",
    sales_point_active: "Punto de Venta Creado",
    pending_sales_point: "Creación Pendiente",
    error_creating_sales_point: "Error al crear el punto de venta",
    add_sales_point: "Agregar Punto de Venta",
    edit_sales_point: "Editar Punto de Venta",
    delete_sales_point: "Eliminar Punto de Venta",
    configured_sales_points: "Puntos de Venta Configurados",
    no_sales_points_configured: "No hay puntos de venta configurados.",
    confirm_delete_sales_point: "¿Estás seguro de que deseas eliminar este punto de venta?",
    sales_points_section_title: "Puntos de Venta (POS)",
    sales_points_section_desc: "Administra los puntos de venta de AFIP / ARCA y configúralos para su uso en los servicios de Turizi.",
    afip_previous_sales_points_title: "Puntos de Venta Cargados desde AFIP / ARCA",
    afip_previous_sales_points_desc: "Puntos de venta existentes en AFIP asociados a tu CUIT. Puedes importarlos para usarlos en Turizi.",
    env_production_portal: "Portal ARCA (Producción)",
    homologation_pos_notice_title: "Entorno de Pruebas (Homologación)",
    homologation_pos_notice_desc: "Los puntos de venta listados abajo se obtienen directamente del portal oficial de ARCA (Producción). Al encontrarte en modo Homologación, el Web Service de AFIP te permite emitir comprobantes de prueba con cualquier número de punto de venta configurado en Turizi.",
    sync_afip_sales_points_btn: "Cargar / Sincronizar desde AFIP",
    sync_afip_sales_points_success: "Puntos de venta sincronizados desde AFIP correctamente",
    sync_afip_sales_points_error: "Error al sincronizar puntos de venta desde AFIP",
    already_configured_in_turizi: "Configurado",
    requires_web_services: "Requiere Web Services",
    no_sales_points_configured_hint: "No hay puntos de venta configurados para facturar.",
    create_afip_sales_point_modal_title: "Crear Punto de Venta en AFIP / ARCA",
    create_afip_sales_point_modal_desc: "Ingresa el nombre de fantasía para registrar un nuevo punto de venta oficial en tu cuenta de AFIP / ARCA habilitado para Web Services.",
    create_in_afip_btn: "Crear en AFIP",
    origin_afip: "AFIP (Preexistente)",
    origin_user: "Creado por Usuario",
    origin_label: "Origen",
    status_in_afip: "Estado AFIP",
    no_afip_points_loaded: "No se han cargado puntos de venta desde AFIP aún. Haz clic en 'Cargar / Sincronizar desde AFIP' para consultar tus puntos de venta existentes en ARCA.",
    view_certificate: "Ver Certificado",
    copy_certificate: "Copiar Certificado",
    certificate_copied_success: "Certificado copiado al portapapeles",
    certificate_modal_title: "Certificado SSL Generado",
    certificate_modal_desc: "Este es el certificado SSL generado para tu integración. Puedes copiarlo si lo necesitas para configuraciones manuales.",
    generate_invoice: "Generar Factura Electrónica (AFIP)",
    generate_invoice_desc: "Crea y autoriza facturas electrónicas directamente ante ARCA / AFIP utilizando tu certificado digital activo.",
    receiver_section: "Receptor / Cliente",
    select_client_selector: "Seleccionar Cliente (Pax/Negocio)",
    manual_entry_toggle: "Ingresar datos del receptor manualmente",
    receiver_name: "Nombre del Receptor / Razón Social",
    invoice_details_section: "Detalles del Comprobante",
    invoice_type: "Tipo de Comprobante",
    pos_label: "Punto de Venta",
    select_pos_placeholder: "Seleccione Punto de Venta",
    pos_required_error: "Debe seleccionar un Punto de Venta",
    concept_label: "Concepto",
    invoice_description_label: "Descripción / Detalle",
    invoice_description_placeholder: "Ej: Facturación de Servicios",
    amounts_section: "Montos",
    tax_net_amount: "Neto Gravado",
    iva_rate: "Alícuota de IVA",
    iva_amount: "Importe IVA",
    total_amount: "Importe Total",
    generate_button: "Generar Factura",
    invoice_generated_success: "Factura generada con éxito",
    invoice_number_result: "Número de Factura",
    cae_result: "CAE",
    cae_expiration_result: "Vencimiento CAE",
    factura_a_requires_cuit: "Factura A requiere que el tipo de documento sea CUIT.",
    success: "Éxito",
    invalid_doc_number: "Por favor, ingrese un número de documento válido.",
    download: "Descargar",
    no_vouchers: "No se encontraron comprobantes",
    afip_vouchers: "Comprobantes AFIP",
    receiver: "Receptor",
    delete_payment: "Borrar Pago",
    are_you_sure_delete_payment: "¿Estás seguro que querés borrar el pago?",
    delete_payment_warning: "Una vez eliminado, este registro de pago no se podrá recuperar.",
    it_provider: "Proveedor de TI",
    gas_station: "Estación de Servicio",
    last_payment: "Último Pago",
    next_payment: "Próximo Pago",
    no_payments_registered: "Sin pagos registrados",
    payments_for_recurring_expense_description: "Pagos registrados específicamente para este gasto recurrente.",
    add_payment_for_this_expense: "Registrar Pago",
    register_payment_for_recurring_expense: "Registrar Pago de Gasto Recurrente",
    due: "Vence",
    debt_percentage: "Porcentaje de Deuda",
    coverage: "Cobertura",
    total_consumption: "Consumo Total",
    covers: "cubre",
    of_total_consumption: "del consumo total",
    reconciliation: "Conciliación",
    outstanding: "Pendiente",
    outstanding_percentage: "% Pendiente",
    total_billed: "Facturación Total",
    of_total_billed: "de la facturación total",
    past_reservations: "Reservas Pasadas",
    future_reservations: "Reservas Futuras",
    all_reservations: "Todas las Reservas",
    reconciliation_explainer_title: "Explicación de Conciliación Automática",
    reconciliation_explainer_desc: "El sistema de conciliación asocia los servicios facturados con los cobros registrados para calcular el saldo pendiente.",
    reconciliation_formula: "Fórmula de Cálculo",
    bookings_found_sales: "Vendimos {{count}} reservas por un total de {{amount}}",
    bookings_found_purchases: "Compramos {{count}} reservas por un total de {{amount}}",
    payments_found_received: "Recibimos {{count}} cobros por un total de {{amount}}",
    payments_found_sent: "Enviamos {{count}} pagos por un total de {{amount}}",
    reconciliation_details: "Detalles de Conciliación",
    debits: "Débitos (Valor entregado / pago realizado)",
    credits: "Créditos (Valor recibido / cobro realizado)",
    total_debits: "Total Débitos",
    total_credits: "Total Créditos",
    we_owe_client: "Debemos",
    client_owes_us: "Nos deben",
    override_payment_status: "Establecer como {{status}}",
    payments_sent: "Pagos Enviados",
    payments_received: "Cobros Recibidos",
    by_period: "por período",
    linked_paxs: "Pasajeros Vinculados",
    no_linked_paxs: "No hay pasajeros vinculados a esta reserva aún",
    please_add_paxs_from_the_reservation: "Agregue pasajeros desde la reserva a la derecha",
    all_reservation_paxs_linked: "Todos los pasajeros de la reserva están vinculados",
    add_passengers: "Agregar Pasajeros",
    from_reservation: "Desde la Reserva",
    send_settlement_by_email: "Enviar Por Mail",
    send_settlement: "Enviar liquidación",
    sending_history: "Historial de envíos",
    loading_history: "Cargando historial...",
    no_sending_history: "Sin historial de envíos de email.",
    reservation_issues: "Errores de Reserva",
    we_detected_reservation_issues: "Detectamos {{count}} reservas con datos incompletos o inconsistentes.",
    no_client_assigned: "Sin cliente asignado (Persona o Cliente/Proveedor)",
    no_start_date: "Sin fecha de inicio",
    issues: "Errores",
    financial_issues: "Errores Financieras",
    pax_issues: "Errores de Pasajeros",
    business_issues: "Errores de Cliente/Proveedores",
    duplicate_businesses: "Cliente/Proveedores Duplicadas",
    no_duplicate_businesses_found: "No se encontraron cliente/proveedores duplicadas.",
    pax_business_issues: "Errores de Pasajeros y Cliente/Proveedores",
    no_pax_business_issues_found: "No se encontraron errores de nombre entre pasajeros y cliente/proveedores.",
    service_issues: "Errores de Servicios",
    services_without_providers: "Servicios con costo pero sin proveedores",
    service_has_costs_no_providers: "Este servicio tiene costos de venta configurados pero no tiene ningún proveedor asignado.",
    duplicate_pax_desc: "Registros de pasajeros con el mismo nombre y apellido.",
    missing_lastname_desc: "El pasajero no tiene un apellido registrado (solo posee un único nombre).",
    duplicate_business_desc: "Cliente/Proveedores registradas con la misma razón social o nombre comercial.",
    pax_business_conflict_desc: "Conflicto de nombre: Existen personas y cliente/proveedores registradas con el mismo nombre exacto.",
    reservation_issues_desc: "Reservas con datos incompletos, faltantes o inconsistencias de facturación.",
    service_issues_desc: "Servicios activos con costos pero sin proveedores configurados.",
    validation_costs_without_providers: "Sin COSTOS.",
    validation_no_price_by_nor_cost_by: "Sin COSTOS activos.",
    validation_no_active_sell_price: "Sin PRECIOS activos.",
    validation_booking_no_provider_with_cost: "Reserva de Servicio #{{bookingId}}: Sin proveedor seleccionado, pero tiene un costo de {{amount}} {{currency}}.",
    validation_booking_cost_higher_than_sell: "Reserva de Servicio #{{bookingId}}: El costo ({{cost}}) es mayor que el precio de venta ({{sellPrice}}).",
    no_service_issues_found: "No se encontraron errores de servicios.",
    no_issues_found: "No se encontraron Errores.",
    emails_and_accounts: "Emails y Cuentas",
    login_popup_title: "Área de Clientes y Socios",
    login_popup_text_1: "Inicia sesión",
    login_popup_text_2: "para acceder a tus tarifas especiales, consultar tu saldo actual y gestionar tus reservas.",
    reservations_as_pax: "Reservas como Pasajero",
    no_payments: "sin pagos",
    clean_filters: "Sacar Filtros",
    add_to_simulator: "Agregar al presupuesto",
    remove_from_simulator: "Sacar del presupuesto",
    true: 'Sí',
    false: 'No',
    included_in_package: "Incluido en el Paquete",
    child_booking_price_tooltip: "El precio de este servicio está incluido en el paquete principal.",
    create_child_reservation: "Crear Reserva Derivada",
    flights: "Vuelos",
    scheduled_short: "Prog.",
    projected_short: "Proyectado",
    actual_short: "Real",
    period_summary: "Resumen del Período",
    payments_applied: "Pagos Aplicados",
    total_reservations_amount: "Total de Reservas",
    link_reservation: "Vincular Reserva",
    unlink_reservation: "Desvincular Reserva",
    enter_reservation_id: "Ingrese el ID de la reserva (ej: 1234)...",
    reservation_already_linked: "La reserva ya se encuentra vinculada",
    period_balance_email_desc: 'Se enviará un resumen con las reservas e importes correspondientes al período seleccionado.',
    all_balance_email_desc: 'Se enviará el estado de cuenta consolidado con el saldo total acumulado a la fecha.',
    document_number: "Nro. Documento",
    round_trip: 'Ida y Vuelta',
    bus: 'Bus',
    minibus: 'Minibus',
    motorhome: 'Motorhome',
    truck: 'Camión',
    delete_link: "Eliminar vínculo",
    edit_applied_amount: "Editar monto aplicado",
    amount_must_be_greater_than_zero: "Debe ser mayor a 0",
    no_attachments: "Sin archivos adjuntos",
    amount_to_link: "Monto a vincular",
    add_note: "Agregar nota",
    edit_note: "Editar nota",
    no_notes: "Sin notas agregadas",
    no_linked_reservations: "Sin reservas vinculadas",
    unallocated_balance: "Saldo sin asignar",
    unassigned_money: "Dinero sin asignar",
    assigned_to_reservations: "Asignado a reservas",
    fully_linked: "Totalmente vinculado",
    partially_linked: "Parcialmente vinculado",
    not_linked: "Sin vincular",
    fully_allocated: "Totalmente asignado",
    over_allocated: "Monto excedido",
    search_payments_placeholder: "Buscar por ID, pagador, destinatario, monto...",
    filter_by_allocation: "Filtrar por asignación",
    allocation_status: "Asignación",
    assigments_desc: "Mis viajes, reservas y paxs para Hoy, Mañana, etc",
    money_sent: "Dinero Enviado",
    money_received: "Dinero Recibido",
    total_money_received: "Total de Dinero Recibido",
    no_costs: "Sin Gastos",
    providers_payments: "Pago a Proveedores",
    payments_count: "{{count}} pagos",
    total_payments_count: "Total de Pagos",
    affected_payments: "Pagos Vinculados",
    unaffected_payments: "Pagos Sin Vincular",
    unaffected_payments_desc: "Pagos que no están afectando a ninguna reserva u orden",
    no_unaffected_payments: "Todos los pagos están afectando ítems (sin pagos libres)",
    unaffected_payments_list: "Listado de Pagos Sin Afectar",
    auto_assign: "Auto Asignar",
    auto_assign_payments: "Auto Asignar Pagos",
    auto_assign_payments_title: "Asignación Automática de Pagos",
    auto_assign_payments_desc: "Asigna automáticamente los pagos sin afectar a las reservas u órdenes impagas más antiguas.",
    calculating_auto_assignments: "Analizando pagos y buscando coincidencias...",
    auto_assign_no_payments_to_assign: "No se encontraron pagos con asignaciones posibles.",
    auto_assign_confirm: "Confirmar Asignación",
    auto_assign_confirm_count: "Confirmar Asignación ({{count}})",
    payments_auto_assigned_success: "Los pagos fueron asignados exitosamente.",
    payments_auto_assigned_error: "Ocurrió un error al asignar los pagos.",
    unassigned_reason_zero_amount: "El monto del pago es 0",
    unassigned_reason_internal_transfer: "Transferencia interna entre cuentas propias",
    unassigned_reason_missing_client: "No se identificó el cliente del pago",
    unassigned_reason_missing_provider: "No se identificó el proveedor del pago",
    unassigned_reason_unknown_direction: "No se pudo determinar el sentido del pago",
    unassigned_reason_no_matching_unpaid_reservations: "Sin reservas impagas en la misma moneda",
    unassigned_reason_no_matching_unpaid_bookings: "Sin órdenes impagas en la misma moneda",
    will_assign: "Se asignará",
    partial_assignment: "Asignación parcial",
    cannot_assign: "No asignable",
    remains_unallocated: "quedará sin asignar",
    assignments_preview: "Previsualización de Asignaciones",
    total_to_assign: "Total a asignar",
    target_item: "Ítem destino",
    balance_before_after: "Saldo pendiente",
    can_assign: "Asignables",
    unassignable: "No asignables",
    analyzed_payments: "Pagos analizados",
    overpaid_discrepancy_title: "Aviso de Cobro Excedido / Sobrepago",
    overpaid_discrepancy_desc: "El monto pagado registrado supera el valor total de ventas debido a reservas con sobrepagos o cobros adicionales.",
    overpaid_amount: "Monto Excedido",
    over_allocated_payments: "Pagos Sobreasignados",
    over_allocated_payments_desc: "Pagos cuyo monto asignado a reservas u órdenes supera el total del pago",
    over_allocated_payments_list: "Listado de Pagos Sobreasignados",
    allocated_amount: "Monto Asignado",
    selected_as_provider: "Como proveedor",
    business_already_exists: "Ya existe una cliente/proveedor con este nombre",
    existing_business_matches: "Clientes/Proveedores existentes",
    no_matching_business_found: "No hay conioncidencias",
    type_to_search: "Escribe al menos 3 caracteres para buscar",
    observations: "Notas",
    deleted_reservations: "Reservas eliminadas",
    deleted_reservation: "Reserva eliminada",
    deleted_by: "Eliminado por",
    deleted_at: "Fecha de eliminación",
    deleted_reservation_banner: "Esta reserva fue eliminada el {{date}} por {{user}}.",
    no_deleted_reservations: "No hay reservas eliminadas",
    original_reservation_id: "ID Reserva Original",
    linked_pax: "Pasajero Vinculado",
    linked_business: "Cliente/Proveedor Vinculado",
    document: "Documento",
    document_type: "Tipo de Documento",
    send_email_campaign: "Enviar Campaña por Email",
    no_emails_selected: "Ningún email seleccionado",
    sent_email_history: "Historial de Envíos",
    deselect_all: "Deseleccionar todos",
    detailed_title: "Título Grande",
    no_emails_configured: "No hay emails configurados para esta empresa",
    select_recipient_emails: "Seleccionar Destinatarios",
    no_emails_sent_yet: "Aún no se enviaron emails",
    step_1_pax: "Pasajeros",
    step_1_pax_dates: "Pasajeros y Fechas",
    step_2_select_service: "Seleccionar Servicio",
    step_3_booking_attrs: "Atributos y Detalles",
    step_next: "Siguiente",
    step_back: "Anterior",
    select_a_service: "Seleccionar un servicio",
    no_attrs_required: "No hay atributos adicionales requeridos",
    search_service_placeholder: "Buscar servicio...",
    no_services_found: "No se encontraron servicios",
    per_person: "por Persona",
    from_date: "Desde",
    to_date: "Hasta",
    back_to_tickets: "Volver a Tickets",
    priority: "Prioridad",
    delete_ticket: "Eliminar Ticket",
    delete_ticket_desc: "Una vez eliminado, este ticket no se podrá recuperar.",
    ticket_saved_success: "Ticket guardado con éxito",
    ticket_updated_success: "Ticket actualizado con éxito",
    opened_on: "abrió este ticket el",
    price_modifiers: "Ajustes de precio",
    add_price_modifier: "Agregar ajuste de precio",
    remove_price_modifier: "Eliminar ajuste de precio",
    price_modifier_section: "Sección",
    price_modifier_type: "Tipo de ajuste",
    price_modifier_value: "Monto / Valor",
    price_modifier_description: "Descripción",
    price_modifier_currency: "Moneda",
    fixed_amount: "Monto fijo",
    taxes: "Impuestos",
    manual_adjustment: "Ajuste Manual",
    voucher: "Voucher / Cupón",
    surcharge: "Recargo",
    fee: "Tasa / Tarifa",
    add_modifier: "Ajuste",
    confirm_delete_price_modifier: "¿Está seguro de eliminar este ajuste de precio?",
    price_modifier_added: "Ajuste de precio agregado exitosamente",
    price_modifier_deleted: "Ajuste de precio eliminado",
    no_price_modifiers: "Sin ajustes de precio",
    all_currencies: "Todas las monedas",
    modifier_operation: "Operación",
    price_modifier_placeholder: "Ej: IVA 21%, Descuento contado",
    service_bookings_subtotal: "Subtotal servicios",
    itemized_bookings: "Detalle de servicios",
    original_amount: "Monto Original",
    modify_price: "Modificar Precio",
    modify_prices: "Modificar Precios",
    multiply_current_price_by_factor: "Multiplicar el precio actual por este factor",
    services_with_modified_prices: "Servicios con Precios Modificados",
    no_active_price_found: "Sin precio activo",
    no_services_with_active_price: "Ninguno de los servicios seleccionados tiene un precio activo",
    current_price: "Precio actual",
    modified_price: "Precio modificado",
    keep_current_date: "Mantener fecha actual",
    price_amount_currency: "Monto de Precio / Moneda",
    price_start_day: "Fecha Inicio Precio",
    price_end_day: "Fecha Fin Precio",
    date_asc: "Fecha Ascendente",
    date_desc: "Fecha Descendente",
    client_view_public: "Vista Cliente",
    print_view: "Vista Imprimible",
    default: "General",
    infant: "Infante",
    child: "Niño",
    senior: "Senior",
    filter_target: "Filtrar por fecha de",
    filter_target_all: "Reserva o Servicio",
    filter_target_reservation: "Inicio de Reserva",
    filter_target_booking: "Inicio de Servicio",
    date_filter_mode: "Modo de Fecha",
    single_day: "Día Individual",
    clear_date_filter: "Todas las Fechas",
    status_all: "Todos los Estados",
    role_filter: "Rol",
    all_roles: "Todos los Roles",
    total_reservations: "Reservas",
    collapsed_summary_bookings: "servicios",
    collapsed_summary_pax: "pasajeros",
    google_account_connected: "Cuenta de Google conectada exitosamente",
    google_account_connection_failed: "Error al conectar la cuenta de Google",
    google_account_disconnected: "Cuenta de Google desconectada",
    email_thread_linked_successfully: "Correo vinculado a la reserva exitosamente",
    failed_to_link_email_thread: "Error al vincular el correo a la reserva",
    email_thread_unlinked_successfully: "Correo desvinculado de la reserva",
    email_reply_sent_successfully: "Respuesta enviada exitosamente",
    failed_to_send_reply: "Error al enviar la respuesta",
    connecting_google_account: "Conectando con Google...",
    please_wait_while_connecting: "Por favor espera mientras se completa la autenticación.",
    link_email_to_reservation: "Vincular Correo a la Reserva",
    suggested_searches: "Búsquedas sugeridas",
    search_gmail_inbox_placeholder: "Buscar correos en Gmail por asunto, remitente o texto...",
    searching_emails: "Buscando correos...",
    searching: "Buscando",
    no_subject: "(Sin Asunto)",
    no_emails_found_matching_query: "No se encontraron correos para esta búsqueda.",
    enter_search_to_find_emails: "Ingresa un término de búsqueda para encontrar correos en tu bandeja de entrada.",
    email_thread: "Conversación de Correo",
    messages: "mensajes",
    loading_thread: "Cargando mensajes...",
    write_reply_placeholder: "Escribe tu respuesta aquí...",
    send_reply: "Enviar Respuesta",
    reply: "Responder",
    reply_all: "Responder a todos",
    no_messages_in_thread: "No hay mensajes en este hilo de correo.",
    show_quoted_text: "Mostrar texto citado",
    hide_quoted_text: "Ocultar texto citado",
    quoted_text: "Texto citado",
    emails_and_messages: "Correos y Mensajes",
    disconnect_google_account: "Desconectar Cuenta de Google",
    link_email: "Vincular Correo",
    new_email: "Nuevo Correo",
    connect_gmail: "Conectar Gmail",
    connect_gmail_account_title: "Conecta tu cuenta de Gmail",
    connect_gmail_account_description: "Vincula correos, lee hilos completos y responde directamente desde esta reserva sin salir de la app.",
    connect_now: "Conectar Ahora",
    open_and_reply: "Ver y Responder",
    unlink: "Desvincular",
    no_linked_emails_yet: "No hay correos vinculados a esta reserva todavía. Haz clic en 'Vincular Correo' o 'Nuevo Correo' para comenzar.",
    google_auth_success_hint: "Tu cuenta ha sido vinculada exitosamente. Ya puedes cerrar esta ventana para volver a la reserva.",
    google_auth_failed_hint: "Ocurrió un error al autorizar tu cuenta con Google. Por favor cierra esta ventana e intenta nuevamente.",
    invalid_auth_code: "Código de autenticación inválido o expirado.",
    error_loading_thread_messages: "No se pudieron cargar los mensajes de este correo",
    google_session_expired_or_invalid_desc: "La sesión de la cuenta de Google puede haber expirado o estar desvinculada. Por favor vuelve a conectar tu cuenta en la configuración de Gmail.",
    reconnect_google_account: "Reconectar Cuenta de Google",
    recipient_email_required: "No se encontró un destinatario válido para enviar la respuesta.",
    cannot_reply_thread_error: "No es posible responder debido a un error al cargar la conversación.",
    close_window: "Cerrar ventana",
    gmail_link: "Vinculación de Gmail",
    gmail_link_desc: "Conecta una o varias cuentas de Gmail para tu organización para vincular correos con reservas y responder mensajes.",
    connected_gmail_accounts: "Cuentas de Gmail Conectadas",
    gmail_accounts_section_desc: "Cuentas de Gmail autorizadas para vincular e interactuar con correos de clientes y proveedores.",
    no_gmail_accounts_connected: "No hay cuentas de Gmail conectadas",
    connect_gmail_account: "Conectar Cuenta de Gmail",
    connect_gmail_account_help: "Al conectar una cuenta de Gmail, tu equipo podrá vincular correos y responder directamente desde las reservas.",
    connect_another_gmail_account: "Conectar otra cuenta de Gmail",
    status_expired: "Expirado",
    status_insufficient_permissions: "Permisos insuficientes",
    google_insufficient_scopes: "Permisos de Gmail insuficientes. Conecta la cuenta nuevamente autorizando el acceso a Gmail.",
    reconnect: "Reconectar",
    disconnect_gmail_account_confirm: "¿Estás seguro de que deseas desconectar la cuenta {{email}}? Los correos ya vinculados no se eliminarán.",
    linked_emails: "Correos vinculados",
    linked_emails_count: "{{count}} correo vinculado",
    linked_emails_count_plural: "{{count}} correos vinculados",
    open_in_gmail: "Abrir en Gmail",
    recipient_to: "Para",
    name_optional: "Nombre (Opcional)",
    all_clients: "Todos los clientes",
    client_business: "Empresa cliente",
    business_specific_price: "Precio específico para empresa",
    this_price_applies_to_all_clients: "Este precio aplica para todos los clientes",
    price_applies_to_business: "Precio exclusivo para {{name}}",
    business_contract_price: "Precio acordado para empresa",
    upcoming: "Próximo",
    no_prices_configured: "No hay precios configurados para este servicio todavía.",
    no_prices_description: "Agrega tarifas por temporada o por proveedor para gestionar los precios del servicio.",
    no_costs_configured: "No hay costos configurados para este servicio todavía.",
    no_costs_description: "Agrega costos de compra de proveedores para calcular márgenes y balances con proveedores.",
    no_rates_defined: "Sin tarifas definidas",
    registered_payments: "Pagos registrados",
    without_scheduled_date: "Sin fecha programada",
    not_available_3rd_party: "No Disponible para Reserva Online / Terceros",
    payment_due_date: "Vencimiento de Pago",
    total_applied: "Total Aplicado",
    all: "Todos",
    this_week: "Esta semana",
    comments: "Comentarios",
    no_tickets: "No hay tickets",
    chat_title: "Chat",
    chat_suggested: "Sugerencias",
    chat_new_chat: "Nueva conversación",
    chat_welcome_title: "¿Cómo puedo ayudarte hoy?",
    chat_welcome_subtitle: "Pregunta sobre tours, excursiones, actividades y precios.",
    chat_input_placeholder: "Escribe un mensaje...",
    chat_send: "Enviar",
    chat_services_title: "Servicios",
    chat_services_empty: "Aún no se mencionaron servicios.",
    chat_view_service: "Ver",
    chat_typing: "Buscando...",
    chat_hide_services: "Ocultar servicios",
    chat_show_services: "Servicios",
    chat_rate_on_request: "Precio a consultar",
    chat_cart_title: "Servicios Guardados",
    chat_pin_service: "Guardar",
    chat_pinned_service: "Guardado",
    chat_add_to_cart: "+ Guardar",
    chat_in_cart: "Guardado",
    chat_remove_from_cart: "Quitar",
    chat_clear_cart: "Vaciar",
    chat_checkout: "Reservar",
    chat_cart_total: "Total estimado",
    chat_cart_empty: "No hay servicios guardados. Puedes fijar o guardar servicios desde el chat para armar tu viaje.",
    chat_ask_about_pinned: "Consultar por estos servicios",
    chat_ask_about_pinned_prompt: "Quisiera consultar y comparar estos servicios que guardé en mi presupuesto: {names}",
    copy_budget: "Copiar Presupuesto",
    chat_history_title: "Historial de conversaciones",
    chat_history_subtitle: "Reanuda o consulta conversaciones anteriores con el asistente.",
    chat_history_empty: "No tienes conversaciones anteriores guardadas.",
    chat_history_empty_hint: "Cuando inicies una conversación, se guardará aquí para que puedas continuarla en cualquier momento.",
    chat_history_open: "Continuar conversación",
    chat_history_messages: "mensajes",
    chat_history_new_chat: "Iniciar nueva conversación",
    chat_history_delete: "Eliminar",
    chat_history_active: "Activo",
    tax_percentage: "Porcentaje de IVA",
    tax_percentage_desc: "Alícuota de IVA para la generación de comprobantes fiscales de este servicio",
    pos_desc: "Punto de Venta asignado a este servicio para facturación",
    tax_invoicing_settings: "Facturación y Comprobantes Fiscales",
    generate_tax_receipts: "Generar Comprobantes AFIP",
    generate_tax_receipts_desc: "Agrupación automática por Punto de Venta (POS) y porcentaje de IVA de los servicios de la reserva",
    grouped_receipts_to_generate: "Comprobantes agrupados a generar",
    no_billable_services: "No hay servicios con monto a cobrar mayor a 0 en esta reserva.",
    generate_all_receipts: "Generar todos los comprobantes",
    generate_receipt: "Generar comprobante",
    receipt_generated: "Comprobante generado",
    afip_not_configured_alert: "AFIP no está configurado en la cuenta. Por favor cargue los certificados y datos fiscales en la configuración.",
    download_pdf: "Descargar PDF",
    select_tax_percentage: "Seleccione porcentaje de IVA",
    group_summary: "Resumen del grupo",
    update_reservation_tax_id: "Guardar números de comprobante en la reserva",
    receipts_generated_successfully: "Comprobantes generados exitosamente",
    send_by_email: 'Enviar por Mail',
    send_voucher_by_email: 'Enviar Comprobante por Mail',
    destination_email: 'Email de Destino',
    voucher_email_sent_successfully: 'Comprobante enviado exitosamente por email',
    failed_to_send_voucher_email: 'Error al enviar el comprobante por email',
    failed_to_download_pdf: 'Error al descargar el PDF',
    taxed_amount: 'Importe Facturado',
    total_vouchers: 'Comprobantes',
    search_afip_vouchers: 'Buscar por cliente, documento, número, reserva o CAE...',
    tax_settings_bulk_desc: 'Actualización masiva de Punto de Venta (POS) y Porcentaje de IVA para los servicios seleccionados.',
    modify_pos: 'Modificar Punto de Venta (POS)',
    modify_tax_percentage: 'Modificar Porcentaje de IVA',
    filter_by_client: 'Filtrar por cliente',
    filter_by_currency: 'Filtrar por moneda',
    total_invoiced: 'Total Facturado',
    date_type: 'Tipo de Fecha',
    registration_date: 'Fecha de Registro',
    registered: 'Registrado',
    no_payment_date: 'Sin fecha de pago',
    total_sold: 'Total Vendido',
    difference: 'Diferencia',
    sold_vs_invoiced: 'Vendido vs Facturado',
    business_emails: 'Emails de la empresa',
    pax_groups: 'Grupos de Pasajeros',
    pax_group: 'Grupo de Pasajeros',
    not_assigned_to_services: 'Sin asignar a ningún servicio',
    add_pax_group: 'Agregar Grupo',
    edit_pax_group: 'Editar Grupo',
    edit_pax: 'Editar Pasajero',
    single_pax: 'Pasajero Individual',
    pax_group_mode: 'Grupo / Contingente',
    passenger_name: 'Nombre del Pasajero',
    passenger_name_placeholder: 'ej. Juan Pérez',
    or_select_existing_person: 'O seleccionar pasajero existente',
    select_existing: 'Buscar existente',
    delete_pax_group: 'Eliminar Grupo',
    delete_pax_group_confirm: '¿Estás seguro de que deseas eliminar este grupo de pasajeros?',
    pax_group_name: 'Nombre del Grupo',
    pax_group_name_placeholder: 'ej. Grupo Cielo Azul, Escuela Normal...',
    coordinator_business: 'Coordinador / Responsable',
    contact_name: 'Nombre de Contacto',
    contact_phone: 'Teléfono de Contacto',
    contact_phone_placeholder: 'ej. +54 9 11 1234-5678',
    pax_group_added_to_all_bookings: 'Grupo vinculado a todos los servicios',
    pax_group_removed_from_all_bookings: 'Grupo desvinculado de todos los servicios',
    pax_group_created_successfully: 'Grupo creado exitosamente',
    pax_group_updated_successfully: 'Grupo actualizado exitosamente',
    pax_group_deleted_successfully: 'Grupo eliminado exitosamente',
    pax_group_create_failed: 'Error al crear el grupo',
    pax_group_update_failed: 'Error al actualizar el grupo',
    pax_group_delete_failed: 'Error al eliminar el grupo',
    no_pax_groups: 'No hay grupos de pasajeros creados',
    no_pax_groups_desc: 'Crea grupos o contingentes para organizar los pasajeros de la reserva.',
    assign_pax_group: 'Vincular Grupo',
    assign_to_service: 'Vincular a este servicio',
    remove_from_service: 'Desvincular del servicio',
    allocated_to_order: 'Asignado a la orden',
    pax_group_members: 'Integrantes del Grupo',
    pax_group_allocation_per_order: 'Asignación de Grupos por Vehículo',
    total_group_paxs: 'Total del grupo',
    allocated_in_other_orders: 'Asignados en otras órdenes',
    remaining_to_allocate: 'Pendiente de asignar',
    booking_allocation_updated: 'Asignación actualizada correctamente',
    booking_allocation_update_failed: 'Error al actualizar la asignación',
    booking_removed_from_order_successfully: 'Servicio removido de la orden exitosamente',
    booking_removed_from_order_failed: 'Error al remover el servicio de la orden',
    manage_pax_groups: 'Gestionar Grupos',
    pax_group_empty_warning: 'El grupo no tiene pasajeros definidos',
    search_coordinator: 'Buscar coordinador...',
    no_coordinator_selected: 'Sin coordinador asignado',
    all_paxs_in_groups: 'Pasajeros en grupos',
    paxs_count_summary: '{{count}} PAX',
    paxs_in_orders_allocated: '{{allocated}} de {{total}} asignados',
    override_group_for_booking: 'Personalizar conteo para este servicio',
    reset_to_default_count: 'Restablecer a valores del grupo',
    no_passengers_allocated: 'Sin pasajeros asignados',
    no_passengers_associated: 'No hay pasajeros asociados',
    add_paxs: 'Agregar Pasajeros',
    edit_paxs: 'Editar Pasajeros',
    add_passenger: 'Agregar Pasajero',
    type_name_press_enter: 'Escribe el nombre y presiona Enter...',
    group_name_desc: 'Nombre del grupo (por defecto toma el 1er pasajero)',
    group_passengers: 'Pasajeros del Grupo',
    pax_numbers_breakdown: 'Desglose de Pasajeros',
    assign_to_bookings: "Asignar a Bookings",
    services_linked_count: '{{linked}} de {{total}} servicios vinculados',
    confirm_modify_booking_with_service_order: 'Este servicio ya está asignado a una orden de servicio. ¿Deseas continuar y actualizar también la orden de servicio?',
    phone_2: 'Teléfono 2',
    add_second_phone: 'Agregar segundo teléfono',
    chat_on_whatsapp: 'Chatear por WhatsApp',
    assign_all_group: 'Asignar todo el grupo',
    unassign_group: 'Deasignar grupo',
    fully_assigned: 'Asignado completo',
    partially_assigned: 'Parcialmente asignado',
    not_assigned_to_vehicle: 'Sin asignar a este vehículo',
    assigned_pax_groups_to_order: 'Asignación de Grupos al Vehículo',
    edit_group_allocation_desc: 'Indica cuántos pasajeros de cada grupo viajan en esta orden de servicio.',
    legacy_allocation_desc: 'Ajusta la cantidad de pasajeros asignados a este vehículo.',
    assign_all_groups: 'Asignar todos los grupos',
    unassign_all_groups: 'Quitar todos del vehículo',
    search_group_placeholder: 'Buscar grupo o pasajero...',
    allocated: 'Asignados',
    allocations: 'Asignaciones',
    pax_group_mode_headcount: 'Por Cantidad / Tamaño',
    pax_group_mode_persons: 'Lista de Pasajeros',
    pax_group_headcount_desc: 'Define el grupo indicando la cantidad de personas por categoría. No es necesario registrar nombres individuales.',
    pax_group_persons_desc: 'Agrega los integrantes de este grupo. Puedes buscar existentes o escribir un nombre para agregarlo rápidamente.',
    pax_group_name_hint: 'Identifica este grupo en la reserva (ej. familia, amigos, contingente). Se puede autocompletar con el primer pasajero.',
    add_passenger_to_group: 'Agregar al grupo',
    passenger_name_input_placeholder: 'Nombre y apellido...',
    document_optional: 'Documento',
    phone_optional: 'Teléfono',
    no_passengers_in_group_yet: 'Aún no has agregado pasajeros a este grupo',
    type_name_to_add_passenger: 'Escribe un nombre arriba y presiona Enter para comenzar a formar el grupo.',
    select_and_add: 'Seleccionar',
    create_and_add: 'Crear y agregar',
    reservation_persons_suggestions: 'Sugerencias de esta reserva',
    group_leader: 'Titular',
    adjust_headcount_manually: 'Ajustar cantidades manualmente',
    hide_headcount_adjustment: 'Ocultar ajuste manual',
    total_headcount: 'Total Pasajeros',
    named_passengers_count: '{{count}} pasajeros nominales',
    save_group: 'Guardar Grupo',
    press_enter_to_add: 'Presiona Enter para agregar',
    or_add_as_new: 'o agregar como nuevo',
    lead_passenger: 'Titular del grupo',
    pax_category: 'Categoría',
    adult: 'Adulto',
    search_allocations_placeholder: 'Buscar por reserva, servicio, grupo o pasajero...',
    save_booking_allocation: 'Guardar asignación',
    save_all_changes: 'Guardar todos los cambios',
    general_pax: 'General',
    select_pax_group: 'Seleccionar Grupo de Pasajeros',
    all_reservation_paxs: 'Todos los pasajeros de la reserva',
    customize_group_size: 'Personalizar cantidades manualmente',
    price_generator: 'Generador de Precios',
    price_generator_desc: 'Calcule y genere precios de venta y costos de proveedores a partir de un precio semilla, alícuota de impuesto y diferenciales.',
    seed_price: 'Precio Semilla',
    seed_price_desc: 'Monto base de referencia para multiplicar por la alícuota impositiva y diferenciales.',
    tax_modifier: 'Modificador de Impuesto',
    tax_modifier_desc: 'Multiplicador derivado del IVA (ej. 21% = 1.2100000000) almacenado con alta precisión.',
    diff_category_multipliers: 'Diferenciales por Categoría',
    differential: 'Diferencial',
    diff_default: 'General',
    diff_foreigner: 'Extranjero',
    diff_child: 'Menor',
    diff_senior: 'Senior',
    diff_retired: 'Jubilado',
    diff_infant: 'Infante',
    diff_provider: 'Proveedor',
    rounding_settings: 'Configuración de Redondeo',
    round_to: 'Redondear a',
    round_method: 'Criterio de Redondeo',
    round_nearest: 'Al más cercano (Round)',
    round_ceil: 'Hacia arriba (Ceil)',
    round_floor: 'Hacia abajo (Floor)',
    cost_multiplier: 'Multiplicador de Costo',
    cost_multiplier_desc: 'Factor multiplicador aplicado al precio semilla para determinar el costo del proveedor.',
    generate_and_apply_prices: 'Generar y Aplicar Precios',
    generate_and_apply_desc: 'Crea registros activos en las tablas de precios de venta y costos de proveedor para este servicio.',
    save_generator_config: 'Guardar Configuración',
    generator_config_saved: 'Configuración del generador guardada exitosamente',
    apply_to_prices: 'Aplicar a Precios',
    apply_to_costs: 'Aplicar a Costos',
    prices_applied_successfully: 'Precios generados y aplicados exitosamente',
    costs_applied_successfully: 'Costos generados y aplicados exitosamente',
    preview_sell_prices: 'Precios de Venta Calculados',
    preview_provider_costs: 'Costos de Proveedor Calculados',
    no_providers_for_costs: 'Este servicio no tiene proveedores asociados actualmente. Los costos calculados se aplicarán como costo general (todos los proveedores).',
    precision_note: 'Modificadores almacenados con 10 dígitos de precisión decimal (ej. 1.2100000000).',
    raw_calculation: 'Cálculo sin redondear',
    rounded_calculation: 'Resultado final',
    confirm_generate_prices_title: '¿Aplicar precios y costos generados?',
    confirm_generate_prices_desc: 'Esto creará un nuevo registro de precio de venta y registros de costos para los proveedores con vigencia a partir de la fecha seleccionada.',
    update_provider_cost_multiplier: 'Actualizar multiplicador en la empresa proveedora',
    start_day: 'Fecha Inicio',
    end_day: 'Fecha Fin',
    seed_prices_history: 'Historial de Precios Semilla',
    no_seed_prices: 'No hay precios semilla registrados',
    use_this_seed_price: 'Usar',
    dates_used: 'Fechas utilizadas',
    pax_discrepancy: 'Diferencia de Pasajeros',
    pax_discrepancy_count_mismatch: 'La cantidad de pasajeros asignados ({{assigned}}) no coincide con el total de la reserva ({{booking}}).',
    pax_discrepancy_category_mismatch: 'La composición por categoría de pasajeros no coincide con la reserva.',
    pax_discrepancy_assigned: 'Asignados',
    pax_discrepancy_booking: 'Reserva',
    prices_and_costs: 'Precios y Costos',
    margins: 'Márgenes',
    prices_and_costs_description: 'Compara precios de venta y costos de proveedores por períodos idénticos para analizar márgenes y diferencias.',
    markup: 'Margen s/ costo',
    net_margin: 'Margen Bruto',
    loss: 'Pérdida',
    unit_profit: 'Ganancia por Unidad',
    no_cost_for_period: 'Sin costo configurado para este período',
    no_price_for_period: 'Sin precio configurado para este período',
    no_periods_found: 'No se encontraron períodos de precios o costos',
    current_active_period: 'Período Activo Actual',
    average_margin: 'Margen Promedio',
    total_periods: 'Períodos Totales',
    cost_exceeds_price: '¡Atención: El costo supera el precio de venta!',
    table_view: 'Tabla',
    cards_view: 'Tarjetas',
    all_tiers: 'Todas las categorías de pasajeros',
    passenger_tiers_breakdown: 'Desglose por categorías de pasajeros',
    different_currencies_warning: 'El precio y el costo usan monedas distintas. La diferencia no puede calcularse directamente.',
    cost_status_missing: 'Costo Faltante',
    price_status_missing: 'Precio Faltante',
    price_and_cost_comparison: 'Comparación de Precios y Costos',
    highest_margin: 'Margen Máximo',
    lowest_margin: 'Margen Mínimo',
    sort_by_margin: 'Margen',
    sort_by_diff: 'Diferencia',
    days_duration: '{{count}} días',
    days_duration_single: '1 día',
    pax_list: "Lista de Pasajeros",
    add_all: "Agregar todos",
    transport: "Transporte",
    transport_plural: "Transportes",
    search_by_phone: "Buscar por Telefono",
    search_by_document_number: "Buscar por Documento",
    search_by_email: "Buscar por Email",
    search_or_add_new_passenger: "Buscar o Crear Pax",
    booking_size: "Tamaño en el Booking",
    sync_booking_size_from_groups: "Actualizar tamaño del booking según grupos",
    sync_group_size_from_persons: "Calcular según pasajeros seleccionados",
    reset_to_group_defaults: "Restablecer valores originales del grupo",
    customized_for_booking: "Personalizado",
    select_passengers_for_booking: "Pasajeros en este servicio",
    sell_price: "Precio de Venta",
    calculate_costs_from: "Calcular a partir de",
    pax_profile_title: "Perfil como Pasajero",
    business_as_pax_explanation: "Un Cliente/Proveedor también puede tener un perfil de Persona para asignarlo como pasajero en reservas.",
    business_profile_title: "Perfil como Cliente / Proveedor",
    person_as_business_explanation: "Una Persona también puede tener un perfil de Cliente/Proveedor para ser titular de reservas, gestionar pagos o proveer servicios.",
    link_pax: "Vincular Persona",
    link_or_create_business: "Vincular o Crear Cliente/Proveedor",
    change_linked_pax: "Cambiar",
    confirm_unlink_pax: "¿Desvincular el pasajero asociado a este cliente/proveedor?",
    confirm_unlink_business: "¿Desvincular el cliente/proveedor asociado a esta persona?",
    view_pax_profile: "Ver perfil de pasajero",
    view_business_profile: "Ver perfil de cliente/proveedor",
    delete_price: "Eliminar Precio",
    delete_cost: "Eliminar Costo",
    expand_all_costs: "Expandir todos los costos",
    collapse_all_costs: "Contraer todos los costos",
    show_costs: "Mostrar costos",
    hide_costs: "Ocultar costos",
    select_sell_price: "Seleccionar precio de venta",
    create_sell_price_first: "Debes crear al menos un precio de venta antes de agregar un costo.",
    person_notes: "Empresa / Observaciones",
    show_pax_list: "Lista de Pasajeros",
    only_first_pax: "Solo 1er Pasajero",
    retentions: "Retenciones",
    add_retention: "Agregar Retención",
    retention_type: "Tipo de Retención",
    retention_types: {
        ganancias: "Impuesto a las Ganancias",
        iibb: "Ingresos Brutos (IIBB)",
        iva: "IVA",
        suss: "SUSS / Seguridad Social",
        other: "Otra Retención"
    },
    retention_jurisdiction: "Jurisdicción / Provincia",
    retention_jurisdiction_placeholder: "ej. CABA, Buenos Aires, Salta...",
    retention_certificate_number: "Nº de Certificado",
    retention_certificate_placeholder: "ej. 0001-00012345",
    retained_amount: "Total Retenido",
    net_cash_amount: "Neto Transferido / Efectivo",
    total_settled_amount: "Total Cancelado (con retenciones)",
    no_retentions: "Sin retenciones registradas",
    upload_certificate: "Subir Certificado",
    provider_tax_vouchers: "Comprobantes del Proveedor",
    add_provider_voucher: "Cargar Comprobante de Proveedor",
    link_existing_voucher: "Vincular Comprobante Existente",
    register_new_voucher: "Registrar Nuevo Comprobante",
    emitted_vouchers: "Emitidos (Ventas)",
    received_vouchers: "Recibidos (Proveedores)",
    issuer_provider: "Proveedor Emisor",
    issuer_cuit: "CUIT del Emisor",
    issue_date: "Fecha de Emisión",
    voucher_number_label: "Número de Comprobante",
    voucher_type_label: "Tipo de Comprobante",
    cae_optional: "CAE (Opcional)",
    cae_expiration_optional: "Vto. CAE (Opcional)",
    link_to_other_bookings_of_provider: "Vincular también a otros servicios de este proveedor",
    no_provider_vouchers: "Sin comprobantes de proveedor vinculados",
    provider_voucher_created: "Comprobante de proveedor registrado exitosamente",
    provider_voucher_linked: "Comprobante vinculado exitosamente",
    provider_voucher_unlinked: "Comprobante desvinculado",
    select_existing_voucher: "Seleccionar comprobante recibido",
    no_received_vouchers_for_provider: "No hay otros comprobantes registrados para este proveedor",
    upload_voucher_file: "Adjuntar PDF / Imagen del Comprobante",
    retention_percentage: "Alícuota (%)",
    retention_preset: "Régimen / Alícuota sugerida",
    select_service_bookings_for_voucher: "Servicios vinculados en la reserva",
    select_at_least_one_booking: "Seleccioná al menos un servicio"
};


